{
    "common": {
        "added": {
            "label": {},
            "msg": {},
            "code": {}
        },
        "label": {
            "Webhooks": "Webhook",
            "Delivery history": "传送历史",
            "Request ID": "请求 ID",
            "Status code": "状态码",
            "Response time": "响应时间",
            "Result": "结果",
            "Select result": "选择结果",
            "Success": "成功",
            "webhook": "Webhook",
            "Create Webhook": "创建 Webhook",
            "Search by webhook name": "按 Webhook 名称搜索",
            "Show value": "显示值",
            "Connection settings": "连接设置",
            "Triggers": "触发器",
            "Webhook": "Webhook",
            "Endpoint URL": "端点 URL",
            "Headers": "请求头",
            "Hide value": "隐藏值",
            "Remove header": "删除请求头",
            "Transport format": "发送格式",
            "HTTP Method": "HTTP 方法",
            "Recent deliveries": "最近发送历史",
            "Request body example": "请求正文示例",
            "Response": "响应",
            "When an asset is created": "创建资产时",
            "When an asset is updated": "更新资产时",
            "When an asset is published": "发布资产公开 URL 时",
            "When an asset is deleted": "删除资产时",
            "When an asset is unpublished": "取消发布资产公开 URL 时",
            "Asset created": "资产创建",
            "Asset updated": "资产更新",
            "Asset published": "资产公开 URL 发布",
            "Asset deleted": "资产删除",
            "Asset unpublished": "资产公开 URL 取消发布",
            "Views": "查看",
            "Updating": "更新中",
            "By URL": "按 URL",
            "Usage trend": "使用趋势",
            "Top {{count}} URLs": "URL 前 {{count}}",
            "Top {{count}} referring domains": "来源域名 前 {{count}}",
            "Top {{count}} countries": "国家/地区 前 {{count}}",
            "{{total}} total": "共 {{total}}",
            "Published target": "发布对象",
            "Last viewed": "最后查看",
            "{{count}} published": "发布中 <0>{{count}}</0>",
            "As of {{hours}} hour(s) ago": "截至 {{hours}} 小时前",
            "As of {{days}} day(s) ago": "截至 {{days}} 天前",
            "As of less than an hour ago": "截至 1 小时内",
            "Public URL statistics": "公开 URL 统计",
            "Usage of {{count}} public URL(s)": "{{count}} 个公开 URL 的使用情况",
            "Public URL statistics details": "公开 URL 统计详情",
            "{{active}} published, {{released}} unpublished": "发布中 <0>{{active}}</0> · 已取消 <1>{{released}}</1>",
            "({{active}} published, {{released}} unpublished)": "(发布中 {{active}} · 已取消 {{released}})",
            "left axis": "(左轴)",
            "right axis": "(右轴)",
            "Estimated visitors": "估算访客",
            "Data transferred": "传输量",
            "Referring domains": "来源域名",
            "Countries": "国家/地区",
            "Last {{days}} days": "最近 {{days}} 天",
            "Gen AI": "Gen AI",
            "Dimension": "尺寸",
            "{{from}}-{{to}} of {{count}}": "{{from}}-{{to}}，共 {{count}}",
            " - Total {{totalSize}}": " - 合计 {{totalSize}}",
            "Add Vocabulary?": "要添加词条吗？",
            "Add to all": "添加到全部",
            "All items cannot be deleted.": "无法删除全部项目。",
            "Archiving...": "归档中...",
            "Asset to be analyzed": "待分析的资产",
            "Bucket name must be between 3 and 63 letters and start with alphabet or number with allowed special characters of -, _, and .)": "存储桶名称必须为 3~63 个字符，以字母或数字开头，且仅允许 -、_ 和 . 特殊字符。",
            "Choose on Organizer": "选择主办方",
            "Close my jobs": "关闭我的作业",
            "Close tab menu": "关闭标签菜单",
            "Collapse panel": "收起面板",
            "Copy to {{name}}": "复制到 {{name}}",
            "Customer": "客户",
            "Default value": "默认值",
            "Destination": "目标位置",
            "Domain URL": "域名 URL",
            "Drive": "驱动器",
            "Duplicate the item?": "要复制该项目吗？",
            "Empty Recoding History": "无录制记录",
            "Enter Vocabulary name": "请输入词条名称",
            "Enter after entering": "输入后请按 Enter 键",
            "Enter field description": "请输入字段说明",
            "Enter prefix": "请输入前缀",
            "Entering Console…": "正在进入控制台…",
            "Error renaming from {{item1}} to {{item2}}.": "将 {{item1}} 重命名为 {{item2}} 时发生错误。",
            "Event Triggers": "事件触发器",
            "Expand panel": "展开面板",
            "Failed": "失败",
            "Find objects by prefix": "按前缀查找对象",
            "Go to Search Results": "前往搜索结果",
            "Grouping": "分组",
            "Height": "高度",
            "Id": "ID",
            "If you need permission, please contact your account manager.": "如需权限，请联系您的客户经理。",
            "In use": "使用中",
            "Ingested": "已采集",
            "Ingesting": "采集中",
            "Min": "最小",
            "Moving...": "移动中...",
            "No requests list": "无请求列表",
            "Offline": "离线",
            "Open tab menu": "打开标签菜单",
            "Other": "其他",
            "Permission to access is required.": "需要访问权限。",
            "Please create an organizer.": "请创建主办方。",
            "Prefix cannot be empty": "前缀不能为空",
            "Prefix must begin with s3://": "前缀必须以 s3:// 开头",
            "Preview Image": "预览图片",
            "Progressing": "进行中",
            "Project name cannot be empty": "项目名称不能为空",
            "Re-Approval requested": "已申请重新审批",
            "Search Projects": "搜索项目",
            "Search by execution ID": "按执行 ID 搜索",
            "Select Language": "选择语言",
            "Select Service Type": "选择服务类型",
            "Select Storage": "选择存储",
            "Share to \"{{name}}\"": "共享到“{{name}}”",
            "Smiling": "微笑",
            "Space ID": "空间 ID",
            "CDN ID": "CDN ID",
            "System management": "系统管理",
            "There is no resource in video.": "视频中没有资源。",
            "There was an error creating the new folder {{item}}.": "创建新文件夹 {{item}} 时发生错误。",
            "Total for all projects": "全部项目合计",
            "Use all": "全部使用",
            "View Files": "查看文件",
            "View History": "查看历史",
            "Vocabularies": "词条",
            "Vocabulary Book Search Results": "词汇表搜索结果",
            "Width": "宽度",
            "You do not have permission.": "您没有权限。",
            "Zoom In": "放大",
            "Zoom Out": "缩小",
            "and": "及",
            "canceled": "已取消",
            "complete": "完成",
            "error": "错误",
            "group": "群组",
            "loading...": "加载中...",
            "preview": "预览",
            "remove": "删除",
            "requested": "已申请",
            "user": "用户",
            "weekly": "每周",
            "{{name}} Search Results": "{{name}} 搜索结果",
            "READY TO DOWNLOAD": "下载准备完成",
            "STARTING": "启动中",
            "STOPPING": "停止中",
            "SUBMITED": "已提交",
            "UNKNOWN": "未知",
            "AWS": "AWS",
            "Daglo": "Daglo",
            "S3 Glacier Deep Archive": "S3 Glacier Deep Archive",
            "S3 Glacier Flexible Retrieval": "S3 Glacier Flexible Retrieval",
            "Subsy": "Subsy",
            "Image zoom in": "图片放大",
            "Add Option": "添加选项",
            "Labels": "标签",
            "Filter labels": "筛选标签",
            "Go to details": "前往详情",
            "Select Key": "选择键",
            "Current Space": "当前空间",
            "Stage List": "阶段列表",
            "Empty Widget List": "无 Widget",
            "Enlarge Layout": "放大布局",
            "Video Player": "视频播放器",
            "Copying": "复制中",
            "Empty Published History": "无发布历史",
            "Request Details": "请求详情",
            "Results for your Search": "搜索结果",
            "Average Confidence (%) : More than": "平均置信度（%）：不低于",
            "Prev": "上一步",
            "Go Detail": "前往详情",
            "By Last Created": "按创建日期",
            "day": "天",
            "Only Unused Files": "仅未使用的文件",
            "Access Token": "访问令牌",
            "Refresh Token": "刷新令牌",
            "Projects Allowed to Use": "可使用的项目",
            "Go to error item": "前往错误项",
            "Error message": "错误消息",
            "How to resolve": "解决方法",
            "Continue editing": "继续编辑",
            "Acknowledge and save": "确认并保存",
            "Add parallel step": "添加并行步骤",
            "WORKFLOW_QUEUED": "已排队",
            "WORKFLOW_READY": "就绪",
            "WORKFLOW_RUNNING": "运行中",
            "WORKFLOW_COMPLETED": "已完成",
            "WORKFLOW_FAILED": "失败",
            "WORKFLOW_EXPIRED": "已过期",
            "Start Date": "开始日期",
            "End Date": "结束日期",
            "Duration (sec)": "时长（秒）",
            "bucketName": "存储桶名称",
            "prefix": "前缀",
            "fileUrl": "文件 URL",
            "extension": "扩展名",
            "extensions": "扩展名",
            "minByte": "最小字节",
            "maxByte": "最大字节",
            "assetId": "资产 ID",
            "mediaType": "媒体类型",
            "attributions": "归属信息",
            "tags": "标签",
            "categories": "类别",
            "description": "描述",
            "extendedMetadata": "扩展元数据",
            "virtualLocation": "位置",
            "collection": "集合",
            "pipelineId": "流水线 ID",
            "videoId": "视频 ID",
            "promptId": "提示词 ID",
            "storageClass": "存储类别",
            "platform": "平台",
            "isCreateOriginAsset": "将原始来源保存为资产",
            "AI Search Mode": "AI 搜索模式",
            "Default Metadata Template": "默认元数据模板",
            "Custom Header": "自定义标头",
            "Grant Space Admin": "授予空间管理员权限",
            "Grant Project Admin": "授予项目管理员权限",
            "1st": "第1",
            "2nd": "第2",
            "3rd": "第3",
            "4th": "第4",
            "5th": "第5",
            "6th": "第6",
            "- Total {{totalSize}}": "- 共计 {{totalSize}}",
            "{{count}} views": "{{count}} 次浏览",
            "{{name}} files": "{{name}} 个文件",
            "{{name}} ID": "{{name}} ID",
            "{{name}} inquiry": "{{name}} 咨询",
            "{{name}} overview": "{{name}} 概览",
            "New": "新建",
            "24 hours": "24小时",
            "24/7": "24/7",
            "Accept": "接受",
            "Account": "账户",
            "Action": "操作",
            "Actions": "操作",
            "Active": "活跃",
            "ACTIVE": "活跃",
            "ACTIVE / INACTIVE TOGGLE": "启用 / 禁用切换",
            "Add": "添加",
            "Add {{name}}": "添加 {{name}}",
            "Add a category": "添加类别",
            "Add caption": "添加字幕",
            "Add faces": "添加人脸",
            "Add files": "添加文件",
            "Add image": "添加图片",
            "Add images": "添加图片",
            "Add lineup": "添加列表",
            "Add roles": "添加角色",
            "Add teams": "添加团队",
            "Add users": "添加用户",
            "Add posters": "添加海报",
            "Admin": "管理员",
            "Administration": "管理",
            "Advanced search": "高级搜索",
            "ALL": "全部",
            "All event type": "所有事件类型",
            "All ingest type": "所有采集类型",
            "All language": "所有语言",
            "All media type": "所有媒体类型",
            "All media types": "所有媒体类型",
            "All pipeline": "所有流水线",
            "All project": "所有项目",
            "All source": "所有来源",
            "All state": "所有状态",
            "All status": "所有状态",
            "All type": "所有类型",
            "All types": "所有类型",
            "Allowed special characters": "允许使用特殊字符",
            "Alternative name": "别名",
            "Alternative names": "别名",
            "Amount": "数量",
            "Amount : {{amount}}": "数量：{{amount}}",
            "Analyzed": "已分析",
            "Analyzing": "分析中",
            "Anywhere": "任意位置",
            "Appears to be happy": "看起来很开心",
            "Appears to be male": "看起来是男性",
            "Apply": "应用",
            "Approval": "审批",
            "Approval in progress": "审批中",
            "Approval request": "审批请求",
            "Approval requested": "已请求审批",
            "Approval status": "审批状态",
            "Approve": "批准",
            "Approve whitelist": "批准白名单",
            "Approved": "已批准",
            "Approved whitelist": "已批准的白名单",
            "Asset": "资产",
            "Asset ID": "资产 ID",
            "Asset name": "资产名称",
            "Assets": "资产",
            "Assets {{name}}": "资产 {{name}}",
            "Attribution": "归属",
            "Attributions": "归属信息",
            "Audio": "音频",
            "Audio settings": "音频设置",
            "Audit logs": "审计日志",
            "Audit-Logs": "审计日志",
            "Authority": "权限",
            "Auto Start/Stop": "自动启动/停止",
            "Automated Workflow": "自动化工作流",
            "AWS medialive channel": "AWS MediaLive 频道",
            "AWS medialive input": "AWS MediaLive 输入",
            "Base video": "基础视频",
            "Blank time": "空白时间",
            "Cancel": "取消",
            "CANCELED": "已取消",
            "Cannot delete the stream": "无法删除该流",
            "Image": "图片",
            "Caption": "字幕",
            "Caption label": "字幕标签",
            "Captions": "字幕",
            "Categories": "类别",
            "Categories selected": "已选类别",
            "Category": "类别",
            "Category description": "类别描述",
            "Category group": "类别组",
            "Category group description": "类别组描述",
            "Category group name": "类别组名称",
            "Category groups": "类别组",
            "Celebrity recognition": "名人识别",
            "Channel": "频道",
            "Channel description": "频道描述",
            "Channel ID": "频道 ID",
            "Channel Logo": "频道徽标",
            "Channel overview": "频道概览",
            "Channel state of non-scheduled time": "非排程时间的频道状态",
            "Channels": "频道",
            "Chapter": "章节",
            "Choose on schedules": "从排程中选择",
            "Choose on stream": "从流中选择",
            "Choose on streams": "从流中选择",
            "Client ID": "客户端 ID",
            "Client IP": "客户端 IP",
            "Client secret": "客户端密钥",
            "Client useragent": "客户端用户代理",
            "Clone": "克隆",
            "Close": "关闭",
            "Cloud": "云",
            "Cloud inquiry": "云咨询",
            "CloudPlex Media": "CloudPlex Media",
            "CloudPlex Media subtitle editor": "CloudPlex Media 字幕编辑器",
            "CMS": "CMS",
            "Code": "代码",
            "COMPLETE": "已完成",
            "Completed": "已完成",
            "Conditions": "条件",
            "Confidence": "置信度",
            "Configuration": "配置",
            "Constraints": "约束条件",
            "Content moderation": "内容审核",
            "Contents": "内容",
            "Contents duration": "内容时长",
            "Copy": "复制",
            "Copyright": "版权",
            "Correct status": "正确状态",
            "Create": "创建",
            "Create {{name}}": "创建 {{name}}",
            "Create {{name}} asset": "创建 {{name}} 资产",
            "Create MP4 asset": "创建视频资产",
            "Create MP3 asset": "创建音频资产",
            "Create IMAGE asset": "创建图片资产",
            "Create CAPTION asset": "创建字幕资产",
            "Created": "已创建",
            "Creator": "创建者",
            "Execution History": "执行历史",
            "Execution Result": "执行结果",
            "Flow Detail Information": "流程详细信息",
            "Created by": "创建人",
            "Creating": "创建中",
            "CSV Export": "CSV 导出",
            "Cumulative viewers": "累计观看人数",
            "Cumulative views": "累计播放次数",
            "Cumulative viewing time": "累计观看时长",
            "Current time": "当前时间",
            "Current viewers": "当前在线观众",
            "Currently online": "当前在线",
            "Custom fields": "自定义字段",
            "Cycle": "周期",
            "Dailys": "每日",
            "Dashboard": "仪表板",
            "Date": "日期",
            "Date picker": "日期选择器",
            "Date format": "日期格式",
            "Day": "天",
            "Days": "天",
            "Default": "默认",
            "Delete": "删除",
            "Delete all": "全部删除",
            "Deleted": "已删除",
            "Deleted output asset retention": "已删除输出资产保留",
            "Description": "描述",
            "Desktop": "桌面端",
            "Destination A": "目标 A",
            "Destination B": "目标 B",
            "Detach": "分离",
            "Detach {{name}}": "分离 {{name}}",
            "Detail": "详情",
            "Direct": "直接",
            "Direct input": "直接输入",
            "Disable": "禁用",
            "Down": "下移",
            "Download": "下载",
            "Download apps": "下载应用",
            "Download filtered list": "下载已筛选的列表",
            "Download full list": "下载全部列表",
            "DRAFT": "草稿",
            "Draft": "草稿",
            "DUAL": "双路",
            "Dual": "双路",
            "Dubbing": "配音",
            "MultipleAudios": "多音轨",
            "Duration": "时长",
            "Edit": "编辑",
            "Email": "邮箱",
            "Embed code": "嵌入代码",
            "Employee Sign in": "LX Hausys 员工登录",
            "Empty": "空",
            "Empty {{name}}": "清空 {{name}}",
            "Every {{interval}} days": "每 {{interval}} 天",
            "Enable": "启用",
            "Encoding profile": "编码配置",
            "End": "结束",
            "End date": "结束日期",
            "End now": "立即结束",
            "End time": "结束时间",
            "Endpoint": "端点",
            "Endpoints": "端点",
            "Error": "错误",
            "ERROR": "错误",
            "Etc": "其他",
            "Event": "事件",
            "EVENT": "事件",
            "Event triggers": "事件触发器",
            "Event type": "事件类型",
            "EventTrigger": "事件触发器",
            "EventTrigger description": "EventTrigger 描述",
            "EventTrigger name": "EventTrigger 名称",
            "EventTriggers": "事件触发器",
            "Every": "每",
            "Expired": "已过期",
            "Expired at": "过期时间",
            "Expired date": "过期日期",
            "Face": "人脸",
            "Face anlaysis": "人脸分析",
            "Face index": "人脸索引",
            "Face search": "人脸搜索",
            "Facebook": "Facebook",
            "Faces": "人脸",
            "Faces selected": "已选人脸",
            "Field type search": "字段类型搜索",
            "Field {{count}}": "字段 {{count}}",
            "File": "文件",
            "File name": "文件名",
            "File source": "文件来源",
            "Files": "文件",
            "Folder name": "文件夹名称",
            "Folder search": "文件夹搜索",
            "Follow default values": "遵循默认值",
            "Force inheritance": "强制继承",
            "Fri": "周五",
            "Friday": "星期五",
            "General": "常规",
            "Go to schedule": "前往计划",
            "Grand additional roles": "授予附加角色",
            "Grant all permissions": "授予所有权限",
            "Grant project access": "授予项目访问权限",
            "Granted": "已授予",
            "Granted roles": "已授予角色",
            "Hide": "隐藏",
            "High": "高",
            "Highest": "最高",
            "Hub scope": "所有项目",
            "Hyper Browser": "Hyper Browser",
            "ID": "ID",
            "Idle": "空闲",
            "IMAGE": "图片",
            "Image setting": "图片设置",
            "Image sources": "图片来源",
            "Images selected": "已选图片",
            "Inactive": "未激活",
            "Index": "索引",
            "Indexing": "索引中",
            "Indexed": "已索引",
            "Index file": "索引文件",
            "Individual settings": "个人设置",
            "Ingest type": "采集类型",
            "Ingest": "采集",
            "INGEST": "采集",
            "INGESTED": "已采集",
            "INGESTING": "采集中",
            "Inherit": "继承",
            "Input {{index}}": "输入 {{index}}",
            "Input asset auto delete": "输入资产自动删除",
            "Input detail": "输入详情",
            "Input path": "输入路径",
            "Input storage": "输入存储",
            "Input storage path": "输入存储路径",
            "Inputs": "输入",
            "Instagram": "Instagram",
            "Interval": "间隔",
            "IP range": "IP 范围",
            "Job": "作业",
            "Job {{name}}": "作业 {{name}}",
            "Job ID": "作业 ID",
            "Job overview": "作业概览",
            "Jobs": "作业",
            "Key": "键",
            "Kind": "类型",
            "Label": "标签",
            "Label detection": "标签检测",
            "Language": "语言",
            "Last access": "最近访问",
            "Last accessed at": "最近访问时间",
            "Leave": "离开",
            "Leave comment": "留下评论",
            "Linear": "线性",
            "LINEAR": "线性",
            "Lineup": "排片",
            "Lineup copy": "复制排片",
            "Lineup count": "排片数量",
            "Lineup detail": "排片详情",
            "Lineup name": "排片名称",
            "List": "列表",
            "Listing": "列表",
            "Schedules": "计划",
            "SCHEDULES": "计划",
            "Schedules detail": "计划详情",
            "Schedules ID": "计划 ID",
            "Schedules overview": "计划概览",
            "Live": "直播",
            "Live player URL": "直播播放器 URL",
            "Loading...": "加载中...",
            "Local": "本地",
            "Local file": "本地文件",
            "Logo": "Logo",
            "Looks like a face": "看起来像人脸",
            "Loop": "循环",
            "Loop to fill lineup duration": "循环填充排片时长",
            "Low": "低",
            "Lowest": "最低",
            "Main": "主",
            "Mark in": "入点",
            "Mark in~out": "入点~出点",
            "Mark out": "出点",
            "Max": "最大",
            "Maximum object size": "最大对象大小",
            "Maximum schedule amount": "最大计划数量",
            "Media": "媒体",
            "Media service": "媒体服务",
            "Media service inquiry": "媒体服务咨询",
            "Media type": "媒体类型",
            "Medium": "中",
            "Megazone ID": "Megazone ID",
            "Members": "成员",
            "Metadata": "元数据",
            "Metadata description": "元数据描述",
            "Metadata name": "元数据名称",
            "Metadata schema description": "元数据架构描述",
            "Mon": "周一",
            "Monday": "星期一",
            "Month": "月",
            "Months": "月份",
            "More than 50%": "超过 50%",
            "MP4": "MP4",
            "Multi Audio": "多音轨",
            "My jobs": "我的作业",
            "Name": "名称",
            "Name / ID": "名称 / ID",
            "Name constraints": "名称限制",
            "Never": "从不",
            "No": "否",
            "No options": "无选项",
            "No {{name}}": "无 {{name}}",
            "No asset contents": "无资产内容",
            "No asset searched.": "未找到资产。",
            "No category searched": "未找到类别",
            "None": "无",
            "Not copy to": "不复制到",
            "Not deleted": "未删除",
            "Not found": "未找到",
            "NOT_READY": "NOT_READY",
            "Now": "现在",
            "Number": "数字",
            "Off": "关",
            "On": "开",
            "OR": "或",
            "Origin": "源",
            "Origins": "源",
            "Output": "输出",
            "Outputs": "输出",
            "Output {{index}}": "输出 {{index}}",
            "Output path": "输出路径",
            "Output preview": "输出预览",
            "Output storage": "输出存储",
            "Output storage path": "输出存储路径",
            "Overview": "概览",
            "Owner": "所有者",
            "Path": "路径",
            "Parent device": "父设备",
            "Parent region": "父区域",
            "Payload": "载荷",
            "Pending ingesting": "等待采集",
            "Pending transcoding": "等待转码",
            "People": "人员",
            "People description": "人员描述",
            "Period": "周期",
            "Period setting": "周期设置",
            "Permissions": "权限",
            "Pipeline": "流水线",
            "Pipeline {{name}}": "流水线 {{name}}",
            "Player": "播放器",
            "Please create a schedules.": "请创建计划。",
            "Please create a stream.": "请创建流。",
            "Poster": "海报",
            "Posters": "海报",
            "Prefix": "前缀",
            "Preview": "预览",
            "Preview button": "预览按钮",
            "Preview in browser URL": "在浏览器中预览 URL",
            "Priority": "优先级",
            "Privacy policy": "隐私政策",
            "Private": "私有",
            "Profile": "配置文件",
            "Profile {{name}}": "配置文件 {{name}}",
            "Program": "节目",
            "Program duration": "节目时长",
            "Programes count": "节目数量",
            "Programs": "节目",
            "PENDING": "进行中",
            "PROGRESSING": "进行中",
            "Project": "项目",
            "Project description": "项目描述",
            "Project ID": "项目 ID",
            "Project in use": "使用中的项目",
            "Project manager": "项目管理员",
            "Project name": "项目名称",
            "Project Name / ID": "项目名称 / ID",
            "Project overview": "项目概览",
            "Project settings": "项目设置",
            "Projects": "项目",
            "Projects in use": "使用中的项目",
            "Provider": "提供商",
            "Provider / Service": "提供商 / 服务",
            "Public": "公开",
            "Publish": "发布",
            "QR": "QR",
            "Quick search": "快速搜索",
            "Range": "范围",
            "READY": "就绪",
            "Reanalysis": "重新分析",
            "Retry AI search indexing": "重试 AI 搜索索引",
            "Retry indexing": "重试索引",
            "Reason": "原因",
            "Reason for approval requested": "申请审批原因",
            "Reason for reclaimed": "回收原因",
            "Reason for rejected": "拒绝原因",
            "Reason for request": "请求原因",
            "Reason for response": "响应原因",
            "Reason for return requested": "申请退回原因",
            "Reclaim": "回收",
            "Reclaim in progress": "回收中",
            "Reclaimed": "已回收",
            "Recorded": "已录制",
            "Redirect URL": "重定向 URL",
            "Redundancy level": "冗余级别",
            "Reference": "参考",
            "Refresh": "刷新",
            "Refresh token": "刷新令牌",
            "Reject": "拒绝",
            "Rejected": "已拒绝",
            "Related {{pascalK}}": "相关 {{pascalK}}",
            "Remaining time": "剩余时间",
            "Remote": "远程",
            "Remote file": "远程文件",
            "Remove": "删除",
            "Rendition": "版本",
            "Renditions": "版本",
            "Repeat": "重复",
            "Request": "请求",
            "Request approval": "申请审批",
            "Request body": "请求正文",
            "Request cancel": "取消请求",
            "Request return": "申请退回",
            "Reset": "重置",
            "Resolution": "分辨率",
            "Resource": "资源",
            "Response body": "响应体",
            "Restore to default": "恢复默认",
            "Retry": "重试",
            "Return": "返回",
            "Return cancel": "取消返回",
            "Return in progress": "返回中",
            "Return request": "返回请求",
            "Return requested": "已请求返回",
            "Returned": "已返回",
            "Role description": "角色描述",
            "Role name": "角色名称",
            "Role overview": "角色概览",
            "Role": "角色",
            "Roles": "角色",
            "rules": "规则",
            "Running": "运行中",
            "S3://~": "S3://~",
            "Sat": "周六",
            "Saturday": "星期六",
            "Save": "保存",
            "Save origin asset": "保存原始资产",
            "Schedule": "计划",
            "Schedule {{index}}": "计划 {{index}}",
            "Schedule repeat": "重复计划",
            "Scheduled lineups": "已计划节目",
            "Scheduled time": "计划时间",
            "Scope": "范围",
            "Search": "搜索",
            "Search assets name": "搜索资产名称",
            "Search by workflow name": "按工作流名称搜索",
            "Search program name": "搜索节目名称",
            "Search team name": "搜索团队名称",
            "Search videos name": "搜索视频名称",
            "Security": "安全",
            "Select": "选择",
            "Select {{name}}": "选择 {{name}}",
            "Select a file": "选择文件",
            "Select a one {{type}} file": "选择一个 {{type}} 文件",
            "Select a one caption file.": "请选择一个字幕文件。",
            "Select assets": "选择资产",
            "Select categories": "选择类别",
            "Select category": "选择类别",
            "Select event type": "选择事件类型",
            "Select files": "选择文件",
            "Select folder": "选择文件夹",
            "Select kind": "选择类型",
            "Select language": "选择语言",
            "Select one MP4 file": "选择一个 MP4 文件",
            "Select pipeline": "选择管道",
            "Select roles to grant": "选择要授予的角色",
            "Select whitelist": "选择白名单",
            "Select...": "请选择...",
            "Selected {{name}}": "已选择 {{name}}",
            "Separate by newlines": "按换行符分隔",
            "Service": "服务",
            "Set": "设置",
            "Set as default": "设为默认",
            "Set as primary": "设为主要",
            "Settings": "设置",
            "Show all": "显示全部",
            "Show more": "显示更多",
            "Sign in": "登录",
            "Sign in with Megazone Accounts": "使用 Megazone 账户登录",
            "Single": "单个",
            "Single IP": "单个 IP",
            "Size": "大小",
            "smiling": "微笑",
            "Source": "来源",
            "Source A": "来源 A",
            "Source B": "来源 B",
            "Source end behavior": "来源结束行为",
            "Sources": "来源",
            "Specifications": "规格",
            "Stage": "阶段",
            "Stage scope": "阶段范围",
            "Project scope": "项目范围",
            "Start": "开始",
            "Space": "空间",
            "Start {{name}}": "开始 {{name}}",
            "Start analysis": "开始分析",
            "Start date": "开始日期",
            "Start indexing": "开始索引",
            "Start time": "开始时间",
            "Start~End": "开始~结束",
            "Started": "已开始",
            "Starting": "正在启动",
            "State": "状态",
            "Statistics": "统计",
            "Status": "状态",
            "Stop": "停止",
            "Stopped": "已停止",
            "Stopping": "正在停止",
            "Storage path": "存储路径",
            "Stream": "流",
            "STREAM": "流",
            "Stream ID": "流 ID",
            "Streams": "流",
            "Submit": "提交",
            "SUBMITTED": "已提交",
            "Submitted": "已提交",
            "Subtitle": "字幕",
            "Sun": "周日",
            "Sunday": "星期日",
            "Supported file formats": "支持的文件格式",
            "Supported inputs": "支持的输入",
            "Supported URL patterns": "支持的 URL 模式",
            "Supported URLs": "支持的 URL",
            "Synchronization": "同步",
            "table": "表格",
            "Tag": "标签",
            "Tags": "标签",
            "Target ID": "目标 ID",
            "Target resource": "目标资源",
            "Team": "团队",
            "Team ID": "团队 ID",
            "Team overview": "团队概览",
            "Teams": "团队",
            "Terms & Conditions": "条款与条件",
            "Text": "文本",
            "Text area": "文本区域",
            "Text field": "文本字段",
            "There is no Stream to select.": "没有可选择的 Stream。",
            "This {{name}}": "此 {{name}}",
            "Thumbnails": "缩略图",
            "THUMBNAILS": "缩略图",
            "Thur": "周四",
            "Thursday": "星期四",
            "Time": "时间",
            "Timestamp": "时间戳",
            "Timezone": "时区",
            "Title": "标题",
            "Today": "今天",
            "Total": "合计",
            "Total {{name}}": "共 {{name}}",
            "Total <strong className=\\\"emphasis\\\">{{elementsLength}}</strong>": "共 <0>{{elementsLength}}</0>",
            "Total <0>{{elementsLength}}</0>": "共 <0>{{elementsLength}}</0>",
            "Total time": "总时长",
            "Transcode": "转码",
            "Transcode profile": "转码配置",
            "Transcoded": "已转码",
            "Transcoder Job ID": "转码器 Job ID",
            "Transcoding": "转码中",
            "Transcoding canceled": "转码已取消",
            "Transcoding complete": "转码完成",
            "Transcoding error": "转码错误",
            "Transcoding failed": "转码失败",
            "Transcoding time": "转码时间",
            "Tree": "树形",
            "Tue": "周二",
            "Tuesday": "星期二",
            "Twitch": "Twitch",
            "Twitter": "Twitter",
            "Type": "类型",
            "Undefined": "未定义",
            "Unique": "唯一",
            "Unknown": "未知",
            "(Unknown)": "（未知）",
            "Unscheduled time": "未计划时间",
            "Unset default": "取消默认",
            "Up": "向上",
            "Update file": "更新文件",
            "Updated": "已更新",
            "Updated at": "更新时间",
            "Updated by": "更新者",
            "Updating...": "更新中...",
            "Upload": "上传",
            "Upload {{status}}.": "上传 {{status}}。",
            "Upload rules": "上传规则",
            "Uploading": "上传中",
            "UPLOADING": "上传中",
            "URL": "URL",
            "User ID": "用户 ID",
            "User information": "用户信息",
            "User name": "用户名",
            "User overview": "用户概览",
            "User username": "用户账号",
            "Username": "用户名",
            "Users": "用户",
            "Value": "值",
            "Video": "视频",
            "Video ID": "视频 ID",
            "Video AI": "Video AI",
            "Video setting": "视频设置",
            "Videos": "视频",
            "View analytics data": "查看分析数据",
            "View more": "查看更多",
            "VOD player URL": "VOD 播放器 URL",
            "Warning": "警告",
            "Wearing glasses": "戴眼镜",
            "Wed": "周三",
            "Wednesday": "星期三",
            "Week": "周",
            "Weekly": "每周",
            "Weeks": "周",
            "Welcome": "欢迎",
            "Whitelist": "白名单",
            "Whitelist rules": "白名单规则",
            "Whitelist to request": "请求白名单",
            "Workflow": "工作流",
            "Workflow Name": "工作流名称",
            "workflow": "工作流",
            "Years old": "岁",
            "Yes": "是",
            "Youtube": "Youtube",
            "Youtube syndication": "Youtube 联合发布",
            "Every months on": "每月第",
            "PREPARING": "准备中",
            "Restrict bucket access": "限制存储桶访问",
            "Active on creation": "创建时激活",
            "ACTIVATING": "激活中",
            "INACTIVATING": "停用中",
            "Archive": "归档",
            "Archving...": "归档中...",
            "Folder path": "文件夹路径",
            "No assets folder": "无资产文件夹",
            "Restoring...": "恢复中...",
            "Search in folder": "在文件夹中搜索",
            "Root": "根目录",
            "Search results": "搜索结果",
            "Restoring": "恢复中",
            "Archiving": "归档中",
            "days": "天",
            "Achived Assets": "已归档资产",
            "Archived": "已归档",
            "Empty Archived": "没有已归档的项目",
            "Archived by": "归档者",
            "Archived Period": "归档期限",
            "Archived Assets": "已归档资产",
            "Restored": "已恢复",
            "Archive ID": "归档 ID",
            "Auto Categorization": "自动分类",
            "Site access": "站点访问",
            "Console": "控制台",
            "File meta": "文件元数据",
            "Operator": "操作符",
            "Contains": "包含",
            "Duration range": "时长范围",
            "Date range": "日期范围",
            "Greater than": "大于",
            "Less than": "小于",
            "OverWrite": "覆盖",
            "Overwrite": "覆盖",
            "Skip": "跳过",
            "OK": "确定",
            "Source name": "来源名称",
            "Partial {{type}} to completed.": "部分 {{type}} 已完成。",
            "Folder Upload": "文件夹上传",
            "Files Upload": "文件上传",
            "New Folder": "新建文件夹",
            "Upload Files": "上传文件",
            "References": "参考资料",
            "사용자 설정 위젯": "用户偏好小组件",
            "팀 설정 위젯": "用户群组偏好小组件",
            "프로젝트 설정 위젯": "项目偏好小组件",
            "전체 기간": "全部时段",
            "빠른 지정": "快速选择",
            "사용자 지정": "用户自定义",
            "이번주": "本周",
            "이번달": "本月",
            "올해": "今年",
            "지난 15분": "最近15分钟",
            "지난 30분": "最近30分钟",
            "지난 1시간": "最近1小时",
            "지난 4시간": "最近4小时",
            "선택됨": "已选择",
            "에 업데이트됨": "更新时间",
            "위젯 설정": "小组件偏好",
            "선택된 위젯": "已选小组件",
            "프로젝트 설정으로 적용": "保存为项目偏好",
            "선 그래프": "折线图",
            "바 그래프": "柱状图",
            "동영상": "视频",
            "시청자 수": "独立观看人数",
            "시청 횟수": "观看次数",
            "디바이스별 시청자 수 (기간)": "按设备划分的观看人数（时段）",
            "디바이스별 시청자 수 (백분율)": "按设备划分的观看人数（%）",
            "현재 시청자 수": "并发观看人数",
            "누적 시청자 수": "总观看人数",
            "누적 시청 횟수": "总观看次数",
            "누적 시청 시간": "总播放时长",
            "상위 지역": "最多观看地区（地区）",
            "상위 디바이스": "最多观看设备（设备）",
            "VIDEOS": "视频",
            "VIEWERS": "独立观看人数",
            "WATCH_COUNT": "观看次数",
            "DEVICE_VIEWERS_ON_TERM": "按设备划分的观看人数（时段）",
            "DEVICE_VIEWERS_ON_PERCENTAGE": "按设备划分的观看人数（%）",
            "COUNTRY_VIEWERS_ON_TERM": "按国家划分的观看人数（时段）",
            "COUNTRY_VIEWERS_ON_PERCENTAGE": "按国家划分的观看人数（%）",
            "REGION_VIEWERS_ON_TERM": "按地区划分的观看人数（时段）",
            "REGION_VIEWERS_ON_PERCENTAGE": "按地区划分的观看人数（%）",
            "CITY_VIEWERS_ON_TERM": "按城市划分的观看人数（时段）",
            "CITY_VIEWERS_ON_PERCENTAGE": "按城市划分的观看人数（%）",
            "VIEWERS_PROGRESS": "按时间轴划分的观看人数",
            "Restore": "恢复",
            "New folder": "新建文件夹",
            "Folder": "文件夹",
            "Search in {{name}}": "在 {{name}} 中搜索",
            "{{name}} View": "{{name}} 视图",
            "Hierarchy": "层级结构",
            "{{name}} Search": "{{name}} 搜索",
            "Confirm": "确认",
            "All lineups": "全部排期",
            "Repeat lineups": "重复排期",
            "All Copy to": "全部复制至",
            "Date to All copy to": "全部复制至的日期",
            "Daily Copy": "每日复制",
            "Check date to all copy to": "检查全部复制至的日期",
            "Available": "可用",
            "No assets category": "无资产类别",
            "No videos folder": "无视频文件夹",
            "No videos category": "无视频类别",
            "No channels category": "无频道类别",
            "Create Auto Captions": "创建自动字幕",
            "Creating Auto Caption": "正在创建自动字幕",
            "Create Auto Caption": "创建自动字幕",
            "Default Language": "默认语言",
            "Last login": "上次登录",
            "Change view": "更改视图",
            "Of": "共",
            "All approval status": "全部审批状态",
            "Action rules": "操作规则",
            "Delete Constraints": "删除限制",
            "Copy to Constraints": "复制至限制",
            "Published History": "发布历史",
            "Channel Name": "频道名称",
            "Accounts": "账户",
            "Account settings": "账户设置",
            "Add Accounts": "添加账户",
            "URL for Posting": "发布URL",
            "Kakaotalk": "Kakaotalk",
            "Select Accounts": "选择账户",
            "Go to": "前往",
            "Expired date :": "到期日期：",
            "Timeshift": "时移",
            "Sec": "秒",
            "DeleteFaceIndex": "取消人脸索引",
            "ModifyFaceIndex": "修改人脸索引",
            "EditFaces": "编辑人脸",
            "FaceToIndex": "待索引人脸",
            "FaceToUnindex": "待取消索引人脸",
            "FacesIndexed": "已索引人脸",
            "StorageClass": "存储类型",
            "Last Modified": "最后修改时间",
            "Objects": "对象",
            "View More": "查看更多",
            "No buckets folder": "无存储桶文件夹",
            "Access": "访问",
            "Manage": "管理",
            "Source Buckets": "源存储桶",
            "Bucket": "存储桶",
            "Custom": "自定义",
            "Header": "标头",
            "Setting": "设置",
            "Theme": "主题",
            "White": "白色",
            "Black": "黑色",
            "CI": "标志",
            "BG": "背景",
            "Color": "颜色",
            "Text button": "文字按钮",
            "Quick Select": "快速选择",
            "User": "用户",
            "Language Settings": "语言设置",
            "Specific Language": "指定语言",
            "Auto Language": "自动语言",
            "Extension": "扩展",
            "All extensions": "所有扩展",
            "Create FILE asset": "创建FILE资产",
            "Go analysis": "开始分析",
            "Copy to": "复制至",
            "Move": "移动",
            "All Storage Class": "所有存储类型",
            "Standard": "标准",
            "Reduced Redundancy": "低冗余存储",
            "Stanard-IA": "标准-IA",
            "One Zone-IA": "单区-IA",
            "Intelligent Tiering": "智能分层",
            "Glacier": "Glacier",
            "Deep Archive": "深度归档",
            "Outposts": "Outposts",
            "Meeting": "会议",
            "Rooms": "房间",
            "Recent Schedule": "最近日程",
            "out of {{total}}": "共 {{total}} 条",
            "Channel Overview": "频道概览",
            "Basic": "基本",
            "Lock": "锁定",
            "people": "人",
            "Disabled": "已禁用",
            "Create Channel": "创建频道",
            "Meetings": "会议",
            "Unlock": "解锁",
            "Locked": "已锁定",
            "All": "全部",
            "Megazone Accounts": "Megazone账户",
            "Megazone Login": "Megazone登录",
            "Sign in with Megazone Login": "使用Megazone账户登录",
            "or": "或",
            "Analyze by timestamp": "按时间戳分析",
            "Usage Time": "使用时长",
            "Music": "音乐",
            "Photo": "照片",
            "Audio Sources": "音频来源",
            "Album Images": "专辑图片",
            "Teaser Images": "预告图片",
            "Music Videos": "音乐视频",
            "Teaser Videos": "预告视频",
            "Live Videos": "直播视频",
            "Music Description": "音乐描述",
            "No musics category": "无音乐类别",
            "INACTIVE": "未激活",
            "Update {{name}}": "更新 {{name}}",
            "{{name}} Description": "{{name}} 描述",
            "Share": "共享",
            "Shared Box": "共享箱",
            "Share Box": "共享箱",
            "Shared Date": "共享日期",
            "Share to me": "共享给我的",
            "Share by me": "我共享的",
            "Add to Shared Box": "添加至共享箱",
            "Remove from Share Box": "从共享箱移除",
            "Shared {{name}}": "共享的 {{name}}",
            "Share Management": "共享管理",
            "Shared with Me": "与我共享",
            "Requested to Share": "申请共享",
            "Requester": "申请人",
            "Requested": "已申请",
            "Review Request": "审核申请",
            "Review Access Request": "审核访问申请",
            "Please add {{name1}} and {{name2}}.": "请添加 {{name1}} 和 {{name2}}。",
            "Phone Number": "电话号码",
            "Asset Sharer": "资产共享者",
            "Quick": "快速",
            "Advanced": "高级",
            "Show": "显示",
            "{{view}} Search fields": "{{view}} 搜索字段",
            "Search for assets by all projects.": "按所有项目搜索资产。",
            "<0>{{count}}</0> Results for your Search": "<0>{{count}}</0> 条搜索结果",
            "Management": "管理",
            "Assets to be shared": "待共享资产",
            "Please add {{name}}.": "请添加 {{name}}。",
            "Image Viewer": "图片查看器",
            "Images Viewer": "图片查看器",
            "Result of <0>{{name}}</0>": "<0>{{name}}</0> 的结果",
            "Download Link": "下载链接",
            "Elements": "元素",
            "This download link URL is only available for one week from now.": "此下载链接URL仅在一周内有效。",
            "Preparing download link URL": "正在准备下载链接URL",
            "No Images List": "无图片列表",
            "File Meta": "文件元数据",
            "Operation": "操作",
            "Versions": "版本列表",
            "Version": "版本",
            "My Activity": "我的活动",
            "Current Version": "当前版本",
            "Share Management Rules": "共享管理规则",
            "Users and groups belonging to the project for the selected asset are excluded from sharing.": "已选资产所在项目的用户和群组不参与共享。",
            "Search for assets in this project.": "在此项目中搜索资产。",
            "Recent People": "最近联系人",
            "Recent Music": "最近音乐",
            "Recent Photos": "最近照片",
            "Recent Photo": "最近照片",
            "Reason for sharing request (Optional)": "共享申请原因（可选）",
            "Request Access": "申请访问",
            "Display Name": "显示名称",
            "Department": "部门",
            "results": "条结果",
            "Sharer": "共享者",
            "Shared": "已共享",
            "Last Login": "最后登录",
            "Spec": "规格",
            "Asset’s Project": "资产所属项目",
            "All Projects": "所有项目",
            "All Users": "所有用户",
            "Only mine": "仅我的",
            "Rename": "重命名",
            "Moving": "移动中",
            "Copying to": "复制到",
            "Deleting": "删除中",
            "Renaming": "重命名中",
            "{{type}} completed.": "{{type}} 已完成。",
            "Partial {{type}} completed.": "部分 {{type}} 已完成。",
            "{{type}} canceled.": "{{type}} 已取消。",
            "{{type}} error.": "{{type}} 错误。",
            "Overwrite or skip file": "覆盖或跳过文件",
            "Pending {{type}}...": "正在等待 {{type}}...",
            "Ask": "询问",
            "Always Overwrite": "始终覆盖",
            "Always Skips": "始终跳过",
            "Handling in case of duplicate files": "重复文件的处理方式",
            "Apply to all": "应用于全部",
            "Shares": "共享",
            "Accessible Projects": "可访问的项目",
            "Recent Videos": "最近视频",
            "Recent Assets Shared with Me": "最近与我共享的资产",
            "Search all assets": "搜索所有资产",
            "Search assets": "搜索资产",
            "Add Users and Teams": "添加用户和团队",
            "Project Settings": "项目设置",
            "Back to Console": "返回控制台",
            "No related assets": "无相关资产",
            "No reference": "无参考",
            "My Assets": "我的资产",
            "Group": "群组",
            "Group ID": "群组 ID",
            "Groups": "群组",
            "No Groups": "无群组",
            "Add groups": "添加群组",
            "Add Users and Groups": "添加用户和群组",
            "Enter Users and Groups": "输入用户和群组",
            "Assets shared with the group are not deleted": "与群组共享的资产不会被删除",
            "Group overview": "群组概览",
            "Selected files": "已选文件",
            "Create by Transcoding": "通过转码创建",
            "Create as Assets": "创建为资产",
            "ItemSet for Metadata": "元数据的 ItemSet",
            "ItemSet": "项目集",
            "Items": "项目",
            "Multiple": "多个",
            "Storage": "存储",
            "CaptionSync": "字幕同步",
            "Fast": "快速",
            "Slow": "慢速",
            "No Time Change": "不更改时间",
            "Time Control": "时间控制",
            "No captions": "无字幕",
            "Edit Captions": "编辑字幕",
            "sec": "秒",
            "Interactive Video": "互动视频",
            "Interactive Videos": "互动视频",
            "Open Chatting": "开放聊天",
            "Group Chatting": "群组聊天",
            "Add Attendees": "添加参与者",
            "Recording": "录制中",
            "Ending Video": "结束视频",
            "msec": "毫秒",
            "Enter Email Address": "输入电子邮件地址",
            "Intro Video URL": "片头视频 URL",
            "Ending Video URL": "结束视频 URL",
            "Empty Recording History": "暂无录制历史",
            "Recording History": "录制历史",
            "Recording Time": "录制时长",
            "Intro Videos": "片头视频",
            "Ending Videos": "结束视频",
            "No Schedule": "无日程",
            "Input file upload error": "输入文件上传错误",
            "Input file preprocessing error": "输入文件预处理错误",
            "MediaConvert transcoding error": "MediaConvert 转码错误",
            "Input file post processing error": "输入文件后处理错误",
            "Console first entry screen": "控制台首页入口",
            "Add attendees to join the Group Chatting": "添加参与者以加入群组聊天",
            "Add attendees": "添加参与者",
            "Schedule Name": "日程名称",
            "Schedule Time": "日程时间",
            "Channel type": "频道类型",
            "Video latency": "视频延迟",
            "Playback authorization": "播放授权",
            "Standard latency": "标准延迟",
            "Ultra-low latency": "超低延迟",
            "Amazon IVS": "Amazon IVS",
            "Amazon Chime": "Amazon Chime",
            "Playback": "播放",
            "Recordings": "录制",
            "Recorded Videos": "录制视频",
            "Event Time": "事件时间",
            "Storage Path": "存储路径",
            "Change after channel creation": "频道创建后更改",
            "Create Assets on creation": "创建时生成资产",
            "Manage Access": "管理访问权限",
            "Search with subcategories": "按子类别搜索",
            "Service Provider": "服务提供商",
            "Sync complete": "同步完成",
            "Sync failed": "同步失败",
            "Synchronizing": "同步中",
            "Sync refresh": "刷新同步",
            "Projects Allowed To Use": "允许使用的项目",
            "SPACE ADMINISTRATION": "SPACE 管理",
            "CloudPlex Delivery": "CloudPlex Delivery",
            "CloudPlex Start": "CloudPlex Start",
            "Switch to Admin": "切换到管理员",
            "Add User": "添加用户",
            "UserName": "用户名",
            "Last Access": "最近访问",
            "Add teaser images": "添加预告图片",
            "out of": "共 ",
            "Indexed Faces": " 个已索引人脸",
            "Products": "产品",
            "Customer Service": "客户服务",
            "Invitation Pending": "邀请待处理",
            "Has Space Access": "拥有空间访问权限",
            "No Space Access": "无空间访问权限",
            "Member": "成员",
            "Trusted": "受信任",
            "No role": "无角色",
            "Revoke space access": "撤销空间访问权限",
            "Last Name": "姓",
            "First Name": "名",
            "Phone number": "电话号码",
            "Company": "公司",
            "Position": "职位",
            "’s Detail": "的详情",
            "Has access on Space": "拥有空间访问权限",
            "Administrator": "管理员",
            "Any role": "任意角色",
            "Last Activity": "最近活动",
            "Grant space access": "授予空间访问权限",
            "Remove user": "删除用户",
            "Add {{number}} users": "添加 {{number}} 个用户",
            "Add user": "添加用户",
            "Add attribute": "添加属性",
            "Next": "下一步",
            "Photos": "图片",
            "Zoom in": "放大",
            "Zoom out": "缩小",
            "Previous": "上一步",
            "Compressing": "压缩中",
            "Ready to {{type}}": "准备 {{type}}",
            "Select Files": "选择文件",
            "Edit Default Metadata": "编辑默认元数据",
            "Edit and Create Assets": "编辑并创建资产",
            "Create assets": "创建资产",
            "create assets": "创建资产",
            "Create Assets": "创建资产",
            "assets": "资产",
            "Asset creation": "资产创建",
            "Create Assets Bulk": "批量创建资产",
            "Selected Files": "已选文件",
            "Edit Metadata": "编辑元数据",
            "APPLY ALL OVER Options": "全部应用选项",
            "Apply All Over": "全部应用",
            "Set as Options": "设为选项",
            "Asset Name Alias": "资产名称别名",
            "Choose Bulk Operation": "选择批量操作",
            "Asset Type": "资产类型",
            "Asset Composition Type": "资产组合类型",
            "Set to Default": "设为默认",
            "Preparing {{type}}...": "正在准备 {{type}}...",
            "Add Files to Bulk": "批量添加文件",
            "Choose Files": "选择文件",
            "A total of <0> {{number}} </0> files can be added.": "最多可添加 <0> {{number}} </0> 个文件。",
            "Add All": "全部添加",
            "If a file is changed or deleted from the storage list": "如果存储列表中的文件被更改或删除",
            "Asset Composition Types": "资产组合类型",
            "Auto-apply language & labels": "自动应用语言和标签",
            "Ex": "示例",
            "Single Asset": "单个资产",
            "Multiple Asset": "多个资产",
            "Filters": "筛选器",
            "Add Assets": "添加资产",
            "No Files": "无文件",
            "Caption Type Asset Creation Rules": "字幕类型资产创建规则",
            "Language & Label": "语言和标签",
            "If there is a language code after the file name (_)": "如果文件名后有语言代码（_）",
            "If there is no language code after the file name (_)": "如果文件名后没有语言代码（_）",
            "Add <0> {{number}} </0> file(s)": "添加 <0> {{number}} </0> 个文件",
            "Ready": "就绪",
            "In Progress": "进行中",
            "FAILED": "失败",
            "NOT_SUPPORTED": "不支持",
            "PARTIAL_COMPLETED": "部分完成",
            "Video and image content analysis": "视频和图像内容分析",
            "Metadata analysis": "元数据分析",
            "AI search mode indexing": "AI 搜索模式索引",
            "AI search indexing status": "AI 搜索索引状态",
            "AI search mode": "AI 搜索模式",
            "Indexing status": "索引状态",
            "Request to Create Assets": "请求创建资产",
            "In Order of Accuracy": "按准确度排序",
            "Latest Order": "最新排序",
            "Only Mine": "仅我的",
            "Other then Mine": "非我的",
            "Detailed Filter": "详细筛选",
            "Storage Class": "存储类别",
            "Search for storage and assets by all projects.": "按所有项目搜索存储和资产。",
            "Please enter your search term": "请输入搜索词",
            "Please check the search term you entered again.": "请重新检查您输入的搜索词。",
            "All Buckets": "所有存储桶",
            "Only My Buckets": "仅我的存储桶",
            "Other Buckets": "其他存储桶",
            "Only My Projects": "仅我的项目",
            "Other Projects": "其他项目",
            "No results were found for your search.": "未找到搜索结果。",
            "Please re-enter your search term.": "请重新输入搜索词。",
            "Please enter your search term.": "请输入搜索词。",
            "Select Bucket": "选择存储桶",
            "Choose the bucket you want to use.": "选择要使用的存储桶。",
            "Current Project": "当前项目",
            "Accessible": "可访问",
            "Not Accessible": "不可访问",
            "Current": "当前",
            "Project other than this one": "其他项目",
            "Use of features based on access": "基于访问权限的功能使用",
            "All functions available": "所有功能可用",
            "All functions unavailable": "所有功能不可用",
            "Partial functions unavailable": "部分功能不可用",
            "Folder path to check": "要检查的文件夹路径",
            "Current project": "当前项目",
            "Switch Project": "切换项目",
            "Project to switch to": "要切换的项目",
            "Add users and teams to share": "添加用户和团队以共享",
            "Link Setting": "链接设置",
            "Password": "密码",
            "Link": "链接",
            "download link URL": "下载链接 URL",
            "Download Period": "下载期限",
            "Number of Downloads": "下载次数",
            "Files to share": "要共享的文件",
            "The files to download are ready.": "要下载的文件已准备就绪。",
            "The number of password errors has been exceeded.": "密码错误次数已超限。",
            "The download period of times has expired.": "下载期限已过期。",
            "The download number of times has expired.": "下载次数已超限。",
            "The page not found.": "页面未找到。",
            "Enter your Password": "输入密码",
            "Show Password": "显示密码",
            "Enter {{name}}": "输入 {{name}}",
            "Done": "完成",
            "Enter Name": "输入名称",
            "Share Link": "共享链接",
            "Share Request": "共享请求",
            "Choose One Approver": "选择一位审批人",
            "File to request": "要请求的文件",
            "Send request": "发送请求",
            "Expires At": "到期时间",
            "History of my request to share": "我的共享请求历史",
            "History of requests to share": "共享请求历史",
            "Previous Request": "上一个请求",
            "Linked Requests": "关联请求",
            "Shared History": "共享历史",
            "Permission": "权限",
            "Reason for Approval (Optional)": "审批原因（可选）",
            "Reason for Reject (Optional)": "拒绝原因（可选）",
            "Select User": "选择用户",
            "Canceled": "已取消",
            "Shared by me": "我共享的",
            "Shared with me": "共享给我的",
            "Shared with": "共享给",
            "Revoke": "撤销",
            "Revoked": "已撤销",
            "Revoke access": "撤销访问权限",
            "Revoke link": "撤销",
            "File to be shared": "待共享文件",
            "By last shared": "按最近共享",
            "By last modified": "按最近修改",
            "By name": "按名称",
            "By type": "按类型",
            "Removed": "已删除",
            "Manage shared with": "管理共享对象",
            "Send email with password": "发送含密码的邮件",
            "Include": "包含",
            "Not Include": "不包含",
            "Request expired": "请求已过期",
            "Shared by": "共享者",
            "Share Expires Date": "共享到期日期",
            "Create Videos": "创建视频",
            "Create People": "创建人物",
            "Create Music": "创建音乐",
            "Create Photo": "创建照片",
            "Folder Path": "文件夹路径",
            "Select Folder Path": "选择文件夹路径",
            "Folder View": "文件夹视图",
            "Category View": "类别视图",
            "View All": "查看全部",
            "Zendesk Widget": "Zendesk Widget",
            "Widget": "Widget",
            "Widget Settings": "Widget 设置",
            "Zendesk Settings": "Zendesk 设置",
            "Zendesk Domain": "Zendesk 域名",
            "API Token": "API 令牌",
            "Locale": "语言区域",
            "Page URL": "页面 URL",
            "Show API Token": "显示 API Token",
            "Section ID": "版块 ID",
            "Topic ID": "主题 ID",
            "Minimum Image Size": "最小图片尺寸",
            "Metadata Template": "元数据模板",
            "Name Prefix": "名称前缀",
            "Metadata Preset": "元数据预设",
            "Metadata Name Prefix": "元数据名称前缀",
            "Metadata Template Name": "元数据模板名称",
            "Metadata Template Description": "元数据模板描述",
            "Select Metadata Template": "选择元数据模板",
            "Asset Name Prefix": "资产名称前缀",
            "Folder Path Option": "文件夹路径选项",
            "Save assets to the top-level path on the drive": "将资产保存到驱动器的顶层路径",
            "Save assets according to the storage folder path": "按存储文件夹路径保存资产",
            "Save assets to the selected folder": "将资产保存到所选文件夹",
            "Asset to share": "待共享资产",
            "Message": "消息",
            "Message (Optional)": "消息（可选）",
            "Send": "发送",
            "Add Users": "添加用户",
            "Pending changes": "待处理变更",
            "Access Updated": "访问已更新",
            "<0> {{number}} </0> days": "<0> {{number}} </0> 天",
            "<0/> times": "<0/> 次",
            "Search Category Group": "搜索类别群组",
            "Discard": "放弃",
            "In Use": "使用中",
            "Not Used": "未使用",
            "No Assets Folders": "无资产文件夹",
            "Select Category Group": "选择类别群组",
            "File to share": "待共享文件",
            "Clear All": "清除全部",
            "Grouping View mode": "分组视图模式",
            "View All mode": "查看全部模式",
            "Archived ID": "归档 ID",
            "Requested At": "已请求",
            "Subject": "主题",
            "Approval Status": "审批状态",
            "Status Updated": "状态已更新",
            "Shared History Action": "操作",
            "Approver": "审批人",
            "Sharehistory": "共享历史",
            "Sharebox": "共享箱",
            "Internal Share": "内部共享",
            "External Share": "外部共享",
            "asset creation": "资产创建",
            "Creating asset...": "正在创建资产...",
            "No {{type}} Categories": "无 {{type}} 类别",
            "Delete the asset?": "删除该资产？",
            "Apply All": "全部应用",
            "Delete the item?": "删除该项目？",
            "Move the item?": "移动该项目？",
            "Move these items?": "移动这些项目？",
            "Location": "位置",
            "Specify Here": "在此指定",
            "Dimensions": "尺寸",
            "Asset Created": "资产已创建",
            "History of my internal share requests": "我的内部共享请求历史",
            "History of internal sharing requests to me": "向我发出的内部共享请求历史",
            "History of my external sharing": "我的外部共享历史",
            "No list": "暂无列表",
            "Restore the item?": "恢复该项目？",
            "Change Restore Option": "更改恢复选项",
            "Users shared with": "共享给的用户",
            "Status of ready": "就绪状态",
            "Expiration Date": "到期日期",
            "Mail Language Settings": "邮件语言设置",
            "Items Shared": "已共享项目",
            "Histories": "历史记录",
            "Shared Histories": "共享历史记录",
            "Search owner": "搜索所有者",
            "Search extension": "搜索扩展名",
            "Search type": "搜索类型",
            "Search filter": "搜索筛选",
            "Search status": "搜索状态",
            "History of external share": "外部共享历史",
            "Calulating...": "计算中...",
            "Asset Details": "资产详情",
            "Asset Search Results": "资产搜索结果",
            "API Endpoint": "API 端点",
            "USED": "已使用",
            "UNUSED": "未使用",
            "Archive after adding assets": "添加资产后归档",
            "Moving to CloudPlex Assets": "正在移动到 CloudPlex 资产",
            "Download All": "全部下载",
            "Starred": "已加星标",
            "Hi, {{name}}": "你好，{{name}}",
            "Switch to": "切换到",
            "Add to Starred": "添加到星标",
            "Remove from Starred": "从星标中移除",
            "Column Settings": "列设置",
            "Sort in descending order": "降序排列",
            "Sort in ascending order": "升序排列",
            "Project Name": "项目名称",
            "Project Lead": "项目负责人",
            "Sort by": "排序方式",
            "by name": "按名称",
            "by most recent": "按最新",
            "by update": "按更新",
            "Last Updated": "最近更新",
            "Hide all": "全部隐藏",
            "CPA_ARCHIVED": "已归档",
            "CPA_ARCHIVING": "归档中",
            "CPA_RESTORING": "恢复中",
            "CPA_ERROR": "错误",
            "PUBLIC": "公开",
            "PRIVATE": "私有",
            "Add Project": "添加项目",
            "Grid Layout": "网格布局",
            "List Layout": "列表布局",
            "Lead": "负责人",
            "View all Projects": "查看所有项目",
            "Project unassigned": "未分配项目",
            "Replace Asset": "替换资产",
            "Set lockout for other users": "为其他用户设置锁定",
            "locked by": "锁定者",
            "Me": "我",
            "Locked by": "锁定者",
            "locked by '{{name}}({{username}})'": "由 '{{name}}({{username}})' 锁定",
            "locked by 'Me'": "由 '我' 锁定",
            "Automatic Bucket Lock Options": "自动存储桶锁定选项",
            "Auto-Lock Enabled": "已启用自动锁定",
            "Size of files Option": "文件大小选项",
            "Size of files": "文件大小",
            "Number of files": "文件数量",
            "Number of files Option": "文件数量选项",
            "Default Archive Option": "默认归档选项",
            "Allow customization when archiving": "归档时允许自定义",
            "Default Restore Options": "默认恢复选项",
            "Archive Option": "归档选项",
            "Restore Option": "恢复选项",
            "Back to Project": "返回项目",
            "Archive the item?": "归档该项目？",
            "Archive items?": "归档这些项目？",
            "Restore items?": "恢复这些项目？",
            "files": "文件",
            "CPD Integrations": "CPD 集成",
            "Credentials Information": "凭证信息",
            "CloudPlex Delivery Information": "CloudPlex Delivery 信息",
            "Switch Admin": "切换管理员",
            "Space List": "空间列表",
            "App Download": "应用下载",
            "REQUEST_ARCHIVE": "请求归档",
            "REQUEST_RESTORE": "请求恢复",
            "ARCHIVE_ERROR": "归档错误",
            "RESTORE_ERROR": "恢复错误",
            "RESTORED": "已恢复",
            "ARCHIVING": "归档中",
            "ARCHIVED": "已归档",
            "RESTORING": "恢复中",
            "Add Collection": "添加集合",
            "Collections": "集合",
            "Assets Count": "资产数量",
            "Collection Details": "集合详情",
            "Collection ID": "集合 ID",
            "Linked Collections": "关联集合",
            "All Media Types": "所有媒体类型",
            "Specify the folder location?": "指定文件夹位置？",
            "Select assets through search": "通过搜索选择资产",
            "Select assets in a specific folder?": "在指定文件夹中选择资产？",
            "Select assets in a specific folder": "在指定文件夹中选择资产",
            "Selected Assets": "已选资产",
            "max": "最多",
            "Also include assets from subfolders": "同时包含子文件夹中的资产",
            "Only assets in that folder are selected": "仅选择该文件夹中的资产",
            "Selected a Folder": "已选文件夹",
            "Selected Collections": "已选集合",
            "Add assets?": "添加资产？",
            "Collections Search Results": "集合搜索结果",
            "Enter ID": "输入 ID",
            "Enter the creator": "输入创建者",
            "Enter the person who modified it": "输入修改人",
            "Enter name": "输入名称",
            "Collection": "集合",
            "Specify the collection?": "指定集合？",
            "Assets to be created can be managed by applying them to a specific collection.": "将待创建的资产应用到特定集合中进行管理。",
            "Specify the folder where the assets will be located. If not specified, it will be saved in the top path.": "指定资产所在的文件夹。若未指定，将保存到顶层路径。",
            "Duplicate": "复制",
            "Add Fields": "添加字段",
            "Metadata Fields": "元数据字段",
            "Reference Fields": "引用字段",
            "Hidden": "隐藏",
            "Fields": "字段",
            "Enter default text": "输入默认文本",
            "Enter default number": "输入默认数字",
            "Required": "必填",
            "Create Content Schema": "创建内容架构",
            "Content Schemas": "内容架构",
            "Details": "详情",
            "Search for the project name.": "搜索项目名称。",
            "Fields Search": "字段搜索",
            "No Metadata Fields yet.": "暂无元数据字段。",
            "No Reference Fields yet.": "暂无引用字段。",
            "Custom Fields": "自定义字段",
            "No {{isReference}} Fields yet.": "暂无 {{isReference}} 字段。",
            "Enter field name": "输入字段名称",
            " {{name}}": " {{name}}",
            " '{{name}}' and <emp>{{count}}</emp> others": " '{{name}}' 和 <emp>{{count}}</emp> 个其他",
            "Select type": "选择类型",
            "Select status": "选择状态",
            "Remove the item?": "删除该项目？",
            "Remove items?": "删除这些项目？",
            "Delete items?": "删除这些项目？",
            "Archiving asset...": "正在归档资产...",
            "Restoring asset...": "正在恢复资产...",
            "Create {{schemaName}}": "创建 {{schemaName}}",
            "Selected Image": "已选图片",
            "Selected {{referenceType}}": "已选 {{referenceType}}",
            "Enter text": "输入文本",
            "Enter number": "输入数字",
            "No {{name}} yet.": "暂无{{name}}。",
            "Enter description": "输入描述",
            "Engine to Use": "使用的引擎",
            "Service Type": "服务类型",
            "Auto Language (<Strong>{{n}}</Strong>/max. {{max}})": "自动语言（<Strong>{{n}}</Strong>/最多 {{max}}）",
            "Vocabulary Book": "词汇表",
            "Select Vocabulary Book": "选择词汇表",
            "Not Selected": "未选择",
            "Select Default Language": "选择默认语言",
            "Go to vocabulary book": "前往词汇表",
            "Speaker Classification": "说话人分类",
            "Enter Label": "输入标签",
            "Enter Asset name": "输入资产名称",
            "Sounds Like": "发音相似",
            "Display As": "显示为",
            "Add Vocabulary": "添加词汇",
            "Enter Display As": "输入显示名称",
            "Enter Sounds Like (Enter after typing)": "输入发音相似词（输入后按回车）",
            "Credentials": "凭证",
            "Engines": "引擎",
            "Available in Auto Captions.": "可在自动字幕中使用。",
            "Before input": "输入前",
            "Typing": "输入中",
            "Editing": "编辑中",
            "Input complete": "输入完成",
            "Assets > Video Asset Detail > Related Assets": "资产 > 视频资产详情 > 关联资产",
            "Contents > Videos Detail > Captions > Auto Captions": "内容 > 视频详情 > 字幕 > 自动字幕",
            "Additional informations": "附加信息",
            "Auto caption": "自动字幕",
            "Console Default Language": "控制台默认语言",
            "List Default Layout": "列表默认布局",
            "Additional AI analysis": "附加分析",
            "View timestamps": "查看时间戳",
            "Start AI analysis": "开始 AI 分析",
            "AI analysis completed": "AI 分析已完成",
            "AI Analysis": "AI 分析",
            "Added to Check timestamp": "已添加到「检查时间戳」",
            "Removed from Check timestamp": "已从「检查时间戳」中删除",
            "Removed from Metadata tags": "已从「元数据标签」中删除",
            "Added to Metadata tags": "已添加到「元数据标签」",
            "Engine": "引擎",
            "Summary analysis result": "摘要分析结果",
            "Original analysis result": "原始分析结果",
            "Top 10 most exposed labels": "曝光最多的前10个标签",
            "Exposure Point (First / Last)": "曝光时间点（首次 / 末次）",
            "Label detection in Video": "视频标签检测",
            "Recognize Faces in Video": "视频人脸识别",
            "Recognize Celebrity in Video": "视频名人识别",
            "Content Moderation in Video": "视频内容审核",
            "Video transcription": "视频转录",
            "Long audio transcription": "长音频转录",
            "Annotate Scenes in Video": "视频场景标注",
            "Recognize Texts in Video": "视频文字识别",
            "Avg. Confidence (%)": "平均置信度（%）",
            "Timestamp - Start": "时间戳 - 开始",
            "Timestamp - End": "时间戳 - 结束",
            "Analysis result {{number}}": "分析结果 {{number}}",
            "Auto Detected": "自动检测",
            "Check timestamp for each label": "检查每个标签的时间戳",
            "View Details": "查看详情",
            "Fold": "折叠",
            "Expand": "展开",
            "point of initial exposure": "首次曝光时间点",
            "last exposure point": "末次曝光时间点",
            "Update Asset": "更新资产",
            "Reply to thread": "回复话题",
            "Edit message": "编辑消息",
            "Add reaction": "添加表情",
            "Delete message": "删除消息",
            "{{commentCount}} replies": "{{commentCount}} 条回复",
            "See all replies": "查看所有回复",
            "replies": "回复",
            "Thread": "话题",
            "Reply": "回复",
            "Replied to :": "回复对象：",
            "Please enter your message.": "请输入消息。",
            "Yesterday": "昨天",
            "member of comment": "评论成员",
            "Change name": "修改名称",
            "Private comment name (maximum <0>{{count}}</0> characters)": "私密评论名称（最多 <0>{{count}}</0> 个字符）",
            "Add member": "添加成员",
            "Delete private comment": "删除私密评论",
            "All public": "全部公开",
            "member": "成员",
            "Check": "确认",
            "Private comment name": "私密评论名称",
            "Comments where I was mentioned": "提到我的评论",
            "Comments written by me": "我写的评论",
            "Comments in threads I belong to": "我参与话题中的评论",
            "Reply to my comment": "回复我的评论",
            "My Comments": "我的评论",
            "Waiting for invitation": "等待邀请",
            "User invitation": "用户邀请",
            "Would you like to invite users?": "是否邀请用户？",
            "Invite": "邀请",
            "Accessible project": "可访问的项目",
            "Invitation date": "邀请日期",
            "Pending Invitation": "待处理邀请",
            "User waiting to be invited": "等待邀请的用户",
            "Projects you want to allow access to": "允许访问的项目",
            "Create Roles": "创建角色",
            "Manual settings": "手动设置",
            "Auto settings": "自动设置",
            "ROLES_Read": "读取权限",
            "ROLES_Edit": "编辑权限",
            "ROLES_Archive": "归档权限",
            "ROLES_Download": "下载权限",
            "ROLES_Internal": "内部共享权限",
            "ROLES_External": "内部·外部共享权限",
            "ROLES_Publish": "发布权限",
            "ROLES_Internal Request": "内部请求权限",
            "Custom Metadata": "自定义元数据",
            "Select Content Schema": "选择内容架构",
            "Search by content schema name.": "按内容架构名称搜索。",
            "Selected schema": "已选择的架构",
            "Accessed": "已访问",
            "CreatedAt": "已创建",
            "Add Users or Groups": "添加用户或群组",
            "Share Settings": "共享设置",
            "Add to Added Users": "添加到已添加用户",
            "Maximum": "最多",
            "times": "次",
            "Current location": "当前位置",
            "Where to clone": "克隆目标位置",
            "Save to top path": "保存到顶级路径",
            "Parent folder": "上级文件夹",
            "Parent folder location": "上级文件夹位置",
            "Select file": "选择文件",
            "Unapply": "取消应用",
            "Undo add": "取消添加",
            "Clear": "清除",
            "Choose one custom data.": "请选择一项自定义数据。",
            "Folder Duplication": "文件夹复制",
            "Duplication target folder": "复制目标文件夹",
            "Asset to be duplicated": "待复制的资产",
            "Request share": "请求共享",
            "Share link": "共享链接",
            "Downloader Permission Settings": "下载者权限设置",
            "Sharing Period": "共享期限",
            "Related Assets": "关联资产",
            "Linked Assets": "链接资产",
            "Remove Asset": "删除资产",
            "Add Linked Assets?": "添加链接资产？",
            "Menu Display": "菜单显示",
            "info": "信息",
            "Specify Folder Location": "指定文件夹位置",
            "Select by Recent Location": "按最近位置选择",
            "Create a private comment": "创建私密评论",
            "Open comment window": "打开评论窗口",
            "Close comment window": "关闭评论窗口",
            "Specify Collection": "指定集合",
            "Moving to CloudPlex Media…": "正在跳转到 CloudPlex Media…",
            "edited": "已编辑",
            "Uploading files": "正在上传文件",
            "Cancel Upload": "取消上传",
            "Attach Files": "附加文件",
            "Mention": "提及",
            "Attach Emoji": "附加表情",
            "Files cannot be attached.": "无法附加文件。",
            "Asset Duplication": "资产复制",
            "Please search by folder name": "请按文件夹名称搜索",
            "Added Users": "已添加用户",
            "Custom Content": "自定义内容",
            "Storages": "存储",
            "Custom Contents": "自定义内容",
            "All categories": "所有类别",
            "Default Custom Metadata": "默认自定义元数据",
            "Default View Mode": "默认视图模式",
            "List view": "列表视图",
            "Folder view": "文件夹视图",
            "Category view": "类别视图",
            "Select default metadata template": "选择默认元数据模板",
            "Select default custom metadata": "选择默认自定义元数据",
            "Please enter a message for your request (Optional)": "请输入请求消息（可选）",
            "Enter name or email": "输入名称或邮箱",
            "Duplicate this role?": "是否复制此角色？",
            "Change Name": "修改名称",
            "Enter required values": "请输入必填项",
            "Select Custom Metadata": "选择自定义元数据",
            "Select custom metadata": "选择自定义元数据",
            "Duplicate within a subfolder": "在子文件夹内复制",
            "Duplication target assets": "复制目标资产",
            "Asset to be copied": "待复制的资产",
            "Create assets from all files individually": "将所有文件分别创建为独立资产",
            "Creating image and caption files as one asset": "将图片和字幕文件创建为一个资产",
            "Please select files to add": "请选择要添加的文件",
            "Select all files": "选择所有文件",
            "InteractiveVideos": "互动视频",
            "and <emp>{{count}}</emp> others": "以及 <emp>{{count}}</emp> 个其他",
            "Asset Bulk Create": "资产批量创建",
            "An error occurred while preparing the asset for {{type}}.": "准备 {{type}} 资产时发生错误。",
            "Transcode in progress": "转码进行中",
            "Transcode has been cancelled.": "转码已取消。",
            "Transcode completed.": "转码已完成。",
            "An error occurred while transcoding.": "转码时发生错误。",
            "Asset Duplicate": "资产复制",
            "Asset Jobs": "资产任务",
            "Source Jobs": "来源任务",
            "Change Menu Name": "修改菜单名称",
            "Default menu name": "默认菜单名称",
            "Menu name to change": "要修改的菜单名称",
            "Apply as default menu name": "应用为默认菜单名称",
            "History of share link": "共享链接历史",
            "Select collections in a specific folder?": "是否在特定文件夹中选择集合？",
            "Delete Group": "删除群组",
            "COPY_ASSETS": "复制资产",
            "UPLOAD_ASSET": "创建资产",
            "CREATE_ASSETS": "资产批量创建",
            "UPLOAD": "上传文件",
            "ASSET_DOWNLOAD": "资产下载",
            "STORAGE_DOWNLOAD": "存储下载",
            "Create Asset": "创建资产",
            "Asset Download": "资产下载",
            "Storage Download": "存储下载",
            "TRANSCODE": "转码",
            "COPY": "复制",
            "RENAME": "重命名",
            "REMOVE": "删除",
            "DELETE": "删除",
            "Replication location": "复制位置",
            "existing location": "现有位置",
            "Copy assets": "复制资产",
            "Drag files here": "将文件拖至此处",
            "Browse": "浏览",
            "drop your files to upload": "拖放文件以上传",
            "Downloader": "下载者",
            "Viewer": "查看者",
            "Adjust": "调整",
            "Back to list": "返回列表",
            "Back to comments": "返回评论",
            "View private comments": "查看私密评论",
            "Close private comments": "关闭私密评论",
            "Select project": "选择项目",
            "Role settings": "角色设置",
            "All projects": "所有项目",
            "Comments": "评论",
            "Folders": "文件夹",
            "Integrated Search": "综合搜索",
            "Users & Groups": "用户与群组",
            "Project In Use": "使用中的项目",
            "Manage Account": "管理账户",
            "Log out": "退出登录",
            "Sub menu": "子菜单",
            "Storage files": "存储文件",
            "Please enter a description of the asset.": "请输入资产描述。",
            "Create Role": "创建角色",
            "Create Workflow": "创建工作流",
            "Comment": "评论",
            "Specific": "特定",
            "Go to space list": "前往空间列表",
            "Bold": "粗体",
            "Underline": "下划线",
            "Strikethrough": "删除线",
            "Share request": "共享请求",
            "contents": "内容",
            "collections": "集合",
            "preview images": "预览图片",
            "Add {{name}}?": "添加 {{name}}？",
            "User invited to group": "用户已受邀加入群组",
            "Space Admin": "空间管理员",
            "Project Admin": "项目管理员",
            "Recent Assets Shared To Me": "最近共享给我的资产",
            "Recent Assets": "最近资产",
            "archive assets": "归档资产",
            "ARCHIVE_ASSETS": "资产归档",
            "An error occurred while preparing {{type}}.": "准备 {{type}} 时发生错误。",
            "Preparing {{type}}": "正在准备 {{type}}",
            "{{type}} in progress": "{{type}} 进行中",
            "Metadata Export": "元数据导出",
            "Completed At": "完成时间",
            "PROCESSING": "处理中",
            "search options": "搜索选项",
            "Export": "导出",
            "Asset creation period": "资产创建时间段",
            "COMPLETED": "已完成",
            "Created At": "创建时间",
            "Updated At": "更新时间",
            "Project count": "项目数量",
            "Additional items": "附加项目",
            "Make": "创建",
            "Export metadata": "导出元数据",
            "Name setting": "名称设置",
            "Selected projects": "已选项目",
            "Asset creation date": "资产创建日期",
            "Directly assigned": "直接分配",
            "Create Collection": "创建集合",
            "Select scope": "选择范围",
            "METADATA_DOWNLOAD": "元数据下载",
            "Metadata download": "元数据下载",
            "Vocabulary": "词汇表",
            "Assets Name": "资产名称",
            "Assets ID": "资产 ID",
            "Preview Settings": "预览设置",
            "Assets to share": "要共享的资产",
            "Collections to share": "要共享的集合",
            "Folder to share": "要共享的文件夹",
            "Archive assets": "归档资产",
            "COLLECTION_DOWNLOAD": "集合下载",
            "collection download": "集合下载",
            "Event occurrence date and time": "事件发生日期和时间",
            "Domain": "域",
            "Admin Audit Logs": "管理员审计日志",
            "Audit log details": "审计日志详情",
            "User Agent": "用户代理",
            "Select domain": "选择域",
            "Select action": "选择操作",
            "Select requestedBy": "选择用户",
            "Publishing options": "发布选项",
            "Player ControlBar Control": "播放器控制栏控制",
            "Start the Player Fullscreen": "以全屏模式启动播放器",
            "Continue after Stopping the Player": "停止播放器后继续播放",
            "Video Download": "视频下载",
            "Embed code options": "嵌入代码选项",
            "Player Width": "播放器宽度",
            "Auto Play": "自动播放",
            "Loop Play": "循环播放",
            "Play directly with the player within the web page": "在网页内直接用播放器播放",
            "Copied": "已复制",
            "Add Vocabulary Book": "添加词汇书",
            "Vocabulary Book ID": "词汇书 ID",
            "Shrink": "收起",
            "Example": "示例",
            "1024px or 100%": "1024px 或 100%",
            "Publishing": "发布中",
            "Reclaiming": "回收中",
            "Published": "已发布",
            "Unpublished": "已取消发布",
            "Enter ResourceId": "输入资源 ID",
            "Enter ThreadResourceId": "输入资源 ID",
            "Select projects": "选择项目",
            "ResourceId": "资源 ID",
            "ThreadResourceId": "资源 ID",
            "Select user": "选择用户",
            "Report collection period": "报告收集周期",
            "Whether to send mail": "是否发送邮件",
            "SEND": "发送",
            "NOT SEND": "不发送",
            "Targets and actions": "目标与操作",
            "Email recipients": "邮件收件人",
            "Sending cycle": "发送周期",
            "REPORT_Create": "创建",
            "REPORT_Delete": "删除",
            "Reports": "报告",
            "{{value}} people": "{{value}} 人",
            "Total asset count": "资产总数",
            "Total asset size": "资产总大小",
            "{{period}} {{condition}} tasks": "{{period}} {{condition}} 任务",
            "A week ago": "一周前",
            "tasks": "任务",
            "{{period}} total": "{{period}} 合计",
            "Top <emp>10</emp> projects by {{period}} tasks": "{{period}} 任务前 <emp>10</emp> 个项目",
            "Table": "表格",
            "Chart": "图表",
            "{{period}} task count": "{{period}} 任务数量",
            "PM": "下午",
            "AM": "上午",
            "{{hour}}:{{minute}} {{period}}": "{{hour}}:{{minute}} {{period}}",
            "Pipeline during video creation": "视频创建期间的流水线",
            "Resource ID": "资源 ID",
            "Video editing": "视频编辑",
            "Video image capture": "视频截图",
            "Pan": "平移",
            "Zoom": "缩放",
            "Cut": "剪切",
            "Pull start marker": "拖动开始标记",
            "Pull end marker": "拖动结束标记",
            "Video name": "视频名称",
            "Create a video": "创建视频",
            "Create an edited video": "创建编辑后的视频",
            "Edit and save images": "编辑并保存图片",
            "Save as asset": "另存为资产",
            "Current video time": "当前视频时间",
            "Aspect custom": "自定义",
            "Scale": "比例",
            "Coordinate": "坐标",
            "Incision": "切割",
            "frame {{id}}": "帧 {{id}}",
            "Image size": "图片大小",
            "Folder location": "文件夹位置",
            "Get instant download": "立即下载",
            "Auto-archive status": "自动归档状态",
            "Auto-archive enabled": "已启用自动归档",
            "Auto-archive schedule date": "自动归档计划日期",
            "Automatic storage date after asset creation": "资产创建后的自动存储日期",
            "Prefix before asset name": "资产名称前缀",
            "days later": "天后",
            "or more": "或以上",
            "days left": "天剩余",
            "Select content in a specific folder?": "选择特定文件夹中的内容？",
            "Failure reason": "失败原因",
            "Unsupported reason": "不支持原因",
            "Field description": "字段描述",
            "Field default value": "字段默认值",
            "Enter field link": "输入字段链接",
            "Add link": "添加链接",
            "Add group": "添加群组",
            "Enter your name": "输入您的姓名",
            "Preparing to share": "正在准备共享",
            "Send again": "重新发送",
            "Cancel invitation": "取消邀请",
            "Total file size": "文件总大小",
            "Total Usage": "总使用量",
            "Project Settings > Settings > Menu (e.g. Assets) > Category Groups": "项目设置 > 设置 > 菜单（例如：资产）> 类别群组",
            "Setting location": "设置位置",
            "Category group settings": "类别群组设置",
            "Please select a custom metadata preset.": "请选择自定义元数据预设。",
            "Load custom metadata schema": "加载自定义元数据架构",
            "Load Metadata": "加载元数据",
            "PROJECT_RESOURCES_DOWNLOAD": "下载项目资源",
            "Project resources download": "下载项目资源",
            "Statistics period": "统计周期",
            "Weekly change": "每周变化",
            "Weekly Asset Count": "每周资产更新",
            "Weekly File Size": "每周文件使用量",
            "Asset count": "资产数量",
            "Comment Room Option": "评论室选项",
            "Project Comment": "项目评论",
            "preview image": "预览图片",
            "Activity History": "活动历史",
            "Activity": "活动",
            "Select location": "选择位置",
            "item selected": "已选项目",
            "Include subfolders": "包含子文件夹",
            "Thumbnail": "缩略图",
            "Maintain image proportions": "填充以适应容器",
            "Crop": "裁剪",
            "Create asset": "创建资产",
            "Menu": "菜单",
            "Cusom settings": "自定义设置",
            "Submenu": "子菜单",
            "Add menu": "添加菜单",
            "Add submenu": "添加子菜单",
            "Library": "库",
            "Menu item settings": "菜单项设置",
            "Menu name": "菜单名称",
            "Add assets from folder": "从文件夹添加资产",
            "Downloads": "下载",
            "Select menu": "选择菜单",
            "Default settings": "默认设置",
            "Custom settings": "自定义设置",
            "First entry screen": "首次进入界面",
            "First entry screen(Create page)": "首次进入界面（创建页面）",
            "Edit menu": "编辑",
            "role_Copy": "复制",
            "Shared At": "共享时间",
            "VIDEO": "视频",
            "AUDIO": "音频",
            "PEOPLE": "人员",
            "TEXT": "文本",
            "FILE": "文件",
            "Select media type": "选择媒体类型",
            "Widget Preference": "小组件偏好设置",
            "LastName/FirstName": "姓/名",
            "Site access permission": "站点访问权限",
            "Person in charge": "负责人",
            "Request date": "请求日期",
            "Request I made": "我发出的请求",
            "Request received": "收到的请求",
            "Inquiry history": "询问历史",
            "In Review": "审核中",
            "Respond": "回复",
            "Attachment": "附件",
            "Request download": "请求下载",
            "Setting download permissions": "设置下载权限",
            "Unlimited": "无限制",
            "Unstarred": "未加星标",
            "Selected Categories": "已选类别",
            "Select requester": "选择请求者",
            "Select person in charge": "选择负责人",
            "Common": "通用",
            "Download permission": "下载权限",
            "Not assigned": "未分配",
            "Attached file": "附件文件",
            "Shared users": "共享用户",
            "Shared management": "共享管理",
            "Share expiration date": "共享到期日期",
            "Number of downloads remaining": "剩余下载次数",
            "Share date": "共享日期",
            "Asset Create": "资产创建",
            "Asset Archive": "资产归档",
            "COMMENT_ATTACHMENT_DOWNLOAD": "评论附件下载",
            "Metadata Download": "元数据下载",
            "Comment Attachment Download": "评论附件下载",
            "My Jobs": "我的任务",
            "Requests": "请求",
            "Upload from My PC": "从我的电脑上传",
            "Upload from cloud": "从云端上传",
            "To Start Page": "转到起始页",
            "Go to previous page": "转到上一页",
            "Go to first page": "转到第一页",
            "Go to next page": "转到下一页",
            "Go to last page": "转到最后一页",
            "Go to page {{page}}": "转到第 {{page}} 页",
            "Go to start-ellipsis page": "转到前面的页码",
            "Go to end-ellipsis page": "转到后面的页码",
            "Open": "打开",
            "REQUEST_ATTACHMENT_DOWNLOAD": "请求附件下载",
            "Request Attachment Download": "请求附件下载",
            "Partial": "部分",
            "Request attachment download": "请求附件下载",
            "Reverse sort direction": "反转排序方向",
            "Selected Attachment": "已选附件",
            "No Channel Categories": "无频道类别",
            "Search Engine": "搜索引擎",
            "Create caption asset": "创建字幕资产",
            "Create video asset": "创建视频资产",
            "Create audio asset": "创建音频资产",
            "Create image asset": "创建图片资产",
            "Create file asset": "创建文件资产",
            "Caption asset": "字幕资产",
            "Video asset": "视频资产",
            "Audio asset": "音频资产",
            "Image asset": "图片资产",
            "File asset": "文件资产",
            "Caption kind": "字幕类型",
            "Caption language": "字幕语言",
            "Create Event Triggers": "创建事件触发器",
            "Task": "任务",
            "TRIGGER": "触发器",
            "CHOICE": "选择",
            "TASK": "任务",
            "Input Path": "输入路径",
            "Options": "选项",
            "Enter key": "输入键",
            "Enter value": "输入值",
            "Auto Language ({{n}}/max. {{max}})": "自动语言（{{n}}/最多 {{max}}）",
            "Add Task": "添加任务",
            "Keep original folder structure": "保留原始文件夹结构",
            "AI Analysis Settings": "AI 分析设置",
            "Transcribe": "转录",
            "STT": "STT",
            "Video annotation": "视频标注",
            "OCR": "OCR",
            "Vocabulary book": "词汇本",
            "Speaker classification": "说话人分类",
            "Asset creation options": "资产创建选项",
            "Create per file": "按文件创建",
            "Create as a batch": "批量创建",
            "Create collection": "创建集合",
            "Invited user": "受邀用户",
            "Space admin permission": "空间管理员权限",
            "Grant space admin": "授予空间管理员",
            "Please search by name": "请按名称搜索",
            "Grant site access": "授予站点访问权限",
            "Admin permission": "管理员权限",
            "Select admin": "选择管理员",
            "Grant project admin": "授予项目管理员",
            "Bucket Settings": "Bucket 设置",
            "Essential": "必填",
            "AWS Account Connection": "AWS 账户连接",
            "Create Project": "创建项目",
            "Use Service Account": "使用服务账户",
            "Connect External Account": "连接外部账户",
            "Region Settings": "区域设置",
            "AWS Account Connection Guide": "AWS 账户连接指南",
            "Create IAM Permission": "创建 IAM 权限",
            "Copy code": "复制代码",
            "Create IAM Role": "创建 IAM 角色",
            "View Connection Guide": "查看连接指南",
            "Group Access Management": "群组访问管理",
            "User Access Management": "用户访问管理",
            "Change Owner": "更改所有者",
            "Change": "更改",
            "Not locked": "未锁定",
            "Locked state": "已锁定状态",
            "Region": "区域",
            "AWS account connection": "AWS 账户连接",
            "Retrieving analysis results...": "正在检索分析结果...",
            "AI Auto Tagging": "AI 自动标签",
            "Use": "使用",
            "Don't Use": "不使用",
            "Min. Confidence": "最低置信度",
            "API Key": "API 密钥",
            "Summary": "摘要",
            "Usage Dashboard": "使用情况仪表板",
            "Unique accessed users": "独立访问用户",
            "Transcoding jobs": "转码任务",
            "Total assets": "资产总数",
            "Metadata registration rate": "元数据注册率",
            "AI jobs": "AI 任务",
            "A month ago": "一个月前",
            "Usage Trend": "使用趋势",
            "Asset count and storage usage by {{target}}": "按 {{target}} 划分的资产数量和存储使用量",
            "AI jobs by service type": "按服务类型划分的 AI 任务",
            "AI jobs by engine": "按引擎划分的 AI 任务",
            "Assets by media type": "按媒体类型划分的资产",
            "Daily asset creation count": "每日资产创建数量",
            "All customers": "所有客户",
            "Segment detection": "片段检测",
            "Text detection": "文本检测",
            "Translate": "翻译",
            "{{target}} detail data": "{{target}} 详细数据",
            "File size": "文件大小",
            "Customer name": "客户名称",
            "customer": "客户",
            "project": "项目",
            "Grant role": "授予角色",
            "Loading Data...": "加载数据中...",
            "MimeType": "MIME 类型",
            "Inviter": "邀请人",
            "Mark as read": "标记为已读",
            "Mark as unread": "标记为未读",
            "Mark all as read": "全部标记为已读",
            "Notifications": "通知",
            "Show only unread items": "仅显示未读项目",
            "Subtitle generation basic settings": "字幕生成基本设置",
            "Auto-delete input bucket": "自动删除输入 Bucket",
            "Try again": "重试",
            "Ask a new question": "提出新问题",
            "New Task": "新任务",
            "Tasks": "任务",
            "Go Back": "返回",
            "Create Shortform": "创建短视频",
            "AI WorkSpace Preset": "AI WorkSpace 预设",
            "Active presets": "已激活的预设",
            "Creation location": "创建位置",
            "Create Prompt Presets": "创建提示词预设",
            "Prompt": "提示词",
            "Response format": "响应格式",
            "Timeline for editing": "编辑时间轴",
            "AI Workspace": "AI Workspace",
            "Unsupported video file format": "不支持的视频文件格式",
            "Name ascending order": "名称升序",
            "Name descending order": "名称降序",
            "Expiration date": "到期日期",
            "Save Tags": "保存标签",
            "Deleted after {{day}} day(s)": "{{day}} 天后删除",
            "Single type": "单一类型",
            "Chat type": "聊天类型",
            "Save description immediately": "立即保存描述",
            "Save Description": "保存描述",
            "Start ingest": "开始导入",
            "End ingest": "结束导入",
            "Start transcoding": "开始转码",
            "End transcoding": "结束转码",
            "Copy description": "复制",
            "Whether transcoded assets are exposed": "是否显示已转码的资产",
            "Create original quality video only": "仅创建原始质量视频",
            "Automatically activated": "自动激活",
            "Publish to YouTube": "发布到 YouTube",
            "Create and manage video URL": "创建和管理视频 URL",
            "Published channels": "已发布的频道",
            "Delete URL": "删除 URL",
            "Create URL": "创建 URL",
            "You can create a URL for video sharing.": "您可以创建用于视频共享的 URL。",
            "Creating video URL": "正在创建视频 URL",
            "MODAL_Publishing": "发布中",
            "Selected": "已选择",
            "audit logs": "审计日志",
            "Select description": "选择操作",
            "List View Settings": "列表视图设置",
            "User Preference Widget": "用户偏好小部件",
            "User Group Preference Widget": "用户群组偏好小部件",
            "Project Preference Widget": "项目偏好小部件",
            "Entire Period": "全部时段",
            "This Week": "本周",
            "This Month": "本月",
            "This Year": "今年",
            "Last 15 Minutes": "最近 15 分钟",
            "Last 30 Minutes": "最近 30 分钟",
            "Last 1 Hour": "最近 1 小时",
            "Last 4 Hours": "最近 4 小时",
            "Apply with Project Settings": "应用项目设置",
            "Line Chart": "折线图",
            "Bar Chart": "柱状图",
            "Notice": "公告",
            "Cancel Update": "取消更新",
            "Widget Type": "小部件类型",
            "Wide Type": "宽幅类型",
            "Default Dashboard Exposure": "默认仪表板显示",
            "Widget Exposure Settings": "小部件显示设置",
            "Not Entered": "未填写",
            "Show Search Options": "显示搜索选项",
            "Project Settings > Settings > Menu (e.g. Asset) > Category Group": "项目设置 > 设置 > 菜单（例如 资产）> 类别群组",
            "Date to automatically retain assets after creation or restoration": "创建或还原资产后自动保留资产的日期",
            "Category Group": "类别群组",
            "Asset name 1": "资产名称 1",
            "Empty notifications": "暂无通知",
            "Unread only": "仅未读",
            "Read only": "仅已读",
            "Mixed read/unread": "已读/未读混合",
            "All comment types mixed": "所有评论类型混合",
            "All domains mixed": "所有域混合",
            "All asset media types mixed": "所有资产媒体类型混合",
            "Turn off test mode": "关闭测试模式",
            "Turn on test mode": "开启测试模式",
            "Select a preset": "选择预设",
            "Recommended": "推荐",
            "More": "更多",
            "Hide Presets": "隐藏预设",
            "See More Presets": "查看更多预设",
            "Duplicate {{name}}": "复制 {{name}}",
            "Schedule ID": "计划 ID",
            "Enter Owner": "输入所有者",
            "24 hour operation": "24 小时运营",
            "CAPTION": "字幕",
            "Search all Assets": "搜索所有资产",
            "Add Content Schema": "添加内容架构",
            "Add {{schemaName}}": "添加 {{schemaName}}",
            "Enter Sounds Like": "输入发音相似词",
            "There are no analysis results for {{name}}.": "{{name}} 没有分析结果。",
            "Change menu name": "更改菜单名称",
            "Delete group": "删除群组",
            "Recent Assets Shared to Me": "最近共享给我的资产",
            "Empty Data": "暂无数据",
            "Users and teams belonging to the project for the selected asset are excluded from sharing.": "属于所选资产项目的用户和团队已从共享中排除。",
            "Recoding": "录制中",
            "share": "共享",
            "Information": "信息",
            "No permission": "无权限",
            "MOVE": "移动",
            "metadata export": "元数据导出",
            "Collection Download": "集合下载",
            "Selected {{referenceType}}s": "已选择的 {{referenceType}}",
            "Source Upload": "源上传",
            "This operation was not entirely successful.": "此操作未完全成功。",
            "View": "查看",
            "Unable to use AI-Workspace": "无法使用 AI-Workspace",
            "Read Only": "只读",
            "Switch": "切换",
            "Switching": "切换中",
            "S3_OBJECT_CREATED": "当文件上传时",
            "ASSET_CREATED": "当资产创建时",
            "FILTER_BY_FILE_EXTENSION": "按文件扩展名过滤",
            "FILTER_BY_FILE_SIZE": "按文件大小过滤",
            "FILTER_BY_ASSET_MEDIA_TYPE": "按资产媒体类型过滤",
            "FILTER_BY_ASSET_SIZE": "按资产大小过滤",
            "ATTACH_ASSET_METADATA": "附加元数据",
            "CREATE_ASSET": "创建资产",
            "CREATE_VIDEO": "创建视频",
            "SUBMIT_AI_WORKSPACE_SINGLE_TYPE_JOB": "提交 AI Workspace 任务",
            "ARCHIVE_ASSET": "归档资产",
            "PUBLISH_VIDEO": "发布视频",
            "File URL": "文件 URL",
            "File Extension": "文件扩展名",
            "File Size": "文件大小",
            "Asset Media Type": "资产媒体类型",
            "Asset Size": "资产大小",
            "Condition": "条件",
            "Flow Edit": "流程编辑",
            "Flow Details": "流程详情",
            "Auto": "自动",
            "Manual": "手动",
            "Select a step": "选择步骤",
            "clippings": "剪辑",
            "accountId": "账户 ID",
            "AiWorkspaceJob SingleTypeJob Output": "AI Workspace 任务输出",
            "AI Mode": "AI 模式",
            "AI Mode OFF": "AI 模式关闭",
            "Ask anything": "随意提问",
            "Hi, this is AI search mode": "您好，这是 AI 搜索模式",
            "Describe a scene or feature in the video you are looking for!": "请描述您正在寻找的视频中的场景或特征！",
            "AI Search Preset Recently modified videos": "最近修改的视频",
            "AI Search Preset Golden sunset on the beach": "海滩上的金色日落",
            "AI Search Preset People in a meeting at the office": "在办公室开会的人们",
            "AI Search Preset Cinematic mood videos": "电影风格视频",
            "AI Search Preset City night view by drone": "无人机拍摄的城市夜景",
            "AI Search Preset Children smiling brightly": "灿烂微笑的孩子们",
            "View indexing status": "查看索引状态",
            "AI Analysis Plan and Usage": "AI 分析套餐及使用量",
            "Ai-billing": "AI 分析套餐及使用量",
            "Current subscription": "当前订阅",
            "No active subscription": "无有效订阅",
            "Concurrent sessions": "并发会话",
            "Fees and usage": "费用及使用量",
            "Fees": "费用",
            "Usage": "使用量",
            "Aggregating": "统计中",
            "Settled": "已结算",
            "Total so far": "截至目前合计",
            "Settled total": "结算合计",
            "Period subtotal": "区间小计",
            "Cumulative usage": "累计使用量",
            "Year option {{year}}": "{{year}}年",
            "Month option {{month}}": "{{month}}月",
            "Pay-as-you-go": "按量计费",
            "No change": "无变化",
            "vs. last month": "较上月",
            "min": "分钟",
            "AI applied": "已应用 AI",
            "Apply all": "全部应用",
            "Cancel setting": "取消设置",
            "Custom metadata": "自定义元数据",
            "Differs from preset schema": "与预设架构不同",
            "Not extracted": "未提取",
            "Replace": "替换",
            "Replace with preset schema": "替换为预设架构",
            "Revert to existing schema": "恢复为原有架构",
            "Same as preset schema": "与预设架构相同",
            "Save custom metadata directly": "直接保存自定义元数据",
            "Set preset schema": "设置为预设架构",
            "Save metadata": "保存元数据",
            "Add publish": "添加发布",
            "Back to manage": "返回管理",
            "Copy public URL": "复制公开 URL",
            "Last published": "最后发布",
            "Manage public URL": "管理公开 URL",
            "Open public URL": "打开公开 URL",
            "Open URL": "打开 URL",
            "Publish ({{count}})": "发布 ({{count}})",
            "Publish and manage public URL": "发布并管理公开 URL",
            "Publish public URL": "发布公开 URL",
            "Publish target": "发布对象",
            "Unpublish": "取消发布",
            "Unpublish ({{count}})": "取消发布 ({{count}})",
            "{{count}} files": "{{count}} 个文件",
            "English (en-US)": "英语 (en-US)",
            "Korean (ko-KR)": "韩语 (ko-KR)",
            "Related Videos": "相关视频",
            "and <emp>{{count}}</emp> others' shared": "等 <emp>{{count}}</emp> 项已共享",
            "(<emp>{{count}}</emp> days left)": "(剩余 <emp>{{count}}</emp> 天)",
            "Info": "信息",
            "Filter": "筛选器",
            "Create Highlights": "生成精彩片段",
            "Create Description": "生成描述",
            "Remove all Shares": "解除所有共享",
            "Create date": "创建日期",
            "Complete date": "完成日期",
            "Start Failure": "启动失败",
            "Recording Started": "录制已开始",
            "Upload Cancel": "取消上传",
            "Select Content in a specific folder?": "要选择特定文件夹中的内容吗？",
            "Template preview": "模板预览",
            "Terms and Conditions": "使用条款",
            "toggle password visibility": "切换密码显示",
            "{{type}} Asset Name": "{{type}} 资产名称",
            "Enter {{type}} Asset Name": "请输入 {{type}} 资产名称",
            "' shared": "' 已共享",
            "Minimap": "小地图",
            "Go back": "返回",
            "Use service account": "使用服务账户",
            "{{names}} and {{restCount}} more": "{{names}} 等 {{restCount}} 项",
            "Proxy video": "代理视频",
            "Proxy video status": "代理提取状态",
            "Auto generate proxy video": "自动生成代理视频",
            "Proxy video ready": "代理已就绪",
            "Extracting proxy video": "正在提取代理",
            "Best match": "最匹配的结果",
            "AI Search": "AI 搜索",
            "Proxy extraction failed": "代理提取失败",
            "{{count}} errors": "错误 {{count}}",
            "View by country and referrer": "查看国家和来源",
            "Countries (this URL)": "国家（此 URL）",
            "Referring domains (this URL)": "来源域名（此 URL）",
            "persons": "人",
            "and {{count}} more": "另有 {{count}} 个",
            "All URLs": "全部 URL",
            "All unpublished": "全部已取消",
            "View all URLs": "查看全部 URL",
            "Search URL": "搜索 URL",
            "Share of total": "占比",
            "Country": "国家",
            "CF address": "CF 地址"
        },
        "msg": {
            "A webhook sends asset event data to an external endpoint whenever a selected trigger occurs.": "每当所选触发器发生时，Webhook 会将资产事件数据发送到外部端点。",
            "Deliveries appear here once a selected trigger occurs.": "所选触发器发生后，传送历史将显示在此处。",
            "\"{{name}}\" will be deleted forever and you won't be able to restore it.": "“{{name}}”将被永久删除且无法恢复。",
            "Are you sure you want to delete this webhook?": "确定要删除此 Webhook 吗？",
            "The webhook has been activated.": "Webhook 已启用。",
            "The webhook has been deactivated. Events will no longer be sent.": "Webhook 已停用。即使触发器发生也不会发送。",
            "Please select at least one trigger.": "请至少选择一个触发器。",
            "Please enter a valid URL.": "请输入有效的 URL。",
            "The URL is too long.": "URL 过长。",
            "Internal addresses (private, loopback, or link-local) cannot be used.": "无法使用内部地址（专用、环回或链路本地）。",
            "We recommend using https.": "建议使用 https。",
            "https://example.com/webhooks": "https://example.com/webhooks",
            "Add request headers such as an authorization token if needed.": "如需要，请添加授权令牌等请求头。",
            "Key is required.": "键为必填项。",
            "Key must be unique.": "键必须唯一。",
            "Only letters, numbers, and hyphens are allowed.": "仅可使用字母、数字和连字符。",
            "This header cannot be used.": "无法使用此请求头。",
            "Line breaks are not allowed.": "不可使用换行符。",
            "Headers can be up to {{maxLength}} characters in total. (currently {{length}})": "请求头总计最多可输入 {{maxLength}} 个字符。（当前 {{length}} 个字符）",
            "HTTP method is fixed to POST and cannot be changed.": "HTTP 方法固定为 POST，无法更改。",
            "The request body is determined automatically by the system based on the trigger and cannot be edited.": "请求正文由系统根据触发器自动确定，无法编辑。",
            "Select a trigger to preview the request body.": "请选择触发器以预览请求正文。",
            "How many times the asset was opened through its public URL. Downloads and on-screen views are counted together, and for video, starting playback counts as one - watching to the end is not measured. If there is no access for 30 minutes after the first view, the next view is counted separately.": "通过公开 URL 打开该资产的次数。下载与在屏观看合并计数；视频以开始播放计为 1 次，不统计是否看完。首次查看后 30 分钟内无访问，之后再次查看将计为第 2 次。",
            "Total data sent out through this asset's public URLs. Opening the same file again adds to it.": "该资产通过公开 URL 发出的数据总量。再次打开同一文件会相应增加。",
            "An estimate, not a headcount. Several people in one company may count as one, and one person switching devices may count as several.": "这是估算值，而非实际人数。同一家公司的多人可能计为 1 人，同一人更换设备可能计为多人。",
            "The site the visitor came from right before opening this URL. Whether the asset was actually embedded in that page or reached by a link is not distinguished. Entries with no value are grouped as Unknown.": "访客打开此 URL 前所在的网站。无法区分资产是嵌入在该页面中，还是通过链接跳转而来。没有值的条目归为「未知」。",
            "Could not load statistics": "无法加载统计数据",
            "Could not update. Showing the previous result.": "无法更新，正在显示上一次的结果。",
            "Data is aggregated hourly, not in real time.": "数据非实时统计，每小时汇总一次。",
            "Aggregated hourly, so the most recent views may not be here yet. Do not decide whether a URL is still in use from this column alone.": "每小时汇总一次，最近的访问可能尚未计入。请勿仅凭此列判断某个 URL 是否仍在使用。",
            "The country the viewer was in.": "观看者所在的国家/地区。",
            "CDN logs are not real-time, so today and yesterday are still filling in. Downloads and on-screen views are counted together, and referring domains do not distinguish embedded pages from link clicks.": "CDN 日志并非实时，因此今天和昨天的数据仍在统计中。下载和在屏幕上查看合并计数，来源域名也不区分页面嵌入与链接点击。",
            "Please try again in a moment.": "请稍后重试。",
            "No views recorded yet": "尚无统计到的访问",
            "Views appear here once someone opens the asset through its public URL.": "当有人通过公开 URL 打开该资产时，访问将显示在此处。",
            "'{{item}}' has been added.": "已添加“{{item}}”。",
            "'{{name}}' AI analysis has begun.": "“{{name}}”的 AI 分析已开始。",
            "'{{name}}' has been added.": "已添加“{{name}}”。",
            "AI Caption task failed.": "AI 字幕任务失败。",
            "Access has Expired": "访问已过期",
            "An error has occurred": "发生错误",
            "An error occured while changing Custom Metadata {type}": "更改自定义元数据 {type} 时发生错误",
            "An error occured while changing collection name": "更改集合名称时发生错误",
            "An error occured while changing collection {{type}}": "更改集合 {{type}} 时发生错误",
            "An error occured while changing custom content {{type}}": "更改自定义内容 {{type}} 时发生错误",
            "An organizer can be selected.": "可以选择一个主办方。",
            "Assets must only be in DRM-free MP4 video type.": "资产仅支持无 DRM 的 MP4 视频格式。",
            "Collection '{{name}}' has been created.": "已创建集合“{{name}}”。",
            "Content schema '{{name}}' has been duplicated.": "已复制内容架构“{{name}}”。",
            "Creating video URL.": "正在生成视频 URL。",
            "Creation of new Metadata Export {{item}} is completed.": "新元数据导出 {{item}} 创建完成。",
            "Detach {{name}}": "解除 {{name}}",
            "Download request failed": "下载请求失败",
            "Enter your name": "请输入姓名",
            "Error adding collection '{{name}}'. {{line}} Please refresh the page and try again.": "添加集合“{{name}}”时发生错误。{{line}} 请刷新页面后重试。",
            "Expired date :": "到期日 :",
            "Face collection is not registered. Please contact to admin.": "尚未注册人脸集合。请联系管理员。",
            "Failed to configure AI analysis trigger.": "AI 分析触发器设置失败。",
            "Failed to move.": "移动失败。",
            "File is empty.": "文件为空。",
            "Group '{{name}}' has been added.": "已添加群组“{{name}}”。",
            "I agree to the above terms and conditions": "我同意以上条款和条件",
            "If you apply a different category group, those items can be found under ‘<NotClassified>Categories Not Classified into Assets</NotClassified>’ in the category view.": "若应用其他类别组，相关项目可在类别视图的‘<NotClassified>未分类到资产的类别</NotClassified>’中查看。",
            "If you delete <0>{{name}}</0>,  will also be removed from reference and you won't be able to revert this.<1/>Are you sure you want to delete?": "删除<0>{{name}}</0>后，也会从参考中移除，且无法恢复。<1/>确定要删除吗？",
            "If you delete <0>{{name}}</0>, you won't be able to revert this.<1/>Are you sure you want to delete?": "删除<0>{{name}}</0>后将无法恢复。<1/>确定要删除吗？",
            "If you have issues with Space approval, please contact Megazone Cloud. ": "如果空间审批遇到问题，请联系 Megazone Cloud。 ",
            "Korean can not contain numbers.": "韩文中不能包含数字。",
            "Please enter title": "请输入标题",
            "Please search by collection name": "请按集合名称搜索",
            "Please uncheck the items you wish to leave and try to delete them.": "请取消勾选要保留的项目后再删除。",
            "Saving of changes to '{{tab}}' failed. - {{error}}": "“{{tab}}”的更改保存失败。- {{error}}",
            "Shortform creation has been requested.": "已请求创建短视频。",
            "Since this is a category group that is not used in {{name}}s, you can check the created {{name}} in 'categories not classified in {{name}}s'.": "由于该类别组未在 {{name}} 中使用，创建的 {{name}} 可在‘未分类到 {{name}} 的类别’中查看。",
            "The Key field be up to {{tag}} characters long.": "键字段最多 {{tag}} 个字符。",
            "The Lineup Name field be up to {{name}} characters long.": "排片名称字段最多 {{name}} 个字符。",
            "The Value field be up to {{tag}} characters long.": "值字段最多 {{tag}} 个字符。",
            "The caption of the program can be edited in the caption of the <0> {{number}} </0> ": "节目的字幕可在<0> {{number}} </0>的字幕中编辑。 ",
            "The language of the captions to be applied to the video must not be duplicated.": "应用到视频的字幕语言不能重复。",
            "There is already a {{target}} with the same email. Please change it to a different email.": "已存在使用相同邮箱的 {{target}}。请更换为其他邮箱。",
            "There is no Organizers to select.": "没有可选择的主办方。",
            "There is no file to retry.": "没有可重试的文件。",
            "There was an error sharing asset {{item}}": "共享资产 {{item}} 时发生错误",
            "This field can be at least {{minByte}} bytes.": "此字段至少需要 {{minByte}} 字节。",
            "This field can be at least {{minLength}} characters.": "此字段至少需要 {{minLength}} 个字符。",
            "This field must be in email address format.": "此字段必须为电子邮箱地址格式。",
            "This listings has updated information.<0/>Please refresh and try again. Do you want to refresh now?": "该列表有更新的信息。<0/>请刷新后重试。是否立即刷新？",
            "Try another search to find an vocabulary.": "请尝试其他搜索条件以查找词条。",
            "User invitation has been completed.": "用户邀请已完成。",
            "Video '{{name}}' has been requested.": "已请求视频“{{name}}”。",
            "Videos must only be in DRM-free MP4 video type among the sources.": "源中的视频仅支持无 DRM 的 MP4 视频格式。",
            "Words to display - Enter Korean, English, numbers, spaces, and special characters (~\\\\!@#$%^&*()-_=+[{]}\\\\|;:'”,<.>/?) You can.": "要显示的词条 - 可输入韩文、英文、数字、空格和特殊字符(~\\\\!@#$%^&*()-_=+[{]}\\\\|;:'”,<.>/?)。",
            "Words to display - You can enter English, numbers, spaces, and special characters (~\\\\!@#$%^&*()-_=+[{]}\\\\|;:'”,<.>/?) there is.": "要显示的词条 - 可输入英文、数字、空格和特殊字符(~\\\\!@#$%^&*()-_=+[{]}\\\\|;:'”,<.>/?)。",
            "You can create a URL for video sharing.": "可以生成用于视频共享的 URL。",
            "You can enter up to 30 whitelist rules.": "白名单规则最多可输入 30 条。",
            "You can see all your current assets. You can find the asset you are looking for using the search option.": "可以查看当前拥有的全部资产。使用搜索选项可以找到所需的资产。",
            "You cannot upload files to this list.": "无法向该列表上传文件。",
            "You must leave at least one entry in your vocabulary book.": "词汇表中至少需要保留一个条目。",
            "You will receive an email letting you know that <0/>  the asset has been shared with you.": "我们会通过<0/>  电子邮件通知您该资产已与您共享。",
            "Your folder name is too long including parent folders, you can shorten the folder name and try again.": "包含上级文件夹在内的文件夹名称过长，请缩短文件夹名称后重试。",
            "{{resourceName}} '{{name}}' has been updated.": "已更新 {{resourceName}}“{{name}}”。",
            "{{schemaName}} '{{name}}' has been created.": "已创建 {{schemaName}}“{{name}}”。",
            "No labels": "无标签",
            "This user does not exist.": "该用户不存在。",
            "No Sharer.": "没有共享者。",
            "No Users.": "没有用户。",
            "No Groups.": "没有群组。",
            "Please manage your assets by adding the new folder.": "请添加新文件夹来管理您的资产。",
            "The video list is missing.": "没有视频列表。",
            "Delete completely from Music": "将从音乐中彻底删除",
            "You have selected <0>{{count}}</0> other than <1>{{name}}</1>": "已选择<1>{{name}}</1>外的 <0>{{count}}</0> 项",
            "Remove from category <0>{{name}}</0> only": "仅从<0>{{name}}</0>类别中移除",
            "You won’t be able to revert this.": "此操作无法撤销。",
            "If you delete <0>{{name}}</0>, it will also be removed from <0>Reference</0> and you won’t be able to revert this.<1/>Are you sure you want to delete <0>{{name}}</0>?": "删除<0>{{name}}</0>后，也会从<0>参考</0>中一并移除，且无法撤销。<1/>确定要删除<0>{{name}}</0>吗？",
            "If you delete <0>{{count}}</0> other than <0>{{name}}</0>, it will also be removed from <0>Reference</0> and you won’t be able to revert this.<1/>Are you sure you want to delete <0>{{name}}</0>?": "删除<0>{{name}}</0>外的 <0>{{count}}</0> 项后，也会从<0>参考</0>中一并移除，且无法撤销。<1/>确定要删除<0>{{name}}</0>吗？",
            "{{verb}} <0>{{count}}</0> files from <1>{{path}}</1> to <2>{{to}}</2>": "将 <0>{{count}}</0> 个文件从 <1>{{path}}</1> {{verb}}到 <2>{{to}}</2>",
            "An item with the name <0>{{name}}</0> is already in this location.<1/>Do you want to overwrite it with the target file?": "该位置已存在名为<0>{{name}}</0>的项目。<1/>是否用目标文件覆盖？",
            "Delete completely from Photo": "将从照片中彻底删除",
            "Upload Failed.": "上传失败。",
            "Upload failed.": "上传失败。",
            "<0>{{date}} (24 hours) </0> schedule is complete, or there is not enough<br />blank time than video duration.<br />If you want to add a schedule, please manual schedule it.": "<0>{{date}}（24 小时）</0> 的编排已全部完成，或相较于视频时长<br />剩余的空白时间不足。<br />如需添加计划，请手动编排。",
            "{{count}} fields auto-filled": "已自动填充 {{count}} 个字段",
            "The current workflow can be saved as a draft, but some connection structures are invalid, which may cause issues when running.": "当前工作流可以保存为草稿，但某些连接结构无效，运行时可能会出现问题。",
            "You can save the current workflow, but saving your changes will cancel <0>{{queuedCount}} queued executions</0>.": "您可以保存当前工作流，但保存更改将取消 <0>{{queuedCount}} 个排队中的执行</0>。",
            "The current workflow has items that need to be resolved and cannot be saved. Please fix the items below and save again.": "当前工作流存在需要解决的问题，无法保存。\n请修复以下问题后重新保存。",
            "Add at least one task.": "请至少添加一个任务。",
            "User list export has been requested.": "已请求导出用户列表。",
            "Failed to export the user list.": "用户列表导出失败。",
            "This setting may take some time to take effect after being changed, and the status cannot be changed again while it is being applied.": "该设置更改后可能需要一段时间才能生效，且在应用期间无法再次更改状态。",
            "This setting is currently being applied. You can change it again after it takes effect.": "当前设置正在应用中。生效后可以再次更改。",
            "Please select {{type}}.": "请选择 {{type}}。",
            "Please select a step.": "请选择一个步骤。",
            "Select a step node.": "选择步骤节点。",
            "No available step": "没有可用的步骤",
            "Up to 5 parallel steps.": "最多支持5个并行步骤。",
            "Drag anywhere to move the canvas.": "拖动任意位置以移动画布。",
            "The step tree for workflow \"{{name}}\" has been updated.": "工作流 \"{{name}}\" 的步骤树已更新。",
            "Input conditions are not satisfied by upstream steps.": "输入条件不满足上游步骤的要求。",
            "This may take some time to apply, depending on the amount of data.": "根据数据量的不同，应用可能需要一些时间。",
            "You have no permission to view this page.": "您没有权限查看此页面。",
            "Attribution cannot be empty.<0/>Please enter a valid attribution.": "\"署名\" 不能为空。<0/>请输入有效的署名。",
            "\"Tags\" can be up to 30.": "\"标签\" 最多可添加30个。",
            "\"Tags\" can be up to {{count}}.": "\"标签\" 最多可添加 {{count}} 个。",
            "ㆍCIDR : xxx.xxx.xxx.xxx/yy\n \n \n ㆍseparate by newlines": "ㆍCIDR : xxx.xxx.xxx.xxx/yy\n \n \n ㆍ以换行分隔",
            "Add file by drag and drop or double-clicking in the select sources.": "通过拖放或双击所选来源来添加文件。",
            "A maximum of 2 streams can be selected.": "最多可选择2个流。",
            "A one schedules can be selected.": "只能选择一个计划。",
            "Access denied.": "访问被拒绝。",
            "An error occured while trying to analyze the asset": "尝试分析资产时发生错误",
            "An attempt to 'Archive' failed. Please try again.": "\"归档\" 操作失败，请重试。",
            "An attempts to change the status from 'Active' to 'Inactive' failed. Please try again.": "将状态从 \"活跃\" 更改为 \"非活跃\" 的操作失败，请重试。",
            "Analyzed automatically labels objects, concepts and scenes in video.": "自动标记视频中的对象、概念和场景。",
            "And {{count}} Other - Total {{total}}": "以及 {{count}} 个其他 - 共计 {{total}}",
            "Approve the channel after creation": "创建后批准频道",
            "Are you sure ? You won't be able to revert this!": "您确定吗？此操作无法撤销！",
            "Are you sure you delete the selected lineups?": "您确定要删除所选节目单吗？",
            "Are you sure you want to approve the selected?": "您确定要批准所选内容吗？",
            "Are you sure you want to cancel the request the selected?": "您确定要取消所选内容的请求吗？",
            "Are you sure you want to cancel the return the selected?": "您确定要取消所选内容的退回吗？",
            "Are you sure you want to delete": "您确定要删除",
            "Are you sure you want to delete <0>{{name}} ({{id}})</0>?": "您确定要删除 <0>{{name}} ({{id}})</0> 吗？",
            "Are you sure you want to delete <0>{{name}}</0>?": "您确定要删除 <0>{{name}}</0> 吗？",
            "Are you sure you want to reclaim the selected?": "您确定要收回所选内容吗？",
            "Are you sure you want to reject the request?": "您确定要拒绝该请求吗？",
            "Are you sure you want to request the selected?": "您确定要请求所选内容吗？",
            "Are you sure you want to return the selected?": "您确定要退回所选内容吗？",
            "Automatically detects explicit adult content in video.": "自动检测视频中的明显成人内容。",
            "Automatically recognizes celebrities in video.": "自动识别视频中的名人。",
            "Base video file can be set only for english without special characters and spaces.": "基础视频文件只能设置为不含特殊字符和空格的英文。",
            "Base video file to be used for the channel can be set only for English without special characters and spaces. (Allowed special characters: ~! () _-.)": "频道使用的基础视频文件只能设置为不含特殊字符和空格的英文。（允许的特殊字符：~! () _-.)",
            "Bucket name must be between 3 and 63 letters and start with alphabet or number with allowed special characters of -, _, and .)": "Bucket 名称长度须在3到63个字符之间，以字母或数字开头，允许使用特殊字符 -、_ 和 .）",
            "Cannot apply because no schema is set": "未设置架构，无法应用",
            "Cannot apply because the schema is different": "架构不同，无法应用",
            "Cannot create a job": "无法创建任务",
            "CloudPlex Media subtitle editor works with the platform to provide flexible workflows from subtitle registration to publishing.<0/>Quickly create subtitles with user experience-based UI.": "CloudPlex Media 字幕编辑器与平台协同工作，提供从字幕注册到发布的灵活工作流。<0/>通过基于用户体验的UI快速创建字幕。",
            "Deleted output assets will be kept for the specified days": "已删除的输出资产将保留指定天数",
            "Do not have an account yet?": "还没有账户？",
            "Do you really want to change?": "您真的要更改吗？",
            "Do you really want to delete it?": "您真的要删除吗？",
            "Drag and drop a file here": "将文件拖放到此处",
            "Drag your files to upload": "将文件拖到此处上传",
            "Duplicate key. The key must be unique.": "键值重复，键必须唯一。",
            "Duplicate values. This field must be unique.": "值重复，此字段必须唯一。",
            "Every month on the": "每月第",
            "Every month on the {{interval}} days": "每月第 {{interval}} 天",
            "Every months on": "每月",
            "Every weeks on": "每周",
            "Failed to get file information from the url.": "无法从该URL获取文件信息。",
            "Reindexing has been requested.": "已请求重新索引。",
            "AI search indexing failed.": "AI 搜索索引失败。",
            "AI search indexing is not supported for this asset.": "此资产不支持 AI 搜索索引。",
            "This is an unsupported media type.": "不支持的媒体类型。",
            "This is an unsupported source format.": "不支持的源格式。",
            "This image is smaller than the minimum size (128x128 pixels).": "此图片小于最小尺寸（128x128 像素）。",
            "This image exceeds the maximum file size (5 MiB).": "此图片超过最大文件大小（5 MiB）。",
            "This video exceeds the maximum file size (6 GB).": "此视频超过最大文件大小（6 GB）。",
            "This video exceeds the maximum duration (4 hours).": "此视频超过最长时长（4 小时）。",
            "Failed to prepare indexing.": "索引准备失败。",
            "Failed to extract metadata.": "元数据提取失败。",
            "Failed to create the source.": "源创建失败。",
            "Failed to check source support.": "源支持情况确认失败。",
            "Failed to analyze the source.": "源分析失败。",
            "Failed to analyze metadata.": "元数据分析失败。",
            "Failed to create the search index.": "搜索索引创建失败。",
            "An internal error occurred.": "发生内部错误。",
            "AI search indexing is in progress.": "AI 搜索索引正在进行中。",
            "This analysis failed.": "此分析失败。",
            "This analysis is outside the supported range.": "此分析超出支持范围。",
            "This analysis was only partially indexed.": "此分析仅部分编入索引。",
            "Only part of the source was analyzed.": "仅分析了部分源。",
            "Only some index entries were created.": "仅创建了部分索引项。",
            "Some parts were not indexed, so this asset may not appear in all AI search results.": "部分内容未编入索引，可能不会出现在所有 AI 搜索结果中。",
            "Click the button on the badge to retry.": "点击徽章上的按钮即可重试。",
            "You can find this asset in AI search.": "可以在 AI 搜索中找到该资产。",
            "Assets that have not finished indexing may not appear in AI search results.": "尚未完成索引的资产可能不会出现在 AI 搜索结果中。",
            "No results for \"{{keyword}}\".": "没有与「{{keyword}}」相关的结果。",
            "Depending on indexing status, some assets may not appear in AI search results.": "根据索引状态，部分资产可能不会出现在搜索结果中。",
            "The index is already up to date.": "索引已是最新状态。",
            "Failed to request reindexing.": "重新索引请求失败。",
            "Granted roles will be deleted.": "已授予的角色将被删除。",
            "Has scheduled lineups.": "已有已计划的节目单。",
            "Hi, {{name}}": "您好，{{name}}",
            "http(s)://~ or s3://~": "http(s)://~ 或 s3://~",
            "Hyper Browser is an enterprise cloud storage client.<0/>Accelerate a variety of workloads with a multi-CDN integration environment and powerful features such as multi-part upload/download, purge and pre-patch.": "Hyper Browser 是一款企业级云存储客户端。<0/>通过多CDN集成环境以及分段上传/下载、清除和预热等强大功能，加速各种工作负载。",
            "If \\\"program duration\\\" is more than \\\"24 hours\\\", you can not repeat the schedule.": "如果 \\\"节目时长\\\" 超过 \\\"24小时\\\"，则无法重复排期。",
            "If it is not the scheduled time, it automatically changes the state of the channel to 'Idle'.": "如果不在计划时间内，频道状态将自动更改为 \"空闲\"。",
            "If the value is the same, next event has the highest priority": "如果值相同，则下一个事件具有最高优先级",
            "If you are not a member yet, please sign up and use.": "如果您尚未成为会员，请先注册后使用。",
            "If you delete <0>{{name}}</0>, it will also be removed from Related the videos.": "如果您删除 <0>{{name}}</0>，它也将从相关视频中移除。",
            "If you delete <0>{{deleteLineupTargetName}}</0>, only future events including this one will be deleted.": "如果您删除 <0>{{deleteLineupTargetName}}</0>，则将删除包括此次在内的所有未来事件。",
            "If you delete <0>{{name}}</0>, only future events including this one will be deleted.<1/>Are you sure you want to delete <0>{{name}}</0>?": "如果您删除 <0>{{name}}</0>，则将删除包括此次在内的所有未来事件。<1/>您确定要删除 <0>{{name}}</0> 吗？",
            "If you delete <0>{{name}}</0>, the scheduled lineups will be deleted together.<1/>Are you sure you want to delete <0>{{name}}</0>?": "如果您删除 <0>{{name}}</0>，已计划的节目单将一并删除。<1/>您确定要删除 <0>{{name}}</0> 吗？",
            "If you delete a lineup that is set to repeat, all future schedule will be deleted.": "如果您删除设置为重复的节目单，所有未来的排期都将被删除。",
            "If you have a problem with your account, or would like to use the cloud <0/>Platform, please contact our sales team. We'll assist you with more details.": "如果您的账户有问题，或希望使用云 <0/>平台，请联系我们的销售团队，我们将为您提供更多详情。",
            "If you have any problem using the stage,<0/> please contact Megazone.": "如果您在使用该阶段时遇到问题，<0/>请联系 Megazone。",
            "If you have any problem using this space,<0/> please contact Megazone Cloud.": "如果您在使用此空间时遇到问题，<0/>请联系 Megazone Cloud。",
            "If you want to access this page, please contact your administrator.": "如需访问此页面，请联系您的管理员。",
            "Indexing faces and get a complete analysis of facial attributes, <0/>including confidence scores.": "对人脸进行索引并获取完整的面部属性分析，<0/>包括置信度评分。",
            "Ingest path setting for pipeline is required. Please contact your manager.": "管道的摄取路径设置为必填项，请联系您的管理员。",
            "Input assets will be automatically deleted after specified days": "输入资产将在指定天数后自动删除",
            "Input name is required.": "输入名称为必填项。",
            "Internal server error": "内部服务器错误",
            "Invalid CIDR. It must be in pattern of xxx.xxx.xxx.xxx/zz.": "无效的CIDR，必须符合 xxx.xxx.xxx.xxx/zz 格式。",
            "Invalid upload path": "无效的上传路径",
            "Multiple image files can be selected.": "可以选择多个图像文件。",
            "No {{name}} is set.<0/>Please set the {{name}} and try again.": "未设置 {{name}}。<0/>请设置 {{name}} 后重试。",
            "No {{name}} searched.": "未找到 {{name}}。",
            "No members is granted": "未授予任何成员",
            "No aduits is granted.": "未授予任何审核员。",
            "No role is granted": "未授予任何角色",
            "One stream can be selected.": "只能选择一个流。",
            "Page not found": "页面未找到",
            "This page is not supported on mobile.": "此页面不支持移动端。",
            "Please use the button below to go back to the previous page.": "请使用下方按钮返回上一页。",
            "Path was not created. Please set again.": "路径未创建，请重新设置。",
            "Pending to upload...": "等待上传中...",
            "Please add a caption to use.": "请添加字幕以使用。",
            "Please add a custom field to use.": "请添加自定义字段以使用。",
            "Please add a poster assets to use.": "请添加海报资产以使用。",
            "Please add images to use.": "请添加图片以使用。",
            "Please add people images.": "请添加人物图片。",
            "Please check and try again": "请检查后重试",
            "Please check the support format and try again.": "请检查支持的格式后重试。",
            "Please check valid single IP, IP range or CIDR.": "请检查有效的单个IP、IP范围或CIDR。",
            "Please contact your stage administrator to access the project.": "请联系您的阶段管理员以访问项目。",
            "Please go back to the main with the button below.": "请使用下方按钮返回主页。",
            "Please select a file to add": "请选择要添加的文件",
            "Please select a file to add.": "请选择要添加的文件。",
            "Please select a valid file.": "请选择有效的文件。",
            "Please select the project of the stage you want to access.": "请选择您想访问的阶段所属项目。",
            "Please try again.": "请重试。",
            "Prefix cannot be empty": "前缀不能为空",
            "Prefix must begin with s3://": "前缀必须以 s3:// 开头",
            "Remove connected medialive input.": "移除已连接的 medialive 输入。",
            "Request a channel approval after creation": "创建后申请频道审批",
            "Save the origin source as an asset": "将原始来源保存为资产",
            "Schedule repeat can not be modified after setting. (Repeated lineups can only be deleted)": "排期重复设置后不可修改。（重复的节目单只能删除）",
            "Search for faces in the video using saved face information.": "使用已保存的人脸信息在视频中搜索人脸。",
            "Select a metadata": "选择元数据",
            "Select AI analysis item": "选择AI分析项目",
            "Select an face to analyze <0/>From the list of registered images on the left.": "选择要分析的人脸 <0/>从左侧已注册图像列表中选择。",
            "Select an face to index <0/>From the list of registered images on the left.": "选择要索引的人脸 <0/>从左侧已注册图像列表中选择。",
            "Select files from the image type of assets.": "从资产的图像类型中选择文件。",
            "Select one caption file.": "选择一个字幕文件。",
            "Source must be selected in order to request a channel approval.": "申请频道审批前必须先选择来源。",
            "Source selection is done after channel creation": "来源选择在频道创建后进行",
            "Special chacters are not allowed": "不允许使用特殊字符",
            "Special chacters can not be entered.": "不能输入特殊字符。",
            "The \\\"End time\\\" must be later than \\\"Start time\\\"": "\\\"结束时间\\\" 必须晚于 \\\"开始时间\\\"",
            "The \\\"Loop To Fill Lineup Duration\\\" setting applies only when the duration of the video is more than \\\"1 minute\\\".": "\\\"循环填充节目单时长\\\" 设置仅适用于视频时长超过 \\\"1分钟\\\" 的情况。",
            "The asset list is missing.": "资产列表缺失。",
            "The asset is only MP4 type video.": "该资产仅支持MP4类型的视频。",
            "The base video is applied only when the source type is schedules": "基础视频仅在来源类型为计划时适用",
            "The begin date time can not be past time.": "开始日期时间不能为过去时间。",
            "The begin date time must be registered after 2 minutes on the current time basis.": "开始日期时间必须在当前时间基础上2分钟后注册。",
            "The changed roles will be applied to users below.": "变更的角色将应用于以下用户。",
            "The comment field can be up to {{byte}} byte long.": "评论字段最多可输入 {{byte}} 字节。",
            "The description can be up to {{byte}} byte": "描述最多可输入 {{byte}} 字节",
            "The description field can be up to {{limit}} byte long.": "描述字段最多可输入 {{limit}} 字节。",
            "The file is not valid.": "该文件无效。",
            "The file source list is missing.": "文件来源列表缺失。",
            "The lineup Name field be up to {{name}} byte long.": "节目单名称字段最多可输入 {{name}} 字节。",
            "The lineup priority field is greater than 0 and less than 100.": "节目单优先级字段的值须大于0且小于100。",
            "The name field be up to {{title}} byte long.": "名称字段最多可输入 {{title}} 字节。",
            "The name field can be up to {{limit}} byte long.": "名称字段最多可输入 {{limit}} 字节。",
            "The name field is required": "名称字段为必填项",
            "The page you requested could not be found.": "您请求的页面无法找到。",
            "The same file could not be found": "未找到相同的文件",
            "The selected Whitelist rules can be modified.": "所选白名单规则可以修改。",
            "The team has no members.": "该团队没有成员。",
            "The value field be up to {{tag}} byte long.": "值字段最多可输入 {{tag}} 字节。",
            "There is an event in the listing or a linked channel, so you can not delete that stream": "该流在列表中存在事件或已关联频道，无法删除",
            "There is no analyzable item. Only non-DRM MP4 types are supported for analysis.": "没有可分析的项目。分析仅支持非DRM的MP4类型。",
            "There is no input to select.": "没有可选择的输入。",
            "There is no schedules to select.": "没有可选择的计划。",
            "There is no project available to access.": "没有可访问的项目。",
            "There is work in progress. Would you really go out?": "有正在进行中的工作，确定要离开吗？",
            "{{count}} upload(s) transferring — do not close or reload this page": "{{count}} 项上传传输中 — 请勿关闭或刷新此页面",
            "Processing continues on the server.": "后续处理将在服务器端继续进行。",
            "Moving between menus or closing this panel is fine.": "切换菜单或关闭此面板不会有影响。",
            "{{count}} upload(s) transferred — you can close this page": "{{count}} 项上传传输完成 — 现在可以关闭此页面",
            "Uploading. Do not close or refresh this page.": "正在上传，请勿关闭或刷新此页面。",
            "There is work in progress. Would you really leave the page?": "有正在进行中的工作，确定要离开此页面吗？",
            "There was either CORS or network error.": "发生了CORS或网络错误。",
            "This field can be up to {{maxByte}} bytes.": "此字段最多可输入 {{maxByte}} 字节。",
            "This field must pass today's datetime.": "此字段必须通过今天的日期时间。",
            "This file format is not supported.": "不支持此文件格式。",
            "This is not a valid URL pattern.": "这不是有效的URL格式。",
            "This schedules has updated information.<0/>Please refresh and try again. Do you want to refresh now?": "此计划已有更新信息。<0/>请刷新后重试。是否立即刷新？",
            "This stage is not accessible.": "此阶段无法访问。",
            "This space is not accessible.": "此空间无法访问。",
            "This whitelist field is required.": "此白名单字段为必填项。",
            "To request a channel approval, you must select a source.": "申请频道审批前，您必须选择来源。",
            "View only <0>requested channels</0>": "仅查看 <0>已申请的频道</0>",
            "We're sorry!": "非常抱歉！",
            "You can enter up to {{count}} whitelist rules": "您最多可以输入 {{count}} 条白名单规则",
            "You can only enter {{count}} whitelist rules": "您只能输入 {{count}} 条白名单规则",
            "You can upload files up to 500KB in size.": "您可以上传最大500KB的文件。",
            "You can watch preview for 1 minute": "您可以观看1分钟的预览",
            "You do not have permission to access.": "您没有访问权限。",
            "You don't have any {{name}} to select.": "您没有可选择的 {{name}}。",
            "You don't have permission to view this page.": "您没有权限查看此页面。",
            "You need to sign in a Megazone Accounts account to get started.": "您需要登录 Megazone Accounts 账户才能开始使用。",
            "Inactivated by error": "因错误而停用",
            "Error while inactivating": "停用时发生错误",
            "Error while activating": "激活时发生错误",
            "An attempt to 'Archive' failed.": "\"归档\" 操作失败。",
            "An attempt to 'Restore' failed. Please try again.": "\"还原\" 操作失败，请重试。",
            "Please select a project you want to access.": "请选择您想访问的项目。",
            "You have no site access.": "您没有站点访问权限。",
            "There is already a folder with the same name. Please change it to a different name.": "已存在同名文件夹，请更改为其他名称。",
            "{{target}} names can’t contain “/”.": "{{target}} 名称不能包含 \"/\"。",
            "There is already a {{target}} with the same name. Please change it to a different name.": "已存在同名的 {{target}}，请更改为其他名称。",
            "deleteModalReferenceNesting1": "$t(common::msg::deleteModalReferenceKey1)<1/>$t(common::msg::deleteModalReferenceKey3)",
            "deleteModalReferenceNesting2": "$t(common::msg::deleteModalReferenceKey2)<1/>$t(common::msg::deleteModalReferenceKey3)",
            "deleteModalReferenceKey1": "如果您删除 <0>{{name}}</0>，它也将从引用中移除，且此操作无法撤销{{dot}}",
            "deleteModalReferenceKey2": "如果您删除 <0>{{name}}</0>，此操作无法撤销{{dot}}",
            "deleteModalReferenceKey3": "您确定要删除 <0>{{name}}</0> 吗？",
            "Don’t ask again": "不再询问",
            "Deleting {{currentIndex}} of {{deleteItemLength}}": "正在删除第 {{currentIndex}} / {{deleteItemLength}} 项",
            "You have selected <0>{{name}}</0>": "您已选择 <0>{{name}}</0>",
            "Remove from category <0>{{name}}</0>": "从类别 <0>{{name}}</0> 中移除",
            "Delete completely from Assets": "从资产中彻底删除",
            "It will also be removed from Reference and you won’t be able to revert this.": "它也将从引用中移除，且此操作无法撤销。",
            "If you archive the asset, you will be charged <0>the 90-day</0> archive amount immediately.": "如果您归档该资产，将立即产生 <0>90天</0> 的归档费用。",
            "Are you sure you want to archive?": "您确定要归档吗？",
            "If you restore the Archived Asset, You will be charged for the <0>remaining {{remainingDays}} days.</0>": "如果您还原已归档的资产，将产生 <0>剩余 {{remainingDays}} 天</0> 的费用。",
            "Are you sure you want to restore?": "您确定要还原吗？",
            "Of the <0>{{currentDate}}</0> schedule, <0>only {{lineupCount}}</0> excluding the repeat lineup will be a all Copy to. Lineups with repeat lineups are excluded from the all copy to.": "在 <0>{{currentDate}}</0> 的排期中，<0>仅 {{lineupCount}} 个</0>不含重复节目单的节目单将被全部复制。含重复节目单的节目单不在全部复制范围内。",
            "Are you sure you all copy to?": "您确定要全部复制吗？",
            "There is a schedule on that date and it cannot be selected.<0/>Please delete the schedule for the selected date or select a different date.": "该日期已有排期，无法选择。<0/>请删除所选日期的排期或选择其他日期。",
            "The <0> {{lineupCount}} lineups </0> included in the <0>{{currentDate}}</0> schedule will be all Copy to. <1/>However, the repeat lineups of the selected lineup will stop repeating this and future schedules.": "<0>{{currentDate}}</0> 排期中包含的 <0>{{lineupCount}} 个节目单</0> 将被全部复制。<1/>但是，所选节目单的重复节目单将停止本次及未来的重复排期。",
            "<0>{{x}}</0> day(s) remaining": "剩余 <0>{{x}}</0> 天",
            "Past broadcast lineup cannot be deleted.": "过去的广播节目单无法删除。",
            "Lineup currently being broadcast cannot be delete.": "当前正在播出的节目单无法删除。",
            "Schedules within 1 minute from the current time cannot be deleted.": "距当前时间1分钟内的排期无法删除。",
            "If you want All Copy to, lineups with the repeat schedule will stop repeating this and future schedules.": "如果要全部复制，含重复排期的节目单将停止本次及未来的重复排期。",
            "If you want to delete lineups with repeat schedule, you cannot delete the past lineup that was broadcast, but you can delete future Lineups including this one will be deleted.": "如果要删除含重复排期的节目单，无法删除已播出的过去节目单，但可以删除包括本次在内的未来节目单。",
            "Set up a YouTube account to publish.": "请设置YouTube账户以进行发布。",
            "To add the channels of the account you want to publish, sign in to Youtube with that account.": "要添加您要发布的账户频道，请使用该账户登录YouTube。",
            "Duplicate login status.": "重复登录状态。",
            "You are currently logged in from another web browser with your information, the connection is terminated and you are directed to the welcome page.": "您的账户当前正在其他网页浏览器上登录，连接已终止并跳转至欢迎页面。",
            "Your account has been expired.": "您的账户已过期。",
            "Your account has been inactivated.": "您的账户已被停用。",
            "Your account has been deleted.": "您的账户已被删除。",
            "You cannot access the project.<0/>The connection is terminated and you are directed to the welcome page.": "您无法访问该项目。<0/>连接已终止并跳转至欢迎页面。",
            "After starting the channel, you can watch past broadcasts by changing the playback position for up to 14 days.": "频道启动后，您可以通过更改播放位置观看过去14天内的广播。",
            "Find objects by prefix": "按前缀查找对象",
            "A total of <0>{{type}}</0> participants can be invited per account, and participants must be divided into the schedule of the channels to be created.": "每个账户最多可邀请 <0>{{type}}</0> 名参与者，且参与者必须分配到所创建频道的排期中。",
            "Megazone Accounts members, please sign in through the button below.": "Megazone Accounts 会员，请通过下方按钮登录。",
            "Megazone Login users, please sign in through the button below.": "Megazone Login 用户，请通过下方按钮登录。",
            "If you do not have an account yet, please sign up through": "如果您尚未拥有账户，请通过以下方式注册。",
            "If you don’t have an account yet, please ask your Organization Administrator.": "如果您尚未拥有账户，请联系您的组织管理员。",
            "Go to log in with": "使用以下方式登录",
            "You need to sign in a {{Megazone Accounts}} {{or}} {{Megazone Login}} account to get started.": "您需要登录 {{Megazone Accounts}} {{or}} {{Megazone Login}} 账户才能开始使用。",
            "You do not have permission to Show Hidden Metadata.": "您没有权限查看隐藏的元数据。",
            "If you to Show Hidden Metadata, please ask your administration.": "如需查看隐藏的元数据，请联系您的管理员。",
            "Select a one file from the audio type of assets.": "从资产的音频类型中选择一个文件。",
            "Select a one file from the image type of assets.": "从资产的图像类型中选择一个文件。",
            "The key field be up to {{tag}} byte long.": "键字段最多可输入 {{tag}} 字节。",
            "Please add a {{name}} assets to use.": "请添加 {{name}} 资产以使用。",
            "You can't access the space.": "您无法访问该空间。",
            "The space is inaccessible because your account has expired or has been deleted.": "该空间无法访问，因为您的账户已过期或已被删除。",
            "Please contact your space manager.": "请联系您的空间管理员。",
            "If you have issues with Space approval, please contact Megazone Cloud.": "如果您在空间审批方面遇到问题，请联系 Megazone Cloud。",
            "If you want to site access, please contact your space manager.": "如需访问站点，请联系您的空间管理员。",
            "You need access": "您需要访问权限",
            "If you want to check the assets you have selected, <0/> please ask for access.": "如需查看您已选择的资产，<0/>请申请访问权限。",
            "Request sent": "请求已发送",
            "You will receive an email letting you know that <0/> the asset has been shared with you.": "您将收到一封电子邮件，告知您 <0/>该资产已与您共享。",
            "Enter Display Name or Username": "输入显示名称或用户名",
            "This asset has been deleted.": "此资产已被删除。",
            "The deleted asset is removed from the Requested to Share.": "已删除的资产将从共享请求中移除。",
            "If necessary, contact the administrator.": "如有需要，请联系管理员。",
            "Are you sure you want to reject sharing request for <0>{{name}}</0>?": "您确定要拒绝 <0>{{name}}</0> 的共享请求吗？",
            "Reason for rejection of sharing request (optional)": "拒绝共享请求的原因（可选）",
            "There is no analytics data.": "没有分析数据。",
            "Detailed view of <0> {{number}} </0> tasks": "<0> {{number}} </0> 个任务的详细视图",
            "files to the <0>{{name}}</0>": "文件到 <0>{{name}}</0>",
            "An item with the name '<0>{{name}}</0>' is already in this location.": "此位置已存在名称为 '<0>{{name}}</0>' 的项目。",
            "Do you want to overwrite it with the target file?": "是否要用目标文件覆盖它？",
            "Renaming in <0>{{name}}</0>": "正在 <0>{{name}}</0> 中重命名",
            "Moving <0>{{totalCount}}</0> files from the <0>{{sourceFolderName}}</0> to the <0>{{distFolderName}}</0>": "正在将 <0>{{totalCount}}</0> 个文件从 <0>{{sourceFolderName}}</0> 移动到 <0>{{distFolderName}}</0>",
            "Copying <0>{{totalCount}}</0> files from the <0>{{sourceFolderName}}</0> to the <0>{{distFolderName}}</0>": "正在将 <0>{{totalCount}}</0> 个文件从 <0>{{sourceFolderName}}</0> 复制到 <0>{{distFolderName}}</0>",
            "All linked video source assets have been deleted, <0/> so the video preview cannot be seen.": "所有关联的视频源资产已被删除，<0/> 因此无法查看视频预览。",
            "There are no items for video AI analysis.": "没有可用于视频 AI 分析的项目。",
            "Please add music file.": "请添加音乐文件。",
            "Select files from the Audio type of assets.": "从音频类型资产中选择文件。",
            "Cannot change settings from Project Settings.": "无法从项目设置更改设置。",
            "Cannot change settings from Console.": "无法从 Console 更改设置。",
            "Add one caption asset to use.<0/>The kind of caption can only select subtitles.": "请添加一个字幕资产。<0/>字幕类型只能选择字幕（subtitles）。",
            "Select files from the video type of assets.": "从视频类型资产中选择文件。",
            "Please add itemSet for metadata.": "请为元数据添加 ItemSet。",
            "There is no ItemSet to select. Please add a ItemSet.": "没有可选择的 ItemSet。请添加一个 ItemSet。",
            "The caption of the program can be edited in the caption of the <0> {{number}} </0>": "节目的字幕可在 <0> {{number}} </0> 的字幕中编辑",
            "There is a duplicate language among the captions applied to the <0> {{name}} </0>": "应用到 <0> {{name}} </0> 的字幕中存在重复语言",
            "Please create a lineup after editing in the video as it is difficult to create a lineup if there are duplicate languages.": "如果存在重复语言，创建节目单将会很困难，请在视频中编辑后再创建节目单。",
            "Changed data exists. Are you sure you want to escape?": "存在已更改的数据。确定要退出吗？",
            "Add attendees to join the Group Chatting": "添加参与者以加入群组聊天",
            "Enter Email Address": "输入电子邮件地址",
            "Saving of changes to '{{tab}}' failed.": "保存对 '{{tab}}' 的更改失败。",
            "Changes to the '{{tab}}' have been saved.": "对 '{{tab}}' 的更改已保存。",
            "File upload failed.": "文件上传失败。",
            "An invalid input file was selected.": "选择了无效的输入文件。",
            "Asset creation failed.": "资产创建失败。",
            "The input file is in an unsupported format.": "输入文件格式不受支持。",
            "The transcoding operation failed due to an unexpected problem.": "由于意外问题，转码操作失败。",
            "If the problem persists, please contact the management.": "如果问题持续存在，请联系管理员。",
            "Please use a different file after checking the file upload rules.": "请检查文件上传规则后使用其他文件。",
            "Please use a different file after checking the 'Supported File Formats' of the file upload rules.": "请查看文件上传规则中的'支持的文件格式'后使用其他文件。",
            "The media information may not be queried, or an invalid file may have been entered.": "媒体信息可能无法查询，或输入了无效文件。",
            "Use streaming software to send live streams to Amazon IVS, providing users with low-latency live stream services and interactive video experiences.": "使用流媒体软件将直播流发送到 Amazon IVS，为用户提供低延迟直播服务和互动视频体验。",
            "Provides real-time communication components such as online conferencing services by leveraging messaging, audio, video and screen sharing capabilities to web or mobile applications.": "通过将消息、音频、视频和屏幕共享功能应用于 Web 或移动应用，提供在线会议等实时通信组件。",
            "Broadcast and deliver live video in up to Full HD.": "以最高全高清（Full HD）广播和传输直播视频。",
            "Broadcast and deliver live video in up to SD.": "以最高标清（SD）广播和传输直播视频。",
            "Best for near real-time interactions with viewers.": "最适合与观众进行接近实时的互动。",
            "Enable if real-time interactivity with viewers is not required. May improve reliability in certain regions.": "若不需要与观众进行实时互动，可启用此选项。在某些地区可能提高可靠性。",
            "Enable token-authorization requirement for video playback.": "启用视频播放的令牌授权要求。",
            "Channel’s live stream is automatically recorded and created as Videos and Assets.": "频道的直播将自动录制并创建为视频和资产。",
            "A chat where all attendees on the channel can join the chat.": "所有频道参与者均可加入的聊天室。",
            "A chat that allows for close interaction between invited attendees.": "允许受邀参与者进行近距离互动的聊天室。",
            "If the chat type is modified after channel creation, all previously set values are initialized.": "若在频道创建后修改聊天类型，之前设置的所有值将被初始化。",
            "Failed to save changes": "保存更改失败",
            "Search for files in Assets.": "在资产中搜索文件。",
            "You are about to revoke site access for <0>{{name}}</0>.<1/>This user won’t be able to use your space. You can give them access at any time.<1/>Are you sure you want to revoke site access for this user?": "您即将撤销 <0>{{name}}</0> 的站点访问权限。<1/>该用户将无法使用您的空间。您可以随时重新授予访问权限。<1/>确定要撤销此用户的站点访问权限吗？",
            "You are about to remove  <0>{{name}}</0> from space.<1/>This user will no longer have access to the space. Your space will still keep all of this user’s contributions.<1/>Are you sure you want to remove user from space?": "您即将将 <0>{{name}}</0> 从空间中移除。<1/>该用户将不再拥有对该空间的访问权限。您的空间仍将保留该用户的所有贡献。<1/>确定要将用户从空间中移除吗？",
            "Bucket names must be between 3 and 63 characters long.": "存储桶名称长度必须在 3 到 63 个字符之间。",
            "Bucket names can consist only of lowercase letters, numbers, dots (.), and hyphens (-).": "存储桶名称只能由小写字母、数字、点（.）和连字符（-）组成。",
            "Bucket names must begin and end with a letter or number.": "存储桶名称必须以字母或数字开头和结尾。",
            "Bucket names must not be formatted as an IP address (for example, 192.168.5.4).": "存储桶名称不得格式化为 IP 地址（例如 192.168.5.4）。",
            "Bucket names must not start with the prefix xn--.": "存储桶名称不得以前缀 xn-- 开头。",
            "Bucket names must not end with the suffix -s3alias.": "存储桶名称不得以后缀 -s3alias 结尾。",
            "Bucket names cannot have consecutive periods.": "存储桶名称不能包含连续的点。",
            "You can enter up to 10 users.": "最多可输入 10 个用户。",
            "Of the selected assets, {{createItemLength}} out of {{selectedItemLength}} can be created as photos. <1/>Choose whether you want <0>the {{createItemLength}} assets</0> to be multiple photos or a single photo.": "在所选资产中，{{selectedItemLength}} 个中有 {{createItemLength}} 个可创建为照片。<1/>请选择是将 <0>{{createItemLength}} 个资产</0>创建为多张照片还是单张照片。",
            "The {{createItemLength}} selected assets have been selected to be created as multiple photos.<0/>Would you like to create a photo now?": "已选择将 {{createItemLength}} 个所选资产创建为多张照片。<0/>是否立即创建照片？",
            "The photo name is applied to the name being used in the asset, and metadata can be edited in the created photo.": "照片名称将应用资产中使用的名称，元数据可在创建的照片中编辑。",
            "Would you like to log out from the account service as well?": "是否同时退出账户服务的登录？",
            "Conveniently apply to asset types through the Apply All Over option.": "通过'全部应用'选项方便地应用到资产类型。",
            "There is a history of individual modification of some metadata among assets of this asset type.": "此资产类型的部分资产中存在单独修改元数据的历史记录。",
            "If you save, all the changed metadata will be applied.": "保存后，所有已更改的元数据将被应用。",
            "Are you sure you want to fix it though?": "确定还是要修复吗？",
            "When applied, all default metadata is applied.": "应用后，将应用所有默认元数据。",
            "Do you still want to apply?": "确定要应用吗？",
            "Changes made to files in the storage list are not updated here.": "对存储列表中文件所做的更改不会在此处更新。",
            "If you want to change the file, you must close the ‘Create Asset Bulk’ screen and re-enter after making changes in the storage list.": "如需更改文件，必须关闭'批量创建资产'界面，并在存储列表中更改后重新进入。",
            "If the asset contains only one single file": "如果资产只包含一个文件",
            "If the asset contains multiple files": "如果资产包含多个文件",
            "If the language code for the file is appended after the file name (_), the language and label are automatically applied.": "如果文件名后附加了语言代码（_），语言和标签将自动应用。",
            "If the language code is not applied after the file name (_), the language and label are applied in English (United States).": "如果文件名后未附加语言代码（_），语言和标签将以英语（美国）应用。",
            "Add files in the first step, Add Files to Bulk.": "在第一步'批量添加文件'中添加文件。",
            "Language and label are automatically applied language and label.": "语言和标签将自动应用语言和标签。",
            "Language and labels apply in English (United States).": "语言和标签以英语（美国）应用。",
            "Kind default is applied as caption type.": "类型默认应用为字幕类型。",
            "Creation for {{count}} assets requested.": "已请求创建 {{count}} 个资产。",
            "It may take some time for stable processing because it is downloading a file from a location far away from the current location (overseas) or a large file.": "由于正在从距当前位置较远的地方（海外）下载文件或文件较大，稳定处理可能需要一些时间。",
            "If you want to check the file you have selected, <0/> Please contact your space administrator.": "如需查看您所选择的文件，<0/> 请联系您的空间管理员。",
            "If it is an item in the 'Current Project', all functions can be used.": "如果是'当前项目'中的项目，则可使用所有功能。",
            "If it is an accessible 'Not Accessible' item, all functions cannot be used.": "如果是'无法访问'的项目，则无法使用所有功能。",
            "If it is an accessible 'other project' item, you can use the download function.": "如果是可访问的'其他项目'项目，则可使用下载功能。",
            "To check the folder, select the project to which the bucket the folder<0/>belongs to, and then switch the site to the selected project.": "要查看文件夹，请选择该文件夹<0/>所属存储桶的项目，然后将站点切换到所选项目。",
            "Are you sure you want to check the folder<0/>after switching to the selected project?": "切换到所选项目后，<0/>确定要查看文件夹吗？",
            "Download period is up to <0>{{totalCount}}</0> days, and the number of downloads is up to <0>{{sourceFolderName}}</0> times.": "下载期限最长为 <0>{{totalCount}}</0> 天，下载次数最多为 <0>{{sourceFolderName}}</0> 次。",
            "The download period is up to <0> {{number}} </0> days.": "下载期限最长为 <0> {{number}} </0> 天。",
            "The number of downloads is up to <0/> times.": "下载次数最多为 <0/> 次。",
            "The download period is up to <0>{{period}}</0> days,<1/>and the number of downloads is up to <0>{{count}}</0> times left.": "下载期限最长为 <0>{{period}}</0> 天，<1/>剩余下载次数最多为 <0>{{count}}</0> 次。",
            "The password is wrong <0>{{count}}</0> times. Please check the password.": "密码错误 <0>{{count}}</0> 次。请检查密码。",
            "In case of error <0>{{count}}</0> times, the download link URL is no longer available.": "错误 <0>{{count}}</0> 次后，下载链接 URL 将不再可用。",
            "If you want to continue downloading,<0/>please get the download link URL back.": "如需继续下载，<0/>请重新获取下载链接 URL。",
            "The requested page may have disappeared or the path may be incorrect.<0/>Please check and try again.": "请求的页面可能已消失或路径不正确。<0/>请检查后重试。",
            "The download period is up to <0>{{period}}</0> days.": "下载期限最长为 <0>{{period}}</0> 天。",
            "up to <0/> times.": "最多 <0/> 次。",
            "Are you sure you want to approval the selected<0/><1>{{name}}</1>?": "确定要批准所选的<0/><1>{{name}}</1>吗？",
            "Are you sure you want to reject the selected<0/><1>{{name}}</1>?": "确定要拒绝所选的<0/><1>{{name}}</1>吗？",
            "If you remove <0>{{name}}</0>, the item is deleted from the view.": "如果移除 <0>{{name}}</0>，该项目将从视图中删除。",
            "Other users will still have access.": "其他用户仍可访问。",
            "Are you sure you want to remove the item?": "确定要移除该项目吗？",
            "If you remove <0>{{number}}</0> other then <0>{{name}}</0>, the items is deleted from the view.": "如果移除除 <0>{{name}}</0> 以外的 <0>{{number}}</0> 个项目，这些项目将从视图中删除。",
            "Are you sure you want to remove the items?": "确定要移除这些项目吗？",
            "Also, all shared users will no longer have access and will be removed from the shared list.": "此外，所有共享用户将不再拥有访问权限，并将从共享列表中移除。",
            "Select the folder path. If not specified, it is stored in the top-level path.": "选择文件夹路径。如未指定，将存储在顶层路径中。",
            "The folder path of the asset is a virtual path specified by the user and is different from the actual S3 folder path.": "资产的文件夹路径是用户指定的虚拟路径，与实际 S3 文件夹路径不同。",
            "Deleting {{currentIndex}} of <0>{{deleteItemLength}}</0> assets": "正在删除 <0>{{deleteItemLength}}</0> 个资产中的第 {{currentIndex}} 个",
            "If you delete <0>{{name}}</0>, you won’t be able to revert this.<1/>Are you sure you want to delete?": "如果删除 <0>{{name}}</0>，将无法恢复。<1/>确定要删除吗？",
            "If you delete <0>{{name}}</0>,  will also be removed from reference and you won’t be able to revert this.<1/>Are you sure you want to delete?": "如果删除 <0>{{name}}</0>，该项目也将从引用中移除且无法恢复。<1/>确定要删除吗？",
            "The download period is up to <0>{{period}}</0> days left.": "下载期限剩余最多 <0>{{period}}</0> 天。",
            "File {{item}} has been shared": "文件 {{item}} 已共享",
            "Asset {{item}} has been shared": "资产 {{item}} 已共享",
            "There was an error removing file {{item}}": "移除文件 {{item}} 时出错",
            "There was an error removing asset {{item}}": "移除资产 {{item}} 时出错",
            "Discard unsaved changes?": "放弃未保存的更改？",
            "Asset {{item}} and {{length}} other items have been removed.": "资产 {{item}} 和其他 {{length}} 个项目已被移除。",
            "File {{item}} and {{length}} other items have been removed.": "文件 {{item}} 和其他 {{length}} 个项目已被移除。",
            "Asset {{item}} has been removed.": "资产 {{item}} 已被移除。",
            "File {{item}} has been removed.": "文件 {{item}} 已被移除。",
            "There was an error removing file {{item}} and {{length}} other items.": "移除文件 {{item}} 和其他 {{length}} 个项目时出错。",
            "There was an error removing asset {{item}} and {{length}} other items.": "移除资产 {{item}} 和其他 {{length}} 个项目时出错。",
            "There was an error removing file {{item}}.": "移除文件 {{item}} 时出错。",
            "There was an error removing asset {{item}}.": "移除资产 {{item}} 时出错。",
            "There was an error sharing file {{item}}.": "共享文件 {{item}} 时出错。",
            "There was an error sharing asset {{item}}.": "共享资产 {{item}} 时出错。",
            "Since this is a category group that is not used in assets, you can check the created assets in 'categories not classified in assets'.": "由于这是资产中未使用的类别群组，您可以在'资产中未分类的类别'中查看已创建的资产。",
            "There was an error deleting folder {{item}}.": "删除文件夹 {{item}} 时出错。",
            "Deletion of folder {{item}} has been completed.": "文件夹 {{item}} 删除完成。",
            "Creation of new folder {{item}} is completed.": "新文件夹 {{item}} 创建完成。",
            "There was an error creating the new folder {{item}}.": "创建新文件夹 {{item}} 时出错。",
            "If you delete <0>{{name}}</0>, you won't be able to revert this.": "如果删除 <0>{{name}}</0>，将无法恢复。",
            "Sync requested.": "同步请求已发送。",
            "If you archive the asset, you will be charged the <0>90-day</0> archive<1/> amount immediately.<1/>Are you sure you want to archive?": "如果归档该资产，将立即收取 <0>90 天</0>归档<1/> 费用。<1/>确定要归档吗？",
            "Move completed from {{item1}} to {{item2}}.": "从 {{item1}} 移动到 {{item2}} 完成。",
            "Moved '{{item1}}' into '{{item2}}'.": "已将“{{item1}}”移动到“{{item2}}”中。",
            "Failed to save the folder order change. Reverted to the original state.": "文件夹顺序变更保存失败。已恢复为原始状态。",
            "Failed to save the folder move. Reverted to the original state.": "文件夹移动保存失败。已恢复为原始状态。",
            "Refreshing the folder tree. Please try again.": "正在将文件夹树更新为最新信息，请重试。",
            "Error moving from {{item1}} to {{item2}}.": "从 {{item1}} 移动到 {{item2}} 时出错。",
            "Error renaming from {{item1}} to {{item2}}.": "将 {{item1}} 重命名为 {{item2}} 时出错。",
            "This folder contains assets.": "此文件夹包含资产。",
            "Rename completed from {{item1}} to {{item2}}.": "将 {{item1}} 重命名为 {{item2}} 完成。",
            "The sharing period for this file has expired. <0/> If you want to check the file you have selected, <0/> Please ask the sharer to share.": "此文件的共享期限已过期。<0/> 如需查看您所选择的文件，<0/> 请要求共享者重新共享。",
            "There was an error creating event trigger.": "创建事件触发器时出错。",
            "Error deleting asset '{{name}}'. {{line}} Please refresh the page and try again.": "删除资产 '{{name}}' 时出错。{{line}} 请刷新页面后重试。",
            "Asset '{{name}}' has been deleted.": "资产 '{{name}}' 已删除。",
            "Error deleting asset '{{name}}' and {{count}} others. {{line}} Please refresh the page and try again.": "删除资产 '{{name}}' 和其他 {{count}} 个时出错。{{line}} 请刷新页面后重试。",
            "Asset '{{name}}' and {{count}} other assets have been deleted.": "资产 '{{name}}' 和其他 {{count}} 个资产已删除。",
            "Error archiving asset '{{name}}'. {{line}} Please refresh the page and try again.": "归档资产 '{{name}}' 时出错。{{line}} 请刷新页面后重试。",
            "Asset '{{name}}' has been restored.": "资产 '{{name}}' 已恢复。",
            "Error restoring asset '{{name}}'. {{line}} Please refresh the page and try again.": "恢复资产 '{{name}}' 时出错。{{line}} 请刷新页面后重试。",
            "Error saving changes to {{resource}} settings. {{line}} Please refresh the page and try again.": "保存 {{resource}} 设置更改时出错。{{line}} 请刷新页面后重试。",
            "Changes to your {{resource}} settings have been saved.": "{{resource}} 设置更改已保存。",
            "Event trigger '{{name}}' has been added.": "事件触发器 '{{name}}' 已添加。",
            "You don't have access. {{line}} Please contact the manager.": "您没有访问权限。{{line}} 请联系管理员。",
            "Error adding asset '{{name}}'. {{line}} Please refresh the page and try again.": "添加资产 '{{name}}' 时出错。{{line}} 请刷新页面后重试。",
            "Error adding asset '{{name}}' and {{count}} others. {{line}} Please refresh the page and try again.": "添加资产 '{{name}}' 和其他 {{count}} 个时出错。{{line}} 请刷新页面后重试。",
            "Asset '{{name}}' has been added.": "资产 '{{name}}' 已添加。",
            "Asset '{{name}}' and {{count}} other assets have been added.": "资产 '{{name}}' 和其他 {{count}} 个资产已添加。",
            "The access of asset '{{name}}' has been updated to private.": "资产 '{{name}}' 的访问权限已更新为私有。",
            "The access of asset '{{name}}' has been updated to public.": "资产 '{{name}}' 的访问权限已更新为公开。",
            "Error updating asset '{{name}}' with access to private. {{line}} Please refresh the page and try again.": "将资产 '{{name}}' 访问权限更新为私有时出错。{{line}} 请刷新页面后重试。",
            "Error updating asset '{{name}}' with access to public. {{line}} Please refresh the page and try again.": "将资产 '{{name}}' 访问权限更新为公开时出错。{{line}} 请刷新页面后重试。",
            "Event trigger '{{name}}' has been deleted.": "事件触发器 '{{name}}' 已删除。",
            "Error deleting event trigger '{{name}}'. {{line}} Please refresh the page and try again.": "删除事件触发器 '{{name}}' 时出错。{{line}} 请刷新页面后重试。",
            "The name has been updated.": "名称已更新。",
            "Attributions has been updated.": "归属信息已更新。",
            "Tags has been updated.": "标签已更新。",
            "Error updating the name. {{line}} Please refresh the page and try again.": "更新名称时出错。{{line}} 请刷新页面后重试。",
            "Error updating the description. {{line}} Please refresh the page and try again.": "更新描述时出错。{{line}} 请刷新页面后重试。",
            "Error updating attributions. {{line}} Please refresh the page and try again.": "更新归属信息时出错。{{line}} 请刷新页面后重试。",
            "Error updating Tags. {{line}} Please refresh the page and try again.": "更新标签时出错。{{line}} 请刷新页面后重试。",
            "Error updating status to active. {{line}} Please refresh the page and try again.": "将状态更新为活跃时出错。{{line}} 请刷新页面后重试。",
            "Error updating status to inactive. {{line}} Please refresh the page and try again.": "将状态更新为非活跃时出错。{{line}} 请刷新页面后重试。",
            "Error updating conditions. {{line}} Please refresh the page and try again.": "更新条件时出错。{{line}} 请刷新页面后重试。",
            "Error updating Actions. {{line}} Please refresh the page and try again.": "更新动作时出错。{{line}} 请刷新页面后重试。",
            "Status updated to active.": "状态已更新为活跃。",
            "Status updated to inactive.": "状态已更新为非活跃。",
            "Conditions has been updated.": "条件已更新。",
            "Actions has been updated.": "动作已更新。",
            "You don't have permission to access this item.": "您没有访问此项目的权限。",
            "Page not found. {{line}} The page you are looking for doesn't exist or an other error occurred.": "页面未找到。{{line}} 您正在查找的页面不存在或发生了其他错误。",
            "That's an error. {{line}} Please try again later.": "发生错误。{{line}} 请稍后重试。",
            "Your request resulted in an error. {{line}} please try again.": "您的请求导致了错误。{{line}} 请重试。",
            "The download of asset '{{name}}' has been requested.": "已请求下载资产 '{{name}}'。",
            "Error requesting download of asset '{{name}}'. {{line}} Please refresh the page and try again.": "请求下载资产 '{{name}}' 时出错。{{line}} 请刷新页面后重试。",
            "The file has been updated.": "文件已更新。",
            "Error updating the file. {{line}} Please refresh the page and try again.": "更新文件时出错。{{line}} 请刷新页面后重试。",
            "Error adding event trigger '{{name}}'. {{line}} Please refresh the page and try again.": "添加事件触发器 '{{name}}' 时出错。{{line}} 请刷新页面后重试。",
            "If you delete \"<0>{{name}}</0>\", you won’t be able to revert this.<1/>Are you sure you want to delete?": "如果删除 \"<0>{{name}}</0>\"，将无法恢复。<1/>确定要删除吗？",
            "Deleting <0>{{currentIndex}}</0>  of <0>{{deleteItemLength}}</0> assets": "正在删除 <0>{{deleteItemLength}}</0> 个资产中的第 <0>{{currentIndex}}</0> 个",
            "\"<0>{{name}}</0>\" will be deleted forever and you won’t be abled to restore it.": "\"<0>{{name}}</0>\" 将被永久删除且无法恢复。",
            "If you navigate away from this page,<1/>your changes cannot be saved.": "如果离开此页面，<1/>您的更改将无法保存。",
            "“{{name}}” will be deleted forever and you won’t be abled to restore it.": "\"{{name}}\" 将被永久删除且无法恢复。",
            "It can only be deleted if there are no assets in the folder.": "只有文件夹中没有资产时才能删除。",
            "Specify the folder location?": "是否指定文件夹位置？",
            "Asset '{{name}}' has been moved from '{{fromFolder}}' to Folder '{{toFolder}}'.": "资产 '{{name}}' 已从 '{{fromFolder}}' 移动到文件夹 '{{toFolder}}'。",
            "Asset '{{name}}' and {{count}} other has been moved from '{{fromFolder}}' to Folder '{{toFolder}}'.": "资产 '{{name}}' 和其他 {{count}} 个已从 '{{fromFolder}}' 移动到文件夹 '{{toFolder}}'。",
            "It may take time to send mail when there are {{count}} or more shared files or folders. (Approximately 3 minutes per 1GB)": "共享文件或文件夹超过 {{count}} 个时，发送邮件可能需要一些时间。（每 1GB 约 3 分钟）",
            "Depending on the size of the shared file, it may take time to send the email. (Approximately 3 minutes per 1GB)": "根据共享文件的大小，发送邮件可能需要一些时间。（每 1GB 约 3 分钟）",
            "If you restore this item now, you will also be charged for the <NewLine>remaining <Strong>{{n}} days.</Strong></NewLine>": "如果您现在恢复此项目，还将收取 <NewLine>剩余 <Strong>{{n}} 天</Strong>的费用。</NewLine>",
            "No search results found.": "未找到搜索结果。",
            "Search for the owner of the asset.": "搜索资产的所有者。",
            "Enter after typing": "输入后按回车",
            "Enter the extension in lowercase without a dot. (e.g. mp4)": "请输入不带点(.)的小写扩展名。(例如：mp4)",
            "The download of asset '{{name}}' and {{count}} other have been requested.": "已请求下载资产 '{{name}}' 和其他 {{count}} 个。",
            "Please select the project you wish to access.": "请选择您希望访问的项目。",
            "Please search by asset name.": "请按资产名称搜索。",
            "Please enter the name.": "请输入名称。",
            "Please enter the description.": "请输入描述。",
            "Error saving changes to project details. {{line}} Please refresh the page and try again.": "保存项目详情更改时出错。{{line}} 请刷新页面后重试。",
            "Changes to your project details settings have been saved.": "项目详情设置更改已保存。",
            "Error adding project '{{name}}'. {{line}} Please refresh the page and try again.": "添加项目 '{{name}}' 时出错。{{line}} 请刷新页面后重试。",
            "Project '{{name}}' has been added.": "项目 '{{name}}' 已添加。",
            "The project lead has been updated.": "项目负责人已更新。",
            "Error updating the project lead. {{line}} Please refresh the page and try again.": "更新项目负责人时出错。{{line}} 请刷新页面后重试。",
            "Asset '{{name}}' has been archived.": "资产 '{{name}}' 已归档。",
            "This setting can lock the bucket so that other users cannot use the storage’s features (Copy, Move, Rename, Delete).": "此设置可锁定存储桶，使其他用户无法使用存储的功能（复制、移动、重命名、删除）。",
            "This bucket is locked by another user and can only be downloaded.": "此存储桶已被其他用户锁定，只能进行下载。",
            "Bucket '{{name}}' is feature locked for other users.": "存储桶 '{{name}}' 已对其他用户进行功能锁定。",
            "Bucket '{{name}}' is feature unlocked for another user.": "存储桶 '{{name}}' 已对其他用户解除功能锁定。",
            "Error occurred while feature-locking bucket '{{name}}' for another user. {{line}} Please refresh the page and try again.": "对存储桶 '{{name}}' 为其他用户进行功能锁定时出错。{{line}} 请刷新页面后重试。",
            "Error occurred while attempting to feature unlock bucket '{{name}}' for another user. {{line}} Please refresh the page and try again.": "尝试为其他用户解除存储桶 '{{name}}' 功能锁定时出错。{{line}} 请刷新页面后重试。",
            "No items match this filter": "没有匹配此筛选条件的项目",
            "None of achives matched this search": "没有匹配此搜索的归档",
            "Find items using another filter option.": "请尝试其他筛选选项。",
            "Try another search, <br/> or use the search option to find an asset.": "请尝试其他搜索，<br/> 或使用搜索选项查找资产。",
            "You can archive by selecting the items you want to <br/> archive under “Assets”.": "您可以在'资产'下选择要<br/>归档的项目进行归档。",
            "No items have been archived yet.": "尚未归档任何项目。",
            "Enter Asset Name": "输入资产名称",
            "Enter Archived ID": "输入归档 ID",
            "Enter Asset ID": "输入资产 ID",
            "Enter Archived by": "输入归档者",
            "Enter Owner": "输入所有者",
            "Welcome": "欢迎",
            "You need to log in to your Megazone account to start CloudPlex.": "您需要登录您的 Megazone 账户才能启动 CloudPlex。",
            "Login with your Megazone account": "使用您的 Megazone 账户登录",
            "Size of files Option : Number of files option is required. <NewLine/> Number of files option : Can be set without checking size of files.": "文件大小选项：需要选择文件数量选项。<NewLine/> 文件数量选项：可以在不选中文件大小的情况下设置。",
            "If you archive the assets, you will be charged the <0>{{n}}-day</0> archive<1/> amount immediately.": "如果归档这些资产，将立即收取 <0>{{n}} 天</0>归档<1/> 费用。",
            "If you archive the asset, you will be charged the <0>{{n}}-day</0> archive<1/> amount immediately.": "如果归档该资产，将立即收取 <0>{{n}} 天</0>归档<1/> 费用。",
            "If you restore this item now, you will also be charged for the <NewLine/>remaining days per asset.": "如果您现在恢复此项目，还将按每个资产的剩余天数收取费用。<NewLine/>",
            "Getting Access Token...": "正在获取 Access Token...",
            "Get Access Token": "获取 Access Token",
            "To use CloudPlex Delivery's CDN, an Access Token must be issued.": "要使用 CloudPlex Delivery 的 CDN，必须先签发 Access Token。",
            "Please search by asset name or ID.": "请按资产名称或 ID 搜索。",
            "No Collection items yet.": "暂无集合项目。",
            "Add it using the “Create” button.": "请使用'创建'按钮添加。",
            "No linked collection yet.": "暂无关联集合。",
            "No assets yet.": "暂无资产。",
            "Add it using the “+” button.": "请使用'+'按钮添加。",
            "Please search by collection name.": "请按集合名称搜索。",
            "Selected assets can be archived by selecting the storage <NewLine/> class to be archived.": "可通过选择归档的存储<NewLine/> 类别来归档所选资产。",
            "Selected assets can be restored by selecting a restore <NewLine/>option based on how they were archived.": "可根据归档方式选择恢复<NewLine/>选项来恢复所选资产。",
            "“{{name}}” and {{count}} others will be deleted forever and you won’t be abled to restore it.": "\"{{name}}\" 和其他 {{count}} 个将被永久删除且无法恢复。",
            "However, assets included in the collection are not deleted.": "但是，集合中包含的资产不会被删除。",
            "Deletion of collection {{item}} has been completed.": "集合 {{item}} 的部分删除已完成。",
            "Partial deletion of collection {{item}} and {{count}} others have been completed.": "集合 {{item}} 及其他 {{count}} 项的部分删除已完成。",
            "Deletion of collection {{item}} and {{count}} others have been completed.": "集合 {{item}} 及其他 {{count}} 项的删除已完成。",
            "There was an error deleting collection": "删除集合时发生错误",
            "There was an error deleting collections": "删除集合时发生错误",
            "Size of files Option : If you choose your own assets, you can have up to {{maxAssets}}. <NewLine/> Keep the number of selected assets under {{maxAssets}}.": "文件大小选项：如果选择自定义资产，最多可添加 {{maxAssets}} 个。<NewLine/> 请将所选资产数量保持在 {{maxAssets}} 以内。",
            "Select assets through search to put them in your collection.": "通过搜索选择资产以将其添加到集合中。",
            "Select the folder containing the assets you want to put in your collection.": "选择包含要添加到集合中的资产的文件夹。",
            "Select collections through search to put them in your collection.": "通过搜索选择集合以将其添加到您的集合中。",
            "The maximum number of tags, {{maxCount}}, has been exceeded.": "已超过标签的最大数量 {{maxCount}}。",
            "Please search by collection name or ID.": "请按集合名称或 ID 搜索。",
            "Deletion of content schema {{item}} has been completed.": "内容架构 {{item}} 的删除已完成。",
            "There was an error deleting content schema.": "删除内容架构时发生错误。",
            "Content schema '{{name}}' has been added.": "内容架构 '{{name}}' 已添加。",
            "Up to 50 {{referenceType}} can be registered": "最多可注册 50 个 {{referenceType}}",
            "You can activate a fortress field right away, and you can additionally turn the field into a user camp.": "您可以立即激活堡垒字段，也可以将字段额外设置为用户阵营。",
            "No projects are in use yet.": "目前尚无使用中的项目。",
            "You must add at least 1 field for “Reference Fields”.<NewLine/> Only then can the schema status be changed to “active” and used in the project.": "您必须为“参考字段”至少添加 1 个字段。<NewLine/> 只有这样，架构状态才能更改为“active”并在项目中使用。",
            "After opening the Fields panel via the “Add Fields” button,<NewLine/> add fields by dragging them to the “{{isReference}} Fields” layout.": "通过“添加字段”按钮打开字段面板，<NewLine/> 然后将字段拖拽到“{{isReference}} 字段”布局中以添加字段。",
            "The name starts with English, contains at least 2 letters, and can only contain English, spaces, and numbers.": "名称以英文开头，包含至少 2 个字母，只能包含英文、空格和数字。",
            "No items yet.": "暂无任何项目。",
            "Add it using the “Add {{name}}” button.": "使用“添加 {{name}}”按钮进行添加。",
            "“{{name}}” will be removed.": " \"{{name}}\" 将被删除。",
            "“{{name}}” and {{count}} others will be removed.": "\"{{name}}\" 及其他 {{count}} 项将被删除。",
            "None of collection matched this search. {{line}} Try another search.": "没有与此搜索匹配的集合。{{line}} 请尝试其他搜索。",
            "Delete the item?": "删除该项目？",
            "Delete these items?": "删除这些项目？",
            "However, assets and content contained in {{schemaName}} are not deleted.": "但是，{{schemaName}} 中包含的资产和内容不会被删除。",
            "Select preview image through search to put them in your content.": "通过搜索选择预览图片以将其添加到您的内容中。",
            "Deletion of custom content {{item}} and {{count}} others has been completed.": "自定义内容 {{item}} 及其他 {{count}} 项的删除已完成。",
            "Deletion of custom content {{item}} has been completed.": "自定义内容 {{item}} 的删除已完成。",
            "Please search by name or ID.": "请按名称或 ID 搜索。",
            "Please search by {{resourceType}} name or ID.": "请按 {{resourceType}} 名称或 ID 搜索。",
            "Try another search to find an content.": "请尝试其他搜索以查找内容。",
            "You must enter your authentication information to use the engine.": "您必须输入认证信息才能使用该引擎。",
            "Delete message?": "删除消息？",
            "Deleting a message cannot be canceled.": "删除消息操作无法取消。",
            "This message was deleted.": "此消息已被删除。",
            "Please enter your message.": "请输入您的消息。",
            "Would you like to make a private comment?": "您想创建私密评论吗？",
            "Please enter a private comment name.": "请输入私密评论名称。",
            "Add users to participate in private comments.": "添加用户以参与私密评论。",
            "you can add users of the project to communicate with them.": "您可以添加项目中的用户与其进行沟通。",
            "Would you like to change your private comment name?": "您想更改私密评论名称吗？",
            "Are you sure you want to delete the private comment?": "您确定要删除该私密评论吗？",
            "If you delete <0>\"{{name}}\"</0>, all messages will be deleted and cannot be restored after deletion.": "如果删除 <0>\"{{name}}\"</0>，所有消息将被删除，且删除后无法恢复。",
            "This is a message window where all the basics of the project can be seen.": "这是一个可以查看项目所有基本信息的消息窗口。",
            "By entering @mention, you can send a comment to the designated member.": "通过输入 @mention，您可以向指定成员发送评论。",
            "This is a message window that only added members can see.": "这是一个只有已添加成员才能查看的消息窗口。",
            "Please enter your user email.": "请输入用户邮箱并按回车键。",
            "Projects you want to allow access to": "您想允许访问的项目",
            "Select the project you want to allow access to.": "选择您想允许访问的项目。",
            "Select the role you want to grant.": "选择您想授予的角色。",
            "Search by user email.": "按用户邮箱搜索。",
            "Delete this role?": "删除此角色？",
            "Deletion of {{domain}} {{item}} has been completed.": "{{domain}} {{item}} 的删除已完成。",
            "Duplication of {{domain}} {{item}} has been completed.": "{{domain}} {{item}} 的复制已完成。",
            "Creation of {{domain}} {{item}} has been completed.": "{{domain}} {{item}} 的创建已完成。",
            "There is no custom metadata yet.": "目前尚无自定义元数据。",
            "To enter metadata, select one of the custom metadata options.": "要输入元数据，请选择其中一个自定义元数据选项。",
            "Please enter a message. (Optional)": "请输入消息。（可选）",
            "Please enter user's name.": "请输入用户姓名。",
            "Select assets.": "选择资产。",
            "If you change the applied custom metadata, all data entered will be lost.": "如果更改已应用的自定义元数据，所有已输入的数据将丢失。",
            "After AI analyzes the content, the field values of the selected content schema are automatically filled in. Only one schema can be selected.": "AI 分析内容后，会自动填充所选内容架构的字段值。只能选择一个架构。",
            "Search by custom metadata name.": "请按自定义元数据名称搜索。",
            "There are no private comments.": "暂无私密评论。",
            "Use the \"Create private comment\" button Make it.": "使用“创建私密评论”按钮进行创建。",
            "Enter name or email": "输入名称或邮箱",
            "Please enter a message for your request (Optional)": "请输入您的请求消息（可选）",
            "Folder can only be deleted if there are no assets in the folder.": "只有文件夹中没有资产时，才能删除文件夹。",
            "Select collections in a specific folder?": "选择特定文件夹中的集合？",
            "This field is required.": "此字段为必填项。",
            "Invalid invitation code or Your invitation link may have expired.": "邀请码无效或您的邀请链接可能已过期。",
            "Please contact your administrator to request a new invitation link.": "请联系您的管理员以请求新的邀请链接。",
            "Hello,<NewLine/>Welcome to LX Hausys Design Library.": "您好，<NewLine/>欢迎来到 LX Hausys Design Library。",
            "Up to <strong>{{number}}</strong> attachments are allowed.": "最多允许添加 <strong>{{number}}</strong> 个附件。",
            "Please select up to <strong>{{number}}</strong> files and try again.": "请选择最多 <strong>{{number}}</strong> 个文件后重试。",
            "You are currently planning to upload <strong>{{added}}</strong> files. If you would like to attach another file, please remove the file and try again.": "您目前计划上传 <strong>{{added}}</strong> 个文件。如果您想附加其他文件，请先移除文件后重试。",
            "You are currently planning to upload <strong>{{added}}</strong> files. Please select and attach up to <strong>{{remaining}}</strong> additional files.": "您目前计划上传 <strong>{{added}}</strong> 个文件。请额外选择并附加最多 <strong>{{remaining}}</strong> 个文件。",
            "The maximum capacity per attachment is up to <strong>{{maxSize}}</strong>.": "每个附件的最大容量为 <strong>{{maxSize}}</strong>。",
            "The current file has exceeded its capacity. Please check the file to attach and try again.": "当前文件已超出容量限制。请检查要附加的文件后重试。",
            "Asset {{item}} duplication completed.": "资产 {{item}} 复制完成。",
            "\"Custom Metadata\" can be applied to an asset’s custom metadata and is available when its status is enabled.": "\"自定义元数据\" 可应用于资产的自定义元数据，状态启用时可用。",
            "Enter required fields for “{{name}}” <0>{{count}}</0>/{{total}}": "\"{{name}}\" 的必填字段 <0>{{count}}</0>/{{total}}",
            "and <0>{{count}}</0> more": "以及 <0>{{count}}</0> 个更多",
            "There is no data for this widget.": "此小组件暂无数据。",
            "There are no jobs yet.": "目前尚无任务。",
            "This operation was not entirely successful.": "此操作未完全成功。",
            "Failed to load preview image. Please again.": "加载预览图片失败。请重试。",
            "Preview image Creating...": "预览图片创建中...",
            "Failed to load preview image. <NewLine/>please try again.": "加载预览图片失败。<NewLine/>请重试。",
            "Some assets are missing required metadata for electronic payment.<NewLine/> Please change the metadata type to Roll or Artwork and submit.": "部分资产缺少电子支付所需的必要元数据。<NewLine/> 请将元数据类型更改为 Roll 或 Artwork 后提交。",
            "Asset '{{name}}' has been requested.": "资产 '{{name}}' 已申请。",
            "Asset '{{name}}' and {{count}} other assets have been requested.": "资产 '{{name}}' 及其他 {{count}} 项资产已申请。",
            "Are you sure you want to turn off applying custom metadata?": "您确定要关闭应用自定义元数据吗？",
            "Attribution cannot be empty. Please enter a valid attribution.": "归属不能为空。请输入有效的归属信息。",
            "If you turn off Custom Apply All Data, your input data is gone and cannot be recovered.": "如果关闭“全部应用自定义数据”，您输入的数据将丢失且无法恢复。",
            "Please search by role name": "请按角色名称搜索",
            "Deleting the role “{{roleName}}” removes all permissions for users and groups set by that role.": "删除角色 \"{{roleName}}\" 将移除该角色为用户和群组设置的所有权限。",
            "The corresponding menu is selected in the project first entry screen settings above. If you do not want to display the menu, turn off the above settings.": "相应菜单已在上方项目首页屏幕设置中选中。如果不想显示该菜单，请关闭上方设置。",
            "Creating access token.": "正在创建访问令牌。",
            "Sucessfully created access token. Please check from the requested client.": "访问令牌创建成功。请从请求的客户端进行确认。",
            "Failed to create access token. Please try again from the requested client.": "创建访问令牌失败。请从请求的客户端重试。",
            "Please select files to add": "请选择要添加的文件",
            "“{{name}}’ is in use in projects.<0/> If you wish to delete it, please disable the schema in the project you are using.": "\"{{name}}' 正在项目中使用。<0/> 如果您想删除它，请先在使用该架构的项目中禁用该架构。",
            "Select {{resourceType}} through search to put them in your custom content.": "通过搜索选择 {{resourceType}} 以将其添加到您的自定义内容中。",
            "The selected item is rejected": "所选项目已被拒绝",
            "The selected item is approved": "所选项目已被批准",
            "The private comment is deleted.": "私密评论已删除。",
            "There is no data": "暂无数据",
            "The selected item has been requested to be archived.": "所选项目已申请归档。",
            "Please search by name": "请按名称搜索",
            "Are you sure you want to delete that export file?": "您确定要删除该导出文件吗？",
            "If you delete a exported metadata, all settings and downloadable files will be deleted.": "如果删除已导出的元数据，所有设置和可下载文件将被删除。",
            "Search for a project.": "搜索项目。",
            "Contains an overview of all selected assets.<NewLine/> The contents of hidden fields are revealed in the exported file.": "包含所有选定资产的概览。<NewLine/> 隐藏字段的内容将在导出文件中显示。",
            "There are no projects selected.": "未选择任何项目。",
            "Creation of new Metadata Export {{item}} is completed": "新建元数据导出 {{item}} 的创建已完成",
            "No {{name}} items yet.": "暂无 {{name}} 项目。",
            "The selected items have been requested to be archived.": "所选项目已申请归档。",
            "You can choose a storage class to store your assets.": "您可以选择存储类别来存储您的资产。",
            "Please search by content schema name": "请按内容架构名称搜索",
            "Please search by DisplayAs or SoundsLike.": "请按 DisplayAs 或 SoundsLike 搜索。",
            "A preview setting of '{{name}}' have been requested.": "已申请 '{{name}}' 的预览设置。",
            "This file size can be up to {{maxByte}} bytes.": "此文件大小最大为 {{maxByte}} 字节。",
            "Things to keep in mind when entering words": "输入词语时的注意事项",
            "Words similar to spoken sounds - Only Korean characters can be entered.": "类似语音发音的词语 - 只能输入韩文字符。",
            "If you want to create a URL, please change the status to Published.": "如果您想创建 URL，请将状态更改为“已发布”。",
            "The changed options is applied when it is ‘ACTIVE’, and if it is ‘INACTIVE’, the options is reset when the pop-up is closed.": "更改的选项在“ACTIVE”状态时生效，若为“INACTIVE”状态，选项将在弹窗关闭时重置。",
            "Please search by audit log resourceId.": "请按审计日志资源 ID 搜索。",
            "Please search by vocabulary book name.": "请按词汇表名称搜索。",
            "You can enter English, numbers, spaces, and special characters (~!@#$%^&*()-_=+[{]}|;:’”,<.>/?).": "可以输入英文、数字、空格和特殊字符（~!@#$%^&*()-_=+[{]}|;:'\"，<.>/?）。",
            "Only English, -(Hyphen) can be entered.": "只能输入英文、-（连字符）。",
            "You can enter Korean, English, numbers, spaces, and special characters (~!@#$%^&*()-_=+[{]}|;:’”,<.>/?).": "可以输入韩文、英文、数字、空格和特殊字符（~!@#$%^&*()-_=+[{]}|;:'\"，<.>/?）。",
            "Only Korean can be entered.": "只能输入韩文。",
            "An email will be sent to users with space admin permission.": "将向具有空间管理员权限的用户发送电子邮件。",
            "No reports have been sent yet.": "尚未发送任何报告。",
            "{{action}} completed.": "{{action}} 已完成。",
            "When you enable automatic archiving, <0>you will be billed immediately for 90 or 180 days</0>, depending on the storage class option you select.": "启用自动归档后，<0>将根据您选择的存储类别选项立即收取 90 天或 180 天的费用</0>。",
            "This storage class is billed for <0>180 days</0> immediately after archiving.": "此存储类别在归档后立即收取 <0>180 天</0> 的费用。",
            "Video images cannot be captured.": "无法捕获视频图像。",
            "To capture video images, the original source must contain an <0>mp4 or mov</0> file. <1/> Try capturing from a video or asset that has an mp4 or mov file.": "要捕获视频图像，原始来源必须包含 <0>mp4 或 mov</0> 文件。<1/> 请尝试从包含 mp4 或 mov 文件的视频或资产中捕获。",
            "Are you sure you want to delete the link??": "您确定要删除该链接吗？",
            "Deleted links cannot be restored.": "已删除的链接无法恢复。",
            "This recipient will no longer be able to download from this link. Revoked access cannot be restored.": "该收件人将无法再通过此链接下载。已撤销的访问权限无法恢复。",
            "Access has been revoked.": "访问权限已撤销。",
            "Revoke this download link?": "要撤销此下载链接吗？",
            "'{{subject}}' shared with {{sharedWith}} will no longer be downloadable.": "已共享给 {{sharedWith}} 的「{{subject}}」将无法再下载。",
            "A revoked link cannot be restored. Share again to send a new link.": "撤销的链接无法恢复。请重新共享以发送新链接。",
            "Download link revoked.": "下载链接已撤销。",
            "Please add a link.": "请添加链接。",
            "This field must be in URL format.": "此字段必须为 URL 格式。",
            "Are you sure you want to delete this group?": "您确定要删除此群组吗？",
            "Deleting the {{groupName}} group removes all permissions from users and roles set by that group.": "删除 {{groupName}} 群组将移除该群组为用户和角色设置的所有权限。",
            "If the problem persists, <0/> please contact the administrator.": "如果问题持续存在，<0/> 请联系管理员。",
            "Up to {{limit}} {{referenceType}} can be registered": "最多可注册 {{limit}} 个 {{referenceType}}",
            "Select Category Group": "选择类别群组",
            "Each menu (e.g. Assets) can be categorized into one category group.": "每个菜单（例如资产）可以归类到一个类别群组中。",
            "Make sure the category group is in use <label>In use</label> status.": "确保类别群组处于 <label>使用中</label> 状态。",
            "If you apply a different category group, you can check the items in the <strong>'Uncategorized'</strong> in the category view.": "如果应用不同的类别群组，您可以在类别视图的 <strong>'未分类'</strong> 中查看这些项目。",
            "No collection items yet.": "暂无集合项目。",
            "There are no assets selected.": "未选择任何资产。",
            "Please select an item to enter the menu": "请选择一个项目以进入菜单",
            "Search by category name": "按类别名称搜索",
            "There are no menus configured.": "尚未配置任何菜单。",
            "Use the \"Add Menu\" button to add it.": "使用“添加菜单”按钮进行添加。",
            "'{{item}}' has been created.": "{{item}}' 已创建。",
            "This menu is set as the first entry screen of the project and cannot be hidden.": "此菜单已设置为项目的首页屏幕，无法隐藏。",
            "Please enter the menu name.": "请输入菜单名称。",
            "Menu name can be up to {{maxByte}} bytes.": "菜单名称最多为 {{maxByte}} 字节。",
            "Please search by name.": "请按名称搜索。",
            "Deletion of vocabulary book {{item}} has been completed.": "词汇表 {{item}} 的删除已完成。",
            "Deletion of vocabulary book {{item}} and {{count}} others has been completed.": "词汇表 {{item}} 及其他 {{count}} 项的删除已完成。",
            "Content schema '{{name}}' has been created.": "内容架构 '{{name}}' 已创建。",
            "Content schema '{{name}}' has been updated.": "内容架构 '{{name}}' 已更新。",
            "Enter last name": "输入姓氏",
            "Enter first name": "输入名字",
            "It's not possible to proceed as the archived menu isn't being used.": "由于归档菜单未在使用中，无法继续操作。",
            "Asset lock has been disabled.": "资产锁定已禁用。",
            "Asset lock has been enabled.": "资产锁定已启用。",
            "Lock this asset": "锁定此资产",
            "Select a category from the category group.": "从类别群组中选择类别。",
            "Sharing Period and Number of Downloads have expired. You can reset it.": "共享期限和下载次数已过期。您可以重置。",
            "Number of Downloads has expired. You can reset it.": "下载次数已过期。您可以重置。",
            "Sharing Period has expired. You can reset it.": "共享期限已过期。您可以重置。",
            "There are no shared users.": "暂无共享用户。",
            "Processing download request...": "正在处理下载请求...",
            "If you delete “{{name}}”, this property will be removed from all assets using this content schema, and it cannot be recovered.": "如果删除 \"{{name}}\"，此属性将从所有使用此内容架构的资产中移除，且无法恢复。",
            "Drag and drop your file here, or upload a file from your PC or cloud.": "将文件拖放到此处，或从您的电脑或云端上传文件。",
            "Go to the start page and select a project you have access to.": "转到起始页并选择您有权访问的项目。",
            "If you don’t have access to any projects, please contact your administrator.": "如果您没有访问任何项目的权限，请联系您的管理员。",
            "Please use the button below to go to the start page.": "请使用下方按钮转到起始页。",
            "There is no page available for this comment.": "此评论没有可用的页面。",
            "You do not have permission to access the page.": "您没有访问该页面的权限。",
            "The custom metadata used in the asset is disabled.": "资产中使用的自定义元数据已禁用。",
            "Selecting Use will make your project assets visible in the full asset search results. This may take some time to apply, depending on the amount of data.": "选择使用后，您的项目资产将在全资产搜索结果中可见。根据数据量，这可能需要一些时间才能生效。",
            "Data accessed through expedited retrieval for all objects except the largest archive objects (250MB or larger) is typically available within 1-5 minutes.": "通过快速检索访问的数据（除最大归档对象 250MB 或更大外）通常在 1-5 分钟内可用。",
            "When restoring, Deep Archive storage will be charged for a minimum of 180 days, and other storage classes will be charged for a minimum of 90 days.": "恢复时，Deep Archive 存储将收取至少 180 天的费用，其他存储类别将收取至少 90 天的费用。",
            "You will be charged when restoring an asset.": "恢复资产时将收取费用。",
            "AI analysis identifies people, actions, and risk factors in videos and can automatically generate subtitles and text.": "AI 分析可识别视频中的人物、动作和风险因素，并可自动生成字幕和文字。",
            "Please save or cancel your changes before adding a new task.": "在添加新任务之前，请先保存或取消您的更改。",
            "Please set the Input Path.": "请设置输入路径。",
            "Are you sure you want to delete the task?": "您确定要删除该任务吗？",
            "Deleting a task will cause all entered information to disappear and cannot be recovered.": "删除任务将导致所有已输入的信息消失且无法恢复。",
            "Please enter your email address and press Enter.": "请输入您的电子邮件地址并按回车键。",
            "Share request to {{userName}}": "向 {{userName}} 发送共享请求",
            "Changed share options to {{permission}} permission": "共享选项已更改为 {{permission}} 权限",
            "Changed share options to {{permission}} permission until {{expireDate}}": "共享选项已更改为 {{permission}} 权限，有效期至 {{expireDate}}",
            "Changed share options to {{permission}} permission until {{expireDate}} with max {{maxDownloads}} downloads": "共享选项已更改为 {{permission}} 权限，有效期至 {{expireDate}}，最多 {{maxDownloads}} 次下载",
            "Changed share options to {{permission}} permission with max {{maxDownloads}} downloads": "共享选项已更改为 {{permission}} 权限，最多 {{maxDownloads}} 次下载",
            "Sharing with {{user}} was updated": "与 {{user}} 的共享已更新",
            "Sharing with {{user}} was removed": "与 {{user}} 的共享已移除",
            "Shared with {{user}}": "已与 {{user}} 共享",
            "Shared with {{grantees}} permission": "已向 {{grantees}} 授予共享权限",
            "Shared with {{grantees}} permission until {{expireDate}}": "已向 {{grantees}} 授予共享权限，有效期至 {{expireDate}}",
            "Shared with {{grantees}} permission until {{expireDate}} with max {{maxDownloads}} downloads": "已向 {{grantees}} 授予共享权限，有效期至 {{expireDate}}，最多 {{maxDownloads}} 次下载",
            "Shared with {{grantees}} permission with max {{maxDownloads}} downloads": "已向 {{grantees}} 授予共享权限，最多 {{maxDownloads}} 次下载",
            "Shared link to {{names}}": "已共享链接给 {{names}}",
            "It's not possible to proceed as the {{menuName}} menu isn't being used.": "由于 {{menuName}} 菜单未在使用中，无法继续操作。",
            "No users have been registered yet.": "尚未注册任何用户。",
            "Click the User invitation button at the top to add a user.": "点击顶部的用户邀请按钮以添加用户。",
            "Please search by name or email": "请按名称或邮箱搜索",
            "Search by project name": "按项目名称搜索",
            "Search by bucket name": "按存储桶名称搜索",
            "\"{{name}}\" will be deleted forever and you won't be abled to restore it.": "\"{{name}}\" 将被永久删除，且无法恢复。",
            "\"{{name}}\" and {{count}} others will be deleted forever and you won't be abled to restore it.": "\"{{name}}\" 及其他 {{count}} 项将被永久删除，且无法恢复。",
            "The service is located in {{region}}.": "该服务位于 {{region}}。",
            "Please select a region.": "请选择区域。",
            "Please copy the JSON below to create an IAM Permission.": "请复制以下 JSON 以创建 IAM 权限。",
            "Please apply the role trust relationship by replacing {REPLACE_WITH_YOUR_EXTERNAL_ACCOUNT_ID} in the JSON below with the account ID you want to use.": "请将以下 JSON 中的 {REPLACE_WITH_YOUR_EXTERNAL_ACCOUNT_ID} 替换为您要使用的账户 ID，以应用角色信任关系。",
            "Please copy the Role ARN and paste it into the external account input field for <0>AWS account connection</0>.": "请复制角色 ARN 并将其粘贴到 <0>AWS 账户连接</0> 的外部账户输入字段中。",
            "Please enter the AWS Role ARN.": "请输入 AWS 角色 ARN。",
            "Please search by user name.": "请按用户名搜索。",
            "Please search by group name.": "请按群组名称搜索。",
            "Please select a new owner": "请选择新的所有者",
            "Changing the owner may result in the existing owner losing permissions and some features being restricted.": "更改所有者可能导致现有所有者失去权限，部分功能受到限制。",
            "Are you sure you want to delete this?": "您确定要删除此项目吗？",
            "Please click Add roles button to grant roles to this user.": "请点击“添加角色”按钮以向此用户授予角色。",
            "No group is granted": "未授予任何群组",
            "There are no groups yet.": "目前尚无群组。",
            "Please click Manage Access button to add group to this project.": "请点击“管理访问”按钮以向此项目添加群组。",
            "There are no users yet.": "目前尚无用户。",
            "Please click Manage Access button to add user to this project.": "请点击“管理访问”按钮以向此项目添加用户。",
            "You can create up to {{n}} tags.": "您最多可以创建 {{n}} 个标签。",
            "Update owner to {{name}}": "将所有者更新为 {{name}}",
            "URL not found": "未找到 URL",
            "The URL has been deleted or the menu does not exist.": "该 URL 已被删除或菜单不存在。",
            "You must enter your credentials to use the engine.": "您必须输入凭据才能使用该引擎。",
            "When uploading via pop-up, empty folders are excluded.<NewLine/> To upload empty folders as well, please drag the folders directly into the asset list.": "通过弹窗上传时，空文件夹将被排除。<NewLine/> 如需同时上传空文件夹，请将文件夹直接拖入资产列表。",
            "If the capacity is more than {{limit}}, the print file will be automatically extracted and automatic captions will be generated.": "如果容量超过 {{limit}}，打印文件将自动提取并生成自动字幕。",
            "It is only available at the all project level.": "仅在所有项目级别可用。",
            "There is no data available.": "暂无可用数据。",
            "The maximum upload size is {{size}}.": "最大上传大小为 {{size}}。",
            "Please select a repository.": "请选择一个存储库。",
            "Remove user from role?": "从角色中移除用户？",
            "If you remove the user {{userName}}, assigned permission will be removed.": "如果移除用户 {{userName}}，已分配的权限将被删除。",
            "Remove group from role?": "从角色中移除群组？",
            "If you remove the group {{groupName}}, assigned permission will be removed.": "如果移除群组 {{groupName}}，已分配的权限将被删除。",
            "There is no file.": "没有文件。",
            "mentioned you in a comment": "在评论中提及了您",
            "replied to your comment": "回复了您的评论",
            "invited you to a private comment": "邀请您加入私密评论",
            "There are no notifications yet.": "暂无通知。",
            "Notifications will be deleted after 7 days.": "通知将在 7 天后删除。",
            "The item does not exist": "该项目不存在",
            "Analysis completed, but there are no results for {{name}}.": "分析已完成，但 {{name}} 没有结果。",
            "An error occurred during analysis and the operation could not be completed.": "分析过程中发生错误，操作无法完成。",
            "Analyzing now uses the proxy video.": "现在分析将使用代理视频。",
            "The proxy video is still being created, so analyzing now uses the original and takes longer.": "代理视频仍在生成中，现在分析将使用原始视频，耗时更长。",
            "The proxy video could not be created, so it is analyzed with the original.": "无法创建代理视频，因此使用原始视频进行分析。",
            "There is no proxy video, so it is analyzed with the original.": "没有代理视频，因此使用原始视频进行分析。",
            "Proxy videos are only created for assets registered after auto generation is turned on.": "仅为开启自动生成后注册的资产创建代理视频。",
            "There was a problem for a moment.": "出现了暂时性问题。",
            "There was a problem processing your request. Please try again later.": "处理您的请求时出现问题，请稍后重试。",
            "AI usage quota has been exceeded.": "AI 使用配额已超出。",
            "You have reached the AI usage limit. Please contact your administrator to increase the quota.": "您已达到 AI 使用限制，请联系管理员以增加配额。",
            "No values were extracted.": "没有提取到任何值。",
            "The analysis finished, but no values matching the schema fields were returned. Retrying may produce the same result.": "分析已完成，但未能获取与架构字段匹配的值。重试可能会得到相同的结果。",
            "I recommend the video highlights.": "我推荐视频精彩片段。",
            "Enter a prompt for AI": "请输入 AI 提示词",
            "What can I help with?": "有什么可以帮您的？",
            "Please enter the prompt.": "请输入提示词。",
            "Preset status has been updated.": "预设状态已更新。",
            "Deletion of preset {{item}} has been completed.": "预设 {{item}} 已删除完成。",
            "Preset has been duplicated successfully.": "预设已成功复制。",
            "Failed to send the prompt preset.": "提示词预设发送失败。",
            "'{{name}}' will be deleted forever and you won't be able to restore it.": "\"{{name}}\" 将被永久删除，且无法恢复。",
            "No preset items yet.": "暂无预设项目。",
            "No content schema items yet.": "暂无内容架构项目。",
            "Create it using the “Create” button.": "请使用「创建」按钮进行创建。",
            "To use the AI-Workspace, the original source must contain an <0>mp4 or mov</0> file.": "要使用 AI-Workspace，原始来源必须包含 <0>mp4 或 mov</0> 文件。",
            "Name is required.": "名称为必填项。",
            "Prompt is required.": "提示词为必填项。",
            "The selected tags have been saved to the metadata.": "所选标签已保存到元数据。",
            "Please select the required items from the recommended tags.": "请从推荐标签中选择必填项目。",
            "Please select a template.": "请选择模板。",
            "Your session has expired. Please start a new conversation.": "您的会话已过期，请开始新的对话。",
            "Generating results": "正在生成结果",
            "There is no description yet. Bring an AI description or enter it directly.": "暂无描述。请使用 AI 生成描述或直接输入。",
            "Please write a description.": "请填写描述。",
            "To capture video images, it must be an <0>mp4 or mov</0> file. <1/> Try capturing from mp4 or mov assets.": "要捕获视频图像，必须是 <0>mp4 或 mov</0> 文件。<1/> 请从 mp4 或 mov 资产中进行捕获。",
            "The video cannot be edited.": "该视频无法编辑。",
            "To edit a video, it must be an <0>mp4 or mov</0> file. <1/> Edit in mp4 or mov assets.": "要编辑视频，必须是 <0>mp4 或 mov</0> 文件。<1/> 请在 mp4 或 mov 资产中进行编辑。",
            "To edit a video, the original source must contain an <0>mp4 or mov</0> file. <1/> Edit videos or assets that contain mp4 or mov files.": "要编辑视频，原始来源必须包含 <0>mp4 或 mov</0> 文件。<1/> 请编辑包含 mp4 或 mov 文件的视频或资产。",
            "You can play it directly on mobile with the QR code.": "您可以通过 QR 码在移动设备上直接播放。",
            "Analyze videos with AI": "使用 AI 分析视频",
            "to easily manage your videos.": "轻松管理您的视频。",
            "Video AI analysis can extract labels for specific people, objects, patterns, and actions in videos, and manage inappropriate or dangerous content.": "视频 AI 分析可提取视频中特定人物、物体、模式和动作的标签，并管理不当或危险内容。",
            "Additionally, it can automatically convert video audio to text and automatically generate captions to easily manage videos.": "此外，它还可以自动将视频音频转换为文字，并自动生成字幕，方便管理视频。",
            "{{resourceName}} '{{name}}' has been added.": "{{resourceName}} \"{{name}}\" 已添加。",
            "{{resourceName}} '{{name}}' and {{count}} others have been added.": "{{resourceName}} \"{{name}}\" 及其他 {{count}} 个已添加。",
            "This field can be up to {{maxLength}} characters.": "此字段最多可输入 {{maxLength}} 个字符。",
            "The description can be up to {{maxLength}} characters long.": "描述最多可输入 {{maxLength}} 个字符。",
            "The comment field can be up to {{maxLength}} characters long.": "评论字段最多可输入 {{maxLength}} 个字符。",
            "Menu name can be up to {{maxLength}} bytes.": "菜单名称最多可输入 {{maxLength}} 字节。",
            "The description can be up to {{maxLength}} characters": "描述最多可输入 {{maxLength}} 个字符",
            "Request to create download link successfully": "下载链接创建请求成功",
            "Auto set by {{name}}": "由 {{name}} 自动设置",
            "request completed": "请求已完成",
            "Each menu (e.g. Asset) can categorize items by setting one category group.": "每个菜单（如资产）可通过设置一个类别群组来对项目进行分类。",
            "Make sure the category group is currently <InUse>In Use</InUse> for the target menu (e.g. Asset).": "请确保类别群组当前对目标菜单（如资产）处于 <InUse>使用中</InUse> 状态。",
            "If you apply a different category group, those items can be found under '<NotClassified>Categories Not Classified into Assets</NotClassified>' in the category view.": "如果应用不同的类别群组，这些项目可在类别视图的「<NotClassified>未分类到资产的类别</NotClassified>」下找到。",
            "Category groups allow you to classify and manage items conveniently.": "类别群组让您可以方便地对项目进行分类和管理。",
            "Assets can be created successfully only when no values are empty. If not used, please delete.": "仅当所有值均不为空时，资产才能成功创建。如不使用，请删除。",
            "The name field be up to {{title}} characters long.": "名称字段最多可输入 {{title}} 个字符。",
            "The selected {{type}} has been saved to the metadata.": "所选 {{type}} 已保存到元数据。",
            "ㆍSingle IP : xxx.xxx.xxx.xxx\n ㆍIP Range : xxx.xxx.xxx.xxx~zzz.zzz.zzz.zzz\n ㆍCIDR : xxx.xxx.xxx.xxx/yy\n ㆍSeparate by newlines": "ㆍ单个 IP：xxx.xxx.xxx.xxx\n ㆍIP 范围：xxx.xxx.xxx.xxx~zzz.zzz.zzz.zzz\n ㆍCIDR：xxx.xxx.xxx.xxx/yy\n ㆍ以换行符分隔",
            "Add it using the “Add Collection” button.": "请使用「添加集合」按钮进行添加。",
            "ㆍCIDR : xxx.xxx.xxx.xxx/yy\n \n ㆍseparate by newlines": "ㆍCIDR：xxx.xxx.xxx.xxx/yy\n \n ㆍ以换行符分隔",
            "This is not a valid URL pattern": "这不是有效的 URL 格式",
            "If you delete <0>{{name}}</0>, You won’t be able to revert this.<1/>Are you sure you want to delete <0>{{name}}</0>?": "如果删除 <0>{{name}}</0>，将无法撤销此操作。<1/>确定要删除 <0>{{name}}</0> 吗？",
            "If you archive the asset, you will be charged <0>the {{n}}-day</0> archive amount immediately.": "如果归档该资产，将立即收取 <0>{{n}} 天</0>的归档费用。",
            "up to <0> {{number}} </0> days.": "最多 <0> {{number}} </0> 天。",
            "Creation of event trigger has been completed.": "事件触发器已创建完成。",
            "Please search by folder name": "请按文件夹名称搜索",
            "Folder": "文件夹",
            "invited you to a thread": "邀请您加入讨论串",
            "You will be notified by email <0/> whether the asset has been shared.": "您将通过电子邮件 <0/> 收到资产共享通知。",
            "The description has been updated.": "描述已更新。",
            "Up to 50 {{referenceType}}s can be registered": "最多可注册 50 个 {{referenceType}}",
            "The status has been changed.": "状态已更改。",
            "Are you sure you want to delete this workflow?": "确定要删除此工作流程吗？",
            "If you delete this workflow, it cannot be recovered.": "删除此工作流程后将无法恢复。",
            "An event that triggers the workflow to run.": "触发工作流程运行的事件。",
            "Branches the workflow based on conditions.": "根据条件对工作流程进行分支。",
            "Proceeds to the next step when the task is completed.": "任务完成后进入下一步。",
            "When the created asset's media type is {{values}}": "当创建的资产媒体类型为 {{values}} 时",
            "When the file extension is {{values}}": "当文件扩展名为 {{values}} 时",
            "Branch files based on file extension": "根据文件扩展名对文件进行分支",
            "Branch files based on file size": "根据文件大小对文件进行分支",
            "Branch files based on media type": "根据媒体类型对文件进行分支",
            "Branch files based on asset size": "根据资产大小对文件进行分支",
            "When an object is created in the S3 bucket": "当在 S3 存储桶中创建对象时",
            "When an asset is created in the current project": "当在当前项目中创建资产时",
            "Submit transcode task to pipeline": "向管道提交转码任务",
            "Create an asset from a file (waits until preview extraction completes)": "从文件创建资产（等待预览提取完成）",
            "Attach metadata to asset": "将元数据附加到资产",
            "System preset-based single type job": "基于系统预设的单类型任务",
            "Archive to the specified storage class": "归档到指定的存储类别",
            "Publish a video to SNS": "将视频发布到 SNS",
            "This trigger has no additional conditions.": "此触发器没有附加条件。",
            "Exactly one of {{keys}} is required": "{{keys}} 中恰好需要一个",
            "One of {{keys}} is required": "{{keys}} 中至少需要一个",
            "{{keys}} cannot be used together": "{{keys}} 不能同时使用",
            "Use AI workspace metadata.": "使用 AI 工作区元数据。",
            "Enter manually.": "手动输入。",
            "Describe the scene or features in the video you are looking for!": "请描述您要查找的视频场景或特征！",
            "Data updated at {{timestamp}} ({{offset}})": "数据更新时间：{{timestamp}}（{{offset}}）",
            "Based on {{start}} ~ {{end}} ({{offset}})": "基于 {{start}} ~ {{end}}（{{offset}}）",
            "{{month}} settlement confirmed": "{{month}} 结算已确认",
            "{{percent}}% in use": "已使用 {{percent}}%",
            "Concurrent session limit {{max}}": "最大并发会话数 {{max}}",
            "Monthly base fee {{fee}}": "月基本费 {{fee}}",
            "Monthly base fee none": "无月基本费",
            "Base fee : {{fee}}": "月基本费：{{fee}}",
            "Base fee : none": "月基本费：无",
            "Usage fee : {{minutes}} min × {{rate}}": "使用费：{{minutes}} 分钟 × {{rate}}",
            "Usage fee : {{minutes}} min": "使用费：{{minutes}} 分钟",
            "{{days}} days": "{{days}} 天",
            "Failed to load billing information.": "费用信息加载失败。",
            "There is no active subscription for this tenant.": "该租户没有有效订阅。",
            "ㆍSingle IP : xxx.xxx.xxx.xxx\nㆍIP Range : xxx.xxx.xxx.xxx~zzz.zzz.zzz.zzz\nㆍCIDR : xxx.xxx.xxx.xxx/yy\nㆍSeparate by newlines": "ㆍ单个 IP : xxx.xxx.xxx.xxx\nㆍIP 范围 : xxx.xxx.xxx.xxx~zzz.zzz.zzz.zzz\nㆍCIDR : xxx.xxx.xxx.xxx/yy\nㆍ以换行分隔",
            "ㆍCIDR : xxx.xxx.xxx.xxx/yy\nㆍseparate by newlines": "ㆍCIDR : xxx.xxx.xxx.xxx/yy\nㆍ以换行分隔",
            "Clicking apply replaces the matching field of the custom metadata below the video with the extracted value.": "点击应用后，视频下方自定义元数据中匹配的字段将被替换为提取值。",
            "This segment has no duration, so it cannot be added.": "该片段没有时长，无法添加。",
            "Replaces the current metadata with the selected preset schema's metadata and saves it. Changes cannot be undone.": "将当前元数据替换为所选预设架构的元数据并保存。更改无法撤销。",
            "The current metadata is replaced with the metadata from the selected preset schema. You can revert to the previous state until the metadata is saved.": "当前元数据将被替换为所选预设架构的元数据。在保存元数据之前，可以恢复到之前的状态。",
            "Replaces the current metadata with the selected preset schema's metadata. You cannot save if required fields are empty. Enter the required values and then save.": "将当前元数据替换为所选预设架构的元数据。必填项未填写时无法保存元数据。请填写必填值后再保存。",
            "Saving deletes the existing custom metadata and replaces it with the AI-extracted metadata. Changes cannot be undone. Do you want to continue?": "保存后，现有自定义元数据将被删除，并替换为 AI 提取的元数据。更改无法撤销。要继续保存吗？",
            "Saving deletes the existing custom metadata and replaces it with the current settings. Changes cannot be undone. Do you want to continue?": "保存后，现有自定义元数据将被删除，并替换为当前设置的信息。更改无法撤销。要继续保存吗？",
            "Select the items to save as custom metadata from the extracted values. You can edit the values before saving.": "请从提取的值中选择要保存为自定义元数据的项目。保存前可以修改这些值。",
            "The metadata has been saved.": "元数据已保存。",
            "This asset uses the <0>'{{current}}'</0> schema, which differs from the preset schema({{preset}}). Field-level replacement is not available; replacing the schema applies all extracted values and clears the existing input data.": "该资产应用的是 <0>'{{current}}'</0> 架构，与预设架构（{{preset}}）不同。无法按字段替换；替换架构后将全部应用提取值，且已输入的数据将被清除。",
            "Setting the preset schema({{preset}}) applies all extracted values.": "设置为预设架构（{{preset}}）后将全部应用提取值。",
            "Set the preset schema to show it here.": "设置为预设架构后，将显示在此处。",
            "Do you want to unpublish the public URL?": "要取消发布该公开 URL 吗？",
            "Due to CDN cache, it may take up to a few minutes to actually block access.": "由于 CDN 缓存，实际阻止访问最多可能需要几分钟。",
            "Each URL stays the same even if you update the file.": "即使更新文件，各 URL 也保持不变。",
            "Failed to copy the URL.": "URL 复制失败。",
            "Failed to open the URL.": "URL 打开失败。",
            "Failed to publish. Please try again later.": "发布失败。请稍后重试。",
            "Failed to publish. Unpublish and try publishing again.": "发布失败。请取消发布后重新发布。",
            "Failed to unpublish. Please try again later.": "取消发布失败。请稍后重试。",
            "Publishing the public URL has been requested.": "已请求发布公开 URL。",
            "Publishing {{count}} captions has been requested.": "已请求发布 {{count}} 个字幕。",
            "Publishing {{count}} images has been requested.": "已请求发布 {{count}} 张图片。",
            "The public URL has been copied.": "公开 URL 已复制。",
            "The public URL has been unpublished.": "公开 URL 已取消发布。",
            "The public URL of <0>{{target}}</0> will no longer be accessible.": "<0>{{target}}</0> 的公开 URL 将无法再访问。",
            "There is no published asset.": "没有已公开的资产。",
            "This asset is published via CDN. The issued URL stays the same even if you update the file.": "该资产将通过 CDN 公开。即使更新文件，已发放的 URL 也保持不变。",
            "To share privately with specific users, use <0>Actions → Share link</0>.": "如需与特定用户私下共享，请使用 <0>操作 → 共享链接</0>。",
            "Failed to load the public URL list.": "公开 URL 列表加载失败。",
            "You do not have permission to publish this asset.": "您没有发布该资产的权限。",
            "{{count}} captions have been unpublished.": "已取消发布 {{count}} 个字幕。",
            "{{count}} images have been unpublished.": "已取消发布 {{count}} 张图片。",
            "Invalid pattern.": "格式不正确。",
            "This field should be a number.": "该字段必须为数字。",
            "This field can be from {{min}} characters.": "该字段最少可输入 {{min}} 个字符。",
            "This field can be up to {{max}}.": "该字段最多可输入 {{max}}。",
            "This field can be at least {{min}}.": "该字段不得小于 {{min}}。",
            "Duplicate value.": "值重复。",
            "Already exists. Try something else.": "已存在。请使用其他值。",
            "If you detach <0>{{name}}</0>, you won’t be able to revert this.<1/>Are you sure you want to detach <0>{{name}}</0>?": "分离 <0>{{name}}</0> 后将无法撤销。<1/>确定要分离 <0>{{name}}</0> 吗？",
            "The asset has <0>{{count}}</0> elements attached.<1/>If the asset is detached, the elements are also detached.": "该资产已连接 <0>{{count}}</0> 个元素。<1/>分离资产后，元素也会一并分离。",
            "Remove connected MediaLive input.": "移除已连接的 MediaLive 输入。",
            "<0>{{name}}</0> is in use.<1/> If you delete this template, you won’t be able to revert this.<1/> Are you sure you want to delete?": "<0>{{name}}</0> 正在使用中。<1/> 删除该模板后将无法撤销。<1/> 确定要删除吗？",
            "Empty values must be filled in when actually used.": "实际使用时，空值为必填项。",
            "If you delete <0>{{count}}</0> other than <0>{{name}}</0>, you won’t be able to revert this.<1/>Are you sure you want to delete <0>{{count}}</0> other than <0>{{name}}</0>?": "删除除 <0>{{name}}</0> 外的 <0>{{count}}</0> 项后将无法撤销。<1/>确定要删除除 <0>{{name}}</0> 外的 <0>{{count}}</0> 项吗？",
            "If you remove all shares on <0>{{name}}</0>, you won’t be able to revert this.<1/>Are you sure you want to remove all shares on <0>{{name}}</0>?": "解除 <0>{{name}}</0> 的所有共享后将无法撤销。<1/>确定要解除 <0>{{name}}</0> 的所有共享吗？",
            "If you remove all shares on <0>{{count}}</0> other than <0>{{name}}</0>, you won’t be able to revert this.<1/>Are you sure you want to remove all shares on <0>{{count}}</0> other than <0>{{name}}</0>?": "解除除 <0>{{name}}</0> 外的 <0>{{count}}</0> 项的所有共享后将无法撤销。<1/>确定要解除除 <0>{{name}}</0> 外的 <0>{{count}}</0> 项的所有共享吗？",
            "If you remove <0>{{name}}</0>, the item is deleted from the view.<1/>Other users will still have access.<1/>Are you sure you want to remove the item?": "移除 <0>{{name}}</0> 后，该项目将从列表中删除。<1/>其他用户仍可访问。<1/>确定要移除该项目吗？",
            "If you remove <0>{{count}}</0> other than <0>{{name}}</0>, the item is deleted from the view.<1/>Other users will still have access.<1/>Are you sure you want to remove the item?": "移除除 <0>{{name}}</0> 外的 <0>{{count}}</0> 项后，该项目将从列表中删除。<1/>其他用户仍可访问。<1/>确定要移除该项目吗？",
            "Share request completed": "共享请求已完成。",
            "The selected item is restored": "所选项目已恢复。",
            "Error occurs!": "发生错误。",
            "Create Completed.": "创建已完成。",
            "Overlap other processing": "与其他处理重叠。",
            "Users and teams added.": "已添加用户和团队。",
            "Please enter the subject.": "请输入标题。",
            "Lineups still exist on date": "该日期仍存在排片。",
            "Approval completed.": "批准已完成。",
            "Rejection completed.": "拒绝已完成。",
            "The Shared with list is Changed": "共享对象列表已变更。",
            "The selected item is Approved": "所选项目已批准。",
            "The selected item is Rejected": "所选项目已拒绝。",
            "The selected item is Deleted": "所选项目已删除。",
            "This page isn't working. {{line}} Please contact the manager.": "此页面无法正常运行。{{line}} 请联系管理员。",
            "Select {{resourceType}} through search to put them in your content.": "请通过搜索选择 {{resourceType}} 并将其添加到内容中。",
            "Words to display - You can enter English, numbers, spaces, and special characters (~\\!@#$%^&*()-_=+[{]}\\|;:'”,<.>/?).": "显示的词语 - 可输入英文、数字、空格和特殊字符 (~\\!@#$%^&*()-_=+[{]}\\|;:'”,<.>/?)。",
            "Words similar to spoken sounds - Only English, -(Hyphen) can be entered.": "与发音相似的词语 - 只能输入英文和 -（连字符）。",
            "Words to display - You can enter Korean, English, numbers, spaces, and special characters (~\\!@#$%^&*()-_=+[{]}\\|;:'”,<.>/?).": "显示的词语 - 可输入韩文、英文、数字、空格和特殊字符 (~\\!@#$%^&*()-_=+[{]}\\|;:'”,<.>/?)。",
            "Deletion of vocabulary phrase {{item}} has been completed.": "词语 {{item}} 已删除完成。",
            "Deletion of vocabulary phrase {{item}} and {{count}} others has been completed.": "词语 {{item}} 等 {{count}} 项已删除完成。",
            "Failed to load analysis results.": "加载分析结果失败。",
            "There are no video segments to edit for the selected labels.": "所选标签没有可编辑的片段。",
            "Imported {{segmentCount}} segments of {{labels}} selected in {{engine}} as edit segments.": "已将在<2>{{engine}}</2>中选择的<1>{{labels}}</1>的出现片段<0>{{segmentCount}}个</0>作为编辑片段导入。",
            "You can select up to {{max}} labels.": "最多可选择 {{max}} 项。",
            "All {{max}} timestamps selected. Deselect one to add another.": "已选择全部 {{max}} 个时间戳。取消选择一个才能添加。",
            "AI analysis uses the proxy video.": "AI 分析使用代理视频。",
            "Creating a proxy video. Analyzing now uses the original and takes longer.": "正在创建代理视频。此时进行分析将使用原始视频，耗时更长。",
            "The proxy video could not be created. AI analysis will use the original.": "无法创建代理视频。AI 分析将使用原始视频。",
            "The proxy video is used by AI Analysis, AI Workspace, and the Adobe plugin.": "代理视频用于 AI 分析、AI Workspace 和 Adobe 插件。",
            "Without it, AI Analysis runs on the original and can be slow or fail on size limits, and the Adobe plugin downloads the original file. This choice applies to assets created from now on.": "没有代理视频时，AI 分析将在原始视频上运行，可能变慢或因大小限制而失败，Adobe 插件也会下载原始文件。此设置对此后创建的资产生效。",
            "No proxy video. Proxy auto-generation applies only to videos registered after it was selected.": "没有代理视频。代理自动生成仅适用于启用之后注册的视频。",
            "Proxy video - a small copy used for AI analysis and preview.": "代理视频 — 用于 AI 分析和预览的轻量副本。",
            "The start date must be on or before the end date.": "开始日期必须早于或等于结束日期。",
            "Finish or cancel the field being edited before saving.": "请先完成或取消正在编辑的字段，然后再保存。",
            "This value is not one of the allowed options.": "该值不在允许的选项中。",
            "Assets closer to the top <0>match your search more accurately</0>.": "越靠上的资产与搜索词<0>匹配度越高</0>。",
            "Requests that failed. The file may have been deleted or the URL may have been unpublished.": "失败的请求数。文件可能已被删除，或 URL 已取消发布。"
        },
        "code": {
            "WORKFLOW_EMPTY_TREE_INCOMPLETE": "工作流程为空。",
            "WORKFLOW_MISSING_TRIGGER_INCOMPLETE": "需要一个 TRIGGER 步骤。",
            "WORKFLOW_MISSING_END_INCOMPLETE": "需要一个 END 步骤。",
            "WORKFLOW_MISSING_TASK_INCOMPLETE": "至少需要一个任务步骤。",
            "WORKFLOW_START_NO_NEXT_INCOMPLETE": "START 步骤必须连接到下一步。",
            "WORKFLOW_UNTERMINATED_PATH_INCOMPLETE": "每条路径都必须以 END 步骤结束。",
            "WORKFLOW_CHOICE_NO_NEXT_INCOMPLETE": "条件（CHOICE）步骤必须有下一步。",
            "WORKFLOW_BRANCH_COUNT_INCOMPLETE": "并行块需要 2 到 5 个分支，请添加更多分支。",
            "WORKFLOW_BRANCH_COUNT_FATAL": "并行块仅允许 2 到 5 个分支。",
            "WORKFLOW_SHAPE_UNKNOWN_KEY_FATAL": "该步骤包含未知属性。",
            "WORKFLOW_SHAPE_NAME_FATAL": "步骤名称无效。",
            "WORKFLOW_SHAPE_SCHEMA_FATAL": "步骤架构信息无效。",
            "WORKFLOW_SHAPE_CONDITION_FATAL": "步骤条件格式无效。",
            "WORKFLOW_SHAPE_NEXT_FATAL": "步骤的下一步连接结构无效。",
            "WORKFLOW_SHAPE_STEP_FATAL": "已连接的步骤具有无效的结构。",
            "WORKFLOW_NODE_CAP_FATAL": "工作流程超出了允许的最大步骤数。",
            "WORKFLOW_BRANCH_NODE_CAP_FATAL": "并行分支超出了允许的最大步骤数。",
            "WORKFLOW_ROOT_NOT_START_FATAL": "工作流程必须以 START 步骤开始。",
            "WORKFLOW_DUPLICATE_START_FATAL": "只能有一个 START 步骤。",
            "WORKFLOW_DUPLICATE_TRIGGER_FATAL": "只能有一个 TRIGGER 步骤。",
            "WORKFLOW_DUPLICATE_END_FATAL": "只能有一个 END 步骤。",
            "WORKFLOW_TRIGGER_NOT_AFTER_START_FATAL": "TRIGGER 步骤必须紧跟在 START 步骤之后。",
            "WORKFLOW_DUPLICATE_NAME_FATAL": "步骤名称必须唯一。",
            "WORKFLOW_MULTIPLE_PARALLEL_FATAL": "只允许一个并行块。",
            "WORKFLOW_NAME_CHARSET_FATAL": "步骤名称包含无效字符。",
            "WORKFLOW_NAME_RESERVED_PREFIX_FATAL": "步骤名称不能以保留前缀（\"__\"）开头。",
            "WORKFLOW_UNKNOWN_SCHEMA_FATAL": "步骤的架构在目录中不存在。",
            "WORKFLOW_CONDITION_SPEC_DEFERRED": "步骤的条件不满足所需规范。",
            "WORKFLOW_END_HAS_NEXT_FATAL": "END 步骤不能有下一步。",
            "WORKFLOW_START_BRANCHES_FATAL": "START 步骤不能直接连接到并行块。",
            "WORKFLOW_NEXT_IS_START_FATAL": "步骤不能转换到 START 步骤。",
            "WORKFLOW_NESTED_PARALLEL_FATAL": "不允许嵌套并行块。",
            "WORKFLOW_NOT_PARALLELIZABLE_FATAL": "此步骤不能用作并行分支。",
            "WORKFLOW_FORBIDDEN_IN_BRANCH_FATAL": "START、TRIGGER 和 END 步骤不能在并行分支内使用。",
            "WORKFLOW_INPUT_NOT_SATISFIED_DEFERRED": "步骤的输入条件不满足前面步骤的可用输出。",
            "WORKFLOW_DSL_NOT_BINDABLE_FATAL": "此字段不允许 DSL 绑定。",
            "WORKFLOW_DSL_MALFORMED_DEFERRED": "DSL 绑定格式无效。",
            "WORKFLOW_DSL_TARGET_NOT_FOUND_DEFERRED": "DSL 绑定引用了不存在的步骤或输出。",
            "WORKFLOW_DSL_OUT_OF_SCOPE_DEFERRED": "DSL 绑定引用了超出范围的步骤。",
            "OPERATION_ERROR": "存储操作失败。",
            "OPERATION_COMPLETED": "存储操作成功。",
            "OPERATION_PARTIAL_COMPLETED": "请求的操作部分成功。",
            "SUCCESS": "操作成功。",
            "S3_OPERATION_FAIL": "存储操作失败。",
            "NOT_EXIST_OBJECT_FROM_S3": "文件在存储中不存在。",
            "NOT_EXIST_OBJECT_FROM_SOURCE_DB": "索引数据库中不存在该记录。",
            "OVERLAP_OTHER_PROCESSING": "由于进程重叠，操作失败。",
            "FAIL_TO_CHANGE_STATUS": "更改文件状态时发生错误。",
            "USER_DECISION_REQUIRED": "出现重复文件，需要用户选择覆盖或跳过。",
            "UNKNOWN_ERROR": "发生了未知错误。",
            "DOWNLOAD_JOB_REJECTED_BY_SIZE": "由于文件大小，下载任务被拒绝。",
            "DOWNLOAD_JOB_REJECTED_BY_COUNT": "由于文件数量，下载任务被拒绝。",
            "DOWNLOAD_JOB_REJECTED_BY_FOLDER": "由于请求包含文件夹，下载任务被拒绝。",
            "RESOURCE_NOT_FOUND": "源文件已被删除。",
            "OPERATION_FAILED": "存储操作失败。",
            "OPERATION_ABORTED": "存储操作已中止。",
            "INTERNAL_ERROR": "发生了内部错误。",
            "CPA_INFO_PANEL_ASSETS_DESC_1": "资产是可数字化存储的任何内容文件，并包含有关文件的元数据。",
            "CPA_INFO_PANEL_ASSETS_DESC_2": "在资产页面，您可以查看已注册资产的列表，通过「添加资产」上传文件将其转化为资产，或编辑/管理/下载现有资产的信息。",
            "CPA_INFO_PANEL_ASSETS_ACTIONS_DESC": "<H4>操作</H4>\n通过将文件创建和管理为资产，您可以执行以下操作。\n<List>\n<ListItem>添加各种文件类型的图片、文档、音频文件和视频文件</ListItem>\n<ListItem>为文件添加或编辑元数据信息</ListItem>\n<ListItem>通过标签或文件夹对资产进行分组和管理</ListItem>\n<ListItem>按资产名称、ID、扩展名、文件类型、所有者、创建日期和标签进行搜索</ListItem>\n</List>",
            "CPA_INFO_PANEL_ASSETS_GRID_DESC": "<H4>网格/列表布局</H4>\n资产列表可以以网格或列表布局查看，设置为列表布局时，用户可以指定是否显示表格列。\n（名称、类型、大小、访问权限、所有者、创建时间、最后更新时间）",
            "CPA_INFO_PANEL_ASSETS_ADD_DESC": "<H4>添加资产</H4>\n您可以通过点击「添加资产」按钮，或将文件拖放到列表中，将文件转化为资产。",
            "CPA_INFO_PANEL_ASSET_DETAIL_DESC": "资产详情允许您查看资产的详细信息。",
            "CPA_INFO_PANEL_ASSET_DETAIL_OVERVIEW_DESC": "<H4>概览</H4>\n概览允许您查看资产的基本详情，修改其访问权限和文件夹位置。",
            "CPA_INFO_PANEL_ASSET_DETAIL_METADATA_DESC": "<H4>元数据</H4>\n元数据可以查看和编辑属性及标签信息。",
            "CPA_INFO_PANEL_ASSET_DETAIL_ACTION_DESC": "<H4>操作</H4>\n您可以对这些资产执行「下载/归档/删除」操作。",
            "CPA_INFO_PANEL_ASSET_DETAIL_ARCHIVE_DESC": "<H4>归档</H4>\n归档选项可由项目管理员在项目设置中进行配置，可选择并使用 S3 Glacier Flexible Retrieval / S3 Glacier Deep Archive。<NewLine/>\n归档文件费用更低，但恢复需要一定时间。",
            "CPA_INFO_PANEL_ASSET_SEARCH_DESC": "您可以在资产列表中查看搜索结果。<NewLine/>\n您可以在搜索栏中按资产名称搜索，或打开搜索选项窗口并应用详细搜索条件。",
            "CPA_INFO_PANEL_ASSET_SEARCH_OPTIONS_DESC": "<H4>搜索选项</H4>\n搜索选项包括资产名称、ID、扩展名、类型、所有者、创建时间和标签。您可以通过应用所需的详细选项对资产进行精确搜索。",
            "CPA_INFO_PANEL_ASSET_SEARCH_GO_TO_DESC": "<H4>返回列表</H4>\n要返回资产列表，只需点击「返回列表（←）」按钮。",
            "CPA_INFO_PANEL_ADD_ASSETS_DESC": "多种不同的文件类型可以转化为资产。",
            "CPA_INFO_PANEL_ADD_ASSETS_DETAILS_DESC": "<H4>资产详情</H4>\n您可以直接浏览文件或拖放以查看所选文件，并将所选文件重命名为您想要的资产名称。<NewLine/>\n此外，您还可以选择是否授予资产访问权限并创建元数据来将其注册为资产。",
            "CPA_INFO_PANEL_ADD_ASSETS_ACCESS_DESC": "<H4>访问权限</H4>\n访问权限可选择为 PUBLIC/PRIVATE。<NewLine/>\n选择 PUBLIC 则对所有人开放，选择 PRIVATE 则对所有人私密。",
            "Project:Assets:Archive": "资产归档权限。",
            "Project:Assets:Edit": "资产编辑权限。",
            "Project:Assets:Read": "资产读取权限。",
            "Project:Categories:Edit": "类别编辑权限。",
            "Project:Categories:Read": "类别读取权限。",
            "Project:Channels:Edit": "频道编辑权限。",
            "Project:Channels:Read": "频道读取权限。",
            "Project:Comments:Edit": "评论编辑权限。",
            "Project:Comments:Read": "评论读取权限。",
            "Project:CustomContents:Edit": "自定义内容编辑权限。",
            "Project:CustomContents:Read": "自定义内容读取权限。",
            "Project:Dashboard:Edit": "仪表盘编辑权限。",
            "Project:Dashboard:Read": "仪表盘读取权限。",
            "Project:Download:Download": "下载权限。",
            "Project:Folders:Edit": "文件夹编辑权限。",
            "Project:Folders:Read": "文件夹读取权限。",
            "Project:IntegratedSearch:Read": "集成搜索读取权限。",
            "Project:InteractiveVideos:Edit": "互动视频编辑权限。",
            "Project:InteractiveVideos:Read": "互动视频读取权限。",
            "Project:Music:Edit": "音乐编辑权限。",
            "Project:Music:Read": "音乐读取权限。",
            "Project:People:Edit": "人物编辑权限。",
            "Project:People:Read": "人物读取权限。",
            "Project:Photo:Edit": "照片编辑权限。",
            "Project:Photo:Read": "照片读取权限。",
            "Project:Shares:External": "外部共享权限。",
            "Project:Shares:Internal": "内部共享权限。",
            "Project:Statistics:Edit": "统计编辑权限。",
            "Project:Statistics:Read": "统计读取权限。",
            "Project:Storages:Edit": "存储编辑权限。",
            "Project:Storages:Read": "存储读取权限。",
            "Project:Users&Groups:Read": "用户和群组读取权限。",
            "Project:Videos:Edit": "视频编辑权限。",
            "Project:Videos:Publish": "视频发布权限。",
            "Project:Videos:Read": "视频读取权限。",
            "Project:Shares:InternalRequest": "内部请求权限。"
        },
        "audit": {
            "Retrieve list of Actions": "获取操作列表",
            "Retrieve list of AI Face collections": "获取 AI 人脸集合列表",
            "Delete AI Face collection": "删除 AI 人脸集合",
            "Update AI Face collection": "更新 AI 人脸集合",
            "Retrieve list of archived assets": "获取已归档资产列表",
            "Retrieve archived asset details": "获取已归档资产详情",
            "Restore archived asset": "恢复已归档资产",
            "Retrieve list of assets": "获取资产列表",
            "Create asset": "创建资产",
            "Retrieve asset details": "获取资产详情",
            "Update asset": "更新资产",
            "Delete asset": "删除资产",
            "Activate asset": "激活资产",
            "Archive asset": "归档资产",
            "Create file in asset": "在资产中创建文件",
            "Add files to asset": "向资产添加文件",
            "Delete file from asset": "从资产中删除文件",
            "Update file in asset": "更新资产中的文件",
            "Update tags of asset": "更新资产的标签",
            "Delete tag from asset": "从资产中删除标签",
            "Inactivate asset": "停用资产",
            "Attach People to asset": "将人物附加到资产",
            "Detach People from asset": "从资产中分离人物",
            "Retrieve asset status": "获取资产状态",
            "Retrieve upload URL for asset": "获取资产的上传 URL",
            "Retrieve list of audit logs": "获取审计日志列表",
            "Retrieve audit log details": "获取审计日志详情",
            "Send HEAD request to storage file": "向存储文件发送 HEAD 请求",
            "Retrieve list of category groups": "获取类别群组列表",
            "Retrieve category group details": "获取类别群组详情",
            "Update category group": "更新类别群组",
            "Delete category group": "删除类别群组",
            "Retrieve list of categories": "获取类别列表",
            "Create category": "创建类别",
            "Delete categories in bulk": "批量删除类别",
            "Retrieve category details": "获取类别详情",
            "Update category": "更新类别",
            "Delete category": "删除类别",
            "Retrieve list of CDNs": "获取CDN列表",
            "Create CDN": "创建CDN",
            "Retrieve CDN details": "获取CDN详情",
            "Update CDN": "更新CDN",
            "Delete CDN": "删除CDN",
            "Retrieve list of channels": "获取频道列表",
            "Create channel": "创建频道",
            "Retrieve channel details": "获取频道详情",
            "Update channel": "更新频道",
            "Delete channel": "删除频道",
            "Update channel case": "更新频道案例",
            "Retrieve list of channel inputs": "获取频道输入列表",
            "Retrieve channel input details": "获取频道输入详情",
            "Retrieve channel encoder details": "获取频道编码器详情",
            "Reclaim channel": "回收频道",
            "Request channel approval": "申请频道审批",
            "Retrieve list of channel schedules": "获取频道排期列表",
            "Update channel schedules in bulk": "批量更新频道排期",
            "Delete channel schedules in bulk": "批量删除频道排期",
            "Delete channel schedule": "删除频道排期",
            "Retrieve channel schedule details": "获取频道排期详情",
            "Update channel schedule": "更新频道排期",
            "Start channel": "启动频道",
            "Retrieve channel state": "获取频道状态",
            "Stop channel": "停止频道",
            "Request DRM token for video": "请求视频DRM令牌",
            "Retrieve Presigned URL of Master file for container format video": "获取容器格式视频主文件的预签名URL",
            "Retrieve Presigned URL of Daughter file for container format video": "获取容器格式视频子文件的预签名URL",
            "Retrieve list of transcode jobs": "获取转码任务列表",
            "Create transcode job": "创建转码任务",
            "Create and start transcode job": "创建并启动转码任务",
            "Retrieve upload URL for transcode job": "获取转码任务的上传URL",
            "Retrieve transcode job details": "获取转码任务详情",
            "Update transcode job": "更新转码任务",
            "Delete transcode job": "删除转码任务",
            "Cancel transcode job": "取消转码任务",
            "Retrieve transcode job status": "获取转码任务状态",
            "Correct transcode job status": "修正转码任务状态",
            "Start transcode job": "启动转码任务",
            "Retrieve list of listings": "获取节目单列表",
            "Create listing": "创建节目单",
            "Retrieve listing details": "获取节目单详情",
            "Update listing": "更新节目单",
            "Delete listing": "删除节目单",
            "Retrieve list of lineups": "获取节目行列表",
            "Create lineup": "创建节目行",
            "Delete lineups in bulk": "批量删除节目行",
            "Create lineups in bulk": "批量创建节目行",
            "Retrieve lineup details": "获取节目行详情",
            "Update lineup": "更新节目行",
            "Delete lineup": "删除节目行",
            "Retrieve list of scheduled lineups after current time": "获取当前时间之后的排期节目行列表",
            "Retrieve list of localization resources": "获取本地化资源列表",
            "Retrieve localization resource details": "获取本地化资源详情",
            "Retrieve current user information": "获取当前用户信息",
            "Retrieve list of Actions allowed for current user in project": "获取当前用户在项目中可执行的操作列表",
            "Retrieve list of Actions allowed for current user in space": "获取当前用户在空间中可执行的操作列表",
            "Request PoPs user synchronization": "申请PoPs用户同步",
            "Retrieve list of metadata fields": "获取元数据字段列表",
            "Create metadata field": "创建元数据字段",
            "Retrieve metadata field details": "获取元数据字段详情",
            "Update metadata field": "更新元数据字段",
            "Delete metadata field": "删除元数据字段",
            "Retrieve list of metadata schemas": "获取元数据架构列表",
            "Create metadata schema": "创建元数据架构",
            "Register metadata schema": "注册元数据架构",
            "Retrieve metadata schema details": "获取元数据架构详情",
            "Update metadata schema": "更新元数据架构",
            "Delete metadata schema": "删除元数据架构",
            "Retrieve list of People": "获取人员列表",
            "Create People": "创建人员",
            "Update People": "更新人员",
            "Delete People": "删除人员",
            "Retrieve People details": "获取人员详情",
            "Retrieve list of transcode pipelines": "获取转码流水线列表",
            "Retrieve transcode pipeline details": "获取转码流水线详情",
            "Retrieve embed URL": "获取嵌入URL",
            "Retrieve shared URL": "获取共享URL",
            "Retrieve list of SNS accounts": "获取SNS账户列表",
            "Create SNS account": "创建SNS账户",
            "Retrieve SNS account details": "获取SNS账户详情",
            "Delete SNS account": "删除SNS账户",
            "Update SNS account": "更新SNS账户",
            "Retrieve SNS posting history": "获取SNS发布历史",
            "Retrieve list of videos posted to SNS": "获取已发布到SNS的视频列表",
            "Post video to SNS": "将视频发布到SNS",
            "Retrieve SNS video details": "获取SNS视频详情",
            "Retrieve transcode profile details": "获取转码配置文件详情",
            "Retrieve list of programmes": "获取节目列表",
            "Create programme": "创建节目",
            "Retrieve programme details": "获取节目详情",
            "Update programme": "更新节目",
            "Delete programme": "删除节目",
            "Retrieve list of projects": "获取项目列表",
            "Create project": "创建项目",
            "Delete project": "删除项目",
            "Retrieve project details": "获取项目详情",
            "Update project": "更新项目",
            "Retrieve list of assignable members to project": "获取项目可分配成员列表",
            "Retrieve list of assignable teams to project": "获取项目可分配团队列表",
            "Retrieve list of assigned project members": "获取已分配项目成员列表",
            "Retrieve list of assigned project teams": "获取已分配项目团队列表",
            "Retrieve list of project members": "获取项目成员列表",
            "Assign member to project": "将成员分配至项目",
            "Unassign member from project": "从项目中取消分配成员",
            "Add storages to project": "将存储添加至项目",
            "Update project storages": "更新项目存储",
            "Retrieve list of project teams": "获取项目团队列表",
            "Assign team to project": "将团队分配至项目",
            "Unassign team from project": "从项目中取消分配团队",
            "Create player": "创建播放器",
            "Retrieve list of players": "获取播放器列表",
            "Create player profile": "创建播放器配置文件",
            "Retrieve list of player profiles": "获取播放器配置文件列表",
            "Retrieve player profile details": "获取播放器配置文件详情",
            "Update player profile": "更新播放器配置文件",
            "Delete player profile": "删除播放器配置文件",
            "Retrieve player details": "获取播放器详情",
            "Update player": "更新播放器",
            "Delete player": "删除播放器",
            "Create player resource": "创建播放器资源",
            "Retrieve list of player resources": "获取播放器资源列表",
            "Retrieve player resource details": "获取播放器资源详情",
            "Update player resource": "更新播放器资源",
            "Delete player resource": "删除播放器资源",
            "Retrieve upload URL for resource": "获取资源的上传URL",
            "Create role": "创建角色",
            "Retrieve list of roles": "获取角色列表",
            "Retrieve role details": "获取角色详情",
            "Update role": "更新角色",
            "Delete role": "删除角色",
            "Attach permissions to role": "为角色附加权限",
            "Retrieve list of permissions in role": "获取角色中的权限列表",
            "Detach permission from role": "从角色中移除权限",
            "Retrieve list of settings": "获取设置列表",
            "Create project settings": "创建项目设置",
            "Delete project settings": "删除项目设置",
            "Create space settings": "创建空间设置",
            "Delete space settings": "删除空间设置",
            "Create statistics": "创建统计数据",
            "Retrieve list of statistics widget groups": "获取统计小部件群组列表",
            "Create statistics widget group": "创建统计小部件群组",
            "Delete statistics widget group": "删除统计小部件群组",
            "Retrieve list of widgets in specific statistics widget group": "获取特定统计小部件群组中的小部件列表",
            "Update statistics widgets": "更新统计小部件",
            "Retrieve list of statistics widgets": "获取统计小部件列表",
            "Create statistics Aggregation": "创建统计聚合",
            "Create statistics Feature": "创建统计功能",
            "Create statistics Resource": "创建统计资源",
            "Retrieve list of stream inputs": "获取流输入列表",
            "Create stream input": "创建流输入",
            "Retrieve list of whitelists": "获取白名单列表",
            "Retrieve stream input details": "获取流输入详情",
            "Update stream input": "更新流输入",
            "Delete stream input": "删除流输入",
            "Retrieve list of teams": "获取团队列表",
            "Retrieve team details": "获取团队详情",
            "Retrieve list of team members": "获取团队成员列表",
            "Retrieve list of event triggers": "获取事件触发器列表",
            "Create event trigger": "创建事件触发器",
            "Retrieve event trigger details": "获取事件触发器详情",
            "Delete event trigger": "删除事件触发器",
            "Update event trigger": "更新事件触发器",
            "Retrieve upload URL for event trigger": "获取事件触发器的上传URL",
            "Retrieve list of users": "获取用户列表",
            "Retrieve user details": "获取用户详情",
            "Update user": "更新用户",
            "Delete user": "删除用户",
            "Retrieve list of videos": "获取视频列表",
            "Create video": "创建视频",
            "Retrieve video details": "获取视频详情",
            "Update video": "更新视频",
            "Delete video": "删除视频",
            "Activate video": "激活视频",
            "Request caption creation via video": "通过视频申请字幕创建",
            "Delete caption from video": "从视频中删除字幕",
            "Update caption in video": "更新视频中的字幕",
            "Inactivate video": "停用视频",
            "Attach People to video": "将人员关联至视频",
            "Detach People from video": "从视频中解除人员关联",
            "Create posters for video in bulk": "批量为视频创建海报",
            "Delete poster from video": "从视频中删除海报",
            "Create SNS posting for video": "为视频创建SNS发布",
            "Retrieve video status": "获取视频状态",
            "Retrieve Thumbnail profiles for video": "获取视频的缩略图配置文件",
            "Create category group": "创建类别群组",
            "Retrieve list of Resource Buckets": "获取资源存储桶列表",
            "Create Resource Buckets in bulk": "批量创建资源存储桶",
            "Retrieve list of files in asset": "获取资产中的文件列表",
            "Retrieve list of Searchable Buckets": "获取可搜索存储桶列表",
            "Create Searchable Bucket": "创建可搜索存储桶",
            "Delete Searchable Bucket": "删除可搜索存储桶",
            "Retrieve Searchable Bucket details": "获取可搜索存储桶详情",
            "Update Searchable Bucket": "更新可搜索存储桶",
            "Register Searchable Bucket": "注册可搜索存储桶",
            "Delete schedule": "删除排期",
            "Retrieve list of asset types": "获取资产类型列表",
            "Create asset type": "创建资产类型",
            "Retrieve list of asset extensions": "获取资产扩展列表",
            "Create asset extension": "创建资产扩展",
            "Retrieve schedule details": "获取排期详情",
            "Retrieve list of schedules": "获取排期列表",
            "Delete schedules in bulk": "批量删除排期",
            "Update schedule": "更新排期",
            "Create schedules in bulk": "批量创建排期",
            "Start schedule": "启动排期",
            "Stop schedule": "停止排期",
            "Lock schedule": "锁定排期",
            "End schedule": "结束排期",
            "Request asset download": "申请资产下载",
            "Retrieve asset download details": "获取资产下载详情",
            "Retrieve schedule history details": "获取排期历史详情",
            "Retrieve list of schedule histories": "获取排期历史列表",
            "Retrieve hidden metadata field value": "获取隐藏元数据字段值",
            "Retrieve list of shared configurations for video": "获取视频的共享配置列表",
            "Create shared configuration for video": "创建视频的共享配置",
            "Retrieve shared configuration details for video": "获取视频的共享配置详情",
            "Update shared configuration for video": "更新视频的共享配置",
            "Delete shared configuration from video": "从视频中删除共享配置",
            "Retrieve list of content schemas": "获取内容架构列表",
            "Attach teaser images to video in bulk": "批量为视频附加预告图片",
            "Detach teaser image from video": "从视频中分离预告图片",
            "Attach teaser videos to video in bulk": "批量为视频附加预告视频",
            "Detach teaser video from video": "从视频中分离预告视频",
            "Retrieve list of music": "获取音乐列表",
            "Retrieve music details": "获取音乐详情",
            "Update music": "更新音乐",
            "Delete music": "删除音乐",
            "Create music": "创建音乐",
            "Add file to music": "向音乐添加文件",
            "Update file in music": "更新音乐中的文件",
            "Delete file from music": "从音乐中删除文件",
            "Retrieve list of photos": "获取照片列表",
            "Retrieve photo details": "获取照片详情",
            "Update photo": "更新照片",
            "Delete photo": "删除照片",
            "Create photo": "创建照片",
            "Add file to photo": "向照片添加文件",
            "Update file in photo": "更新照片中的文件",
            "Delete file from photo": "从照片中删除文件",
            "Retrieve asset file download link": "获取资产文件下载链接",
            "Retrieve download information": "获取下载信息",
            "Search": "搜索",
            "Retrieve list of attributions": "获取署名列表",
            "Create attribution": "创建署名",
            "Retrieve attribution details": "获取署名详情",
            "Update attribution": "更新署名",
            "Delete attribution": "删除归因",
            "Retrieve list of asset files": "获取资产文件列表",
            "Retrieve list of file versions in asset": "获取资产中文件版本列表",
            "Attach categories to asset in bulk": "批量将类别附加到资产",
            "Detach categories from asset in bulk": "批量从资产中分离类别",
            "Retrieve list of attribution keys": "获取归因键列表",
            "Update owner of asset": "更新资产所有者",
            "Retrieve dashboard data": "获取仪表板数据",
            "Retrieve list of Actions for role": "获取角色的操作列表",
            "Retrieve list of file meta keys": "获取文件元数据键列表",
            "Update project member": "更新项目成员",
            "Update project team": "更新项目团队",
            "Retrieve list of related contents in asset": "获取资产中相关内容列表",
            "Retrieve list of asynchronous Jobs": "获取异步作业列表",
            "Create asynchronous Job": "创建异步作业",
            "Update asynchronous Job": "更新异步作业",
            "Create asynchronous Job Action": "创建异步作业操作",
            "Retrieve list of Tasks in asynchronous Job": "获取异步作业中的任务列表",
            "Create Task in asynchronous Job": "在异步作业中创建任务",
            "Update Task in asynchronous Job": "更新异步作业中的任务",
            "Request action on specific storage": "对特定存储请求操作",
            "Retrieve asynchronous Job details": "获取异步作业详情",
            "Retrieve asynchronous Job Alias": "获取异步作业别名",
            "Create Alias for asynchronous Job": "为异步作业创建别名",
            "Retrieve list of asynchronous Job Types": "获取异步作业类型列表",
            "Create asynchronous Job Type": "创建异步作业类型",
            "Retrieve asynchronous Job Type details": "获取异步作业类型详情",
            "Update asynchronous Job Type": "更新异步作业类型",
            "Delete asynchronous Job Type": "删除异步作业类型",
            "Retrieve list of Actions in asynchronous Job Type": "获取异步作业类型中的操作列表",
            "Create Action in asynchronous Job Type": "在异步作业类型中创建操作",
            "Update Action in asynchronous Job Type": "更新异步作业类型中的操作",
            "Delete Action in asynchronous Job Type": "删除异步作业类型中的操作",
            "Update music in bulk": "批量更新音乐",
            "Update photos in bulk": "批量更新照片",
            "Retrieve list of hidden metadata": "获取隐藏元数据列表",
            "Update People in bulk": "批量更新人物",
            "Retrieve list of item sets for metadata": "获取元数据的项目集列表",
            "Create item set for metadata": "为元数据创建项目集",
            "Update item set for metadata": "更新元数据的项目集",
            "Delete item set for metadata": "删除元数据的项目集",
            "Retrieve list of elements in item set": "获取项目集中的元素列表",
            "Update videos in bulk": "批量更新视频",
            "Start asynchronous Job": "启动异步作业",
            "Complete asynchronous Job": "完成异步作业",
            "Start Task in asynchronous Job": "启动异步作业中的任务",
            "Complete Task in asynchronous Job": "完成异步作业中的任务",
            "Create asynchronous Job Alias": "创建异步作业别名",
            "Retrieve asynchronous Job Alias details": "获取异步作业别名详情",
            "Request fms action on specific storage": "对特定存储请求 fms 操作",
            "Retrieve list of Searchable Buckets by admin": "由管理员获取可搜索存储桶列表",
            "Retrieve list of download jobs": "获取下载作业列表",
            "Request download": "请求下载",
            "Retrieve download job details": "获取下载作业详情",
            "Retrieve list of download job tasks": "获取下载作业任务列表",
            "Retrieve download job task details": "获取下载作业任务详情",
            "Retrieve download link": "获取下载链接",
            "Retrieve list of Batch Jobs": "获取批量作业列表",
            "Create Batch Job": "创建批量作业",
            "Retrieve Batch Job details": "获取批量作业详情",
            "Retrieve list of Batch Job Tasks": "获取批量作业任务列表",
            "Retrieve Batch Job Task details": "获取批量作业任务详情",
            "Retrieve Presigned URL for S3 file": "获取 S3 文件的预签名 URL",
            "Initiate multipart upload session for S3 file": "初始化 S3 文件的分片上传会话",
            "Complete multipart upload for S3 file": "完成 S3 文件的分片上传",
            "Abort multipart upload for S3 file": "中止 S3 文件的分片上传",
            "Retrieve Presigned URL for part upload in S3 file": "获取 S3 文件分片上传的预签名 URL",
            "Retrieve Presigned URL for upload in S3 file": "获取 S3 文件上传的预签名 URL",
            "Retrieve integrated search list": "获取集成搜索列表",
            "Retrieve list of Resource Buckets assigned to me": "获取分配给我的资源存储桶列表",
            "Retrieve Task details in asynchronous Job": "获取异步作业中的任务详情",
            "Retrieve list of integrated search domains": "获取集成搜索域列表",
            "Create integrated search domain": "创建集成搜索域",
            "Retrieve integrated search domain details": "获取集成搜索域详情",
            "Delete integrated search domain": "删除集成搜索域",
            "Retrieve list of shared links": "获取共享链接列表",
            "Share link": "共享链接",
            "Retrieve shared link details": "获取共享链接详情",
            "Delete shared link": "删除共享链接",
            "Retrieve list of AWS S3 buckets": "获取 AWS S3 存储桶列表",
            "Retrieve list of internal shares": "获取内部共享列表",
            "Create internal share": "创建内部共享",
            "Retrieve internal share details": "获取内部共享详情",
            "Update internal share": "更新内部共享",
            "Update requester action in internal share": "更新内部共享中的请求者操作",
            "Update approver action in internal share": "更新内部共享中的审批者操作",
            "Retrieve list of approver candidates for internal share": "获取内部共享的审批者候选人列表",
            "Retrieve list of shared resources": "获取共享资源列表",
            "Share resource": "共享资源",
            "Retrieve shared resource details": "获取共享资源详情",
            "Delete shared resource": "删除共享资源",
            "Retrieve list of grantees for shared resource": "获取共享资源的被授权人列表",
            "Add grantee to shared resource": "向共享资源添加被授权人",
            "Retrieve grantee details for shared resource": "获取共享资源的被授权人详情",
            "Update grantee for shared resource": "更新共享资源的被授权人",
            "Remove grantee from shared resource": "从共享资源中移除被授权人",
            "Check share permission": "检查共享权限",
            "Retrieve list of resources shared with me": "获取与我共享的资源列表",
            "Retrieve details of resource shared with me": "获取与我共享的资源详情",
            "Delete resource shared with me": "删除与我共享的资源",
            "Retrieve list of drives": "获取驱动器列表",
            "Retrieve drive details": "获取驱动器详情",
            "Update drive": "更新驱动器",
            "Retrieve list of folders": "获取文件夹列表",
            "Create folder": "创建文件夹",
            "Retrieve folder details": "获取文件夹详情",
            "Update folder": "更新文件夹",
            "Delete folder": "删除文件夹",
            "Move folder": "移动文件夹",
            "Retrieve list of metadata templates": "获取元数据模板列表",
            "Create metadata template": "创建元数据模板",
            "Retrieve metadata template details": "获取元数据模板详情",
            "Update metadata template": "更新元数据模板",
            "Delete metadata template": "删除元数据模板",
            "Register metadata template": "注册元数据模板",
            "Retrieve list of dashboard widgets": "获取仪表板小组件列表",
            "Create dashboard widget": "创建仪表板小组件",
            "Retrieve dashboard widget details": "获取仪表板小组件详情",
            "Update dashboard widget": "更新仪表板小组件",
            "Delete dashboard widget": "删除仪表板小组件",
            "Retrieve list of dashboard widget data": "获取仪表板小组件数据列表",
            "Retrieve list of storage folders": "获取存储文件夹列表",
            "Retrieve list of storage files": "获取存储文件列表",
            "Move asset": "移动资产",
            "Request storage action": "请求存储操作",
            "Lock Searchable Bucket": "锁定可搜索存储桶",
            "Unlock Searchable Bucket": "解锁可搜索存储桶",
            "Retrieve list of multipart upload jobs": "获取分片上传作业列表",
            "Retrieve list of parts in multipart upload job": "获取分片上传作业中的分片列表",
            "Retrieve list of collections": "获取集合列表",
            "Create collection": "创建集合",
            "Retrieve collection details": "获取集合详情",
            "Update collection": "更新集合",
            "Delete collection": "删除集合",
            "Retrieve list of items in collection": "获取集合中的项目列表",
            "Update collection tags": "更新集合标签",
            "Retrieve list of linked collections": "获取关联集合列表",
            "Request collection action": "请求集合操作",
            "Retrieve list of content field types": "获取内容字段类型列表",
            "Create content field type": "创建内容字段类型",
            "Retrieve content field type details": "获取内容字段类型详情",
            "Update content field type": "更新内容字段类型",
            "Delete content field type": "删除内容字段类型",
            "Create content schema": "创建内容架构",
            "Request content schema field action": "请求内容架构字段操作",
            "Retrieve content schema details": "获取内容架构详情",
            "Update content schema": "更新内容架构",
            "Delete content schema": "删除内容架构",
            "Request content schema action": "请求内容架构操作",
            "Retrieve list of projects assigned to content schema": "获取分配到内容架构的项目列表",
            "Retrieve list of custom contents": "获取自定义内容列表",
            "Create custom content": "创建自定义内容",
            "Retrieve custom content details": "获取自定义内容详情",
            "Update custom content": "更新自定义内容",
            "Delete custom content": "删除自定义内容",
            "Request custom content action": "请求自定义内容操作",
            "Retrieve custom content field details": "获取自定义内容字段详情",
            "Request custom content action in bulk": "批量请求自定义内容操作",
            "Retrieve list of AI caption jobs": "获取 AI 字幕作业列表",
            "Create AI caption job": "创建 AI 字幕作业",
            "Retrieve AI caption job details": "获取 AI 字幕作业详情",
            "Retrieve list of AI analysis jobs": "获取 AI 分析作业列表",
            "Create AI analysis job": "创建 AI 分析作业",
            "Retrieve AI analysis job details": "获取 AI 分析作业详情",
            "Delete AI analysis job": "删除 AI 分析作业",
            "Retrieve list of AI analysis job summaries": "获取 AI 分析作业摘要列表",
            "Retrieve list of AI analysis job results": "获取 AI 分析作业结果列表",
            "Retrieve list of AI analysis job original results": "获取 AI 分析作业原始结果列表",
            "Retrieve AI analysis job original result details": "获取 AI 分析作业原始结果详情",
            "Callback for AI analysis job engine": "AI 分析作业引擎回调",
            "Retrieve list of dictation vocabularies": "获取听写词汇列表",
            "Create dictation vocabulary": "创建听写词汇",
            "Retrieve dictation vocabulary details": "获取听写词汇详情",
            "Delete dictation vocabulary": "删除听写词汇",
            "Update dictation vocabulary": "更新听写词汇",
            "Retrieve list of phrases in vocabulary": "获取词汇中的短语列表",
            "Request vocabulary phrase action": "请求词汇短语操作",
            "Retrieve list of notifications": "获取通知列表",
            "Create notification": "创建通知",
            "Retrieve notification details": "获取通知详情",
            "Update notification": "更新通知",
            "Delete notification": "删除通知",
            "Retrieve list of notification subscriptions": "获取通知订阅列表",
            "Subscribe to notification": "订阅通知",
            "Retrieve notification subscription details": "获取通知订阅详情",
            "Unsubscribe from notification": "取消订阅通知",
            "Retrieve list of notification conditions": "获取通知条件列表",
            "Update notification conditions": "更新通知条件",
            "Retrieve list of domain events": "获取域事件列表",
            "Retrieve download links for AI analysis job": "获取 AI 分析作业的下载链接",
            "Retrieve list of asset versions": "获取资产版本列表",
            "Create asset version": "创建资产版本",
            "Retrieve asset version details": "获取资产版本详情",
            "Delete asset version": "删除资产版本",
            "Retrieve list of comment threads": "获取评论话题列表",
            "Create comment thread": "创建评论话题",
            "Retrieve list of comments in thread": "获取话题中的评论列表",
            "Create comment": "创建评论",
            "Update comment": "更新评论",
            "Delete comment": "删除评论",
            "Request comment action": "请求评论操作",
            "Delete comment thread": "删除评论话题",
            "Retrieve comment details": "获取评论详情",
            "Update comment thread": "更新评论话题",
            "Retrieve list of comments": "获取评论列表",
            "Retrieve list of Action Groups": "获取操作组列表",
            "Retrieve Action Group details": "获取操作组详情",
            "Retrieve list of my space permissions": "获取我的空间权限列表",
            "Retrieve list of my project permissions": "获取我的项目权限列表",
            "Request role action": "请求角色操作",
            "Retrieve list of entities by role": "获取角色对应的实体列表",
            "Assign role to entity": "为实体分配角色",
            "Remove role from entity": "从实体中移除角色",
            "Create user": "创建用户",
            "Create team": "创建团队",
            "Update team": "更新团队",
            "Delete team": "删除团队",
            "Assign member to team": "将成员分配到团队",
            "Retrieve team member details": "获取团队成员详情",
            "Remove member from team": "从团队中移除成员",
            "Assign project member": "分配项目成员",
            "Retrieve project member details": "获取项目成员详情",
            "Remove project member": "移除项目成员",
            "Assign project team": "分配项目团队",
            "Retrieve project team details": "获取项目团队详情",
            "Remove project team": "移除项目团队",
            "Retrieve list of project team members": "获取项目团队成员列表",
            "Retrieve project team member details": "获取项目团队成员详情",
            "Retrieve list of Resource Types": "获取资源类型列表",
            "Copy asset": "复制资产",
            "Retrieve list of collections by asset": "获取资产的集合列表",
            "Delete users in bulk": "批量删除用户",
            "Request team action": "请求团队操作",
            "Delete teams in bulk": "批量删除团队",
            "Remove project members in bulk": "批量移除项目成员",
            "Remove project teams in bulk": "批量移除项目团队",
            "Retrieve list of linked assets": "获取关联资产列表",
            "Add linked asset": "添加关联资产",
            "Remove linked asset": "移除关联资产",
            "Create comment attachment": "创建评论附件",
            "Delete comment attachment": "删除评论附件",
            "Request user action": "请求用户操作",
            "Retrieve list of project admins": "获取项目管理员列表",
            "Request project action": "请求项目操作",
            "Retrieve list of project member's teams": "获取项目成员的团队列表",
            "Retrieve list of project member's roles": "获取项目成员的角色列表",
            "Retrieve list of project team's roles": "获取项目团队的角色列表",
            "Retrieve comment thread details": "获取评论话题详情",
            "Retrieve list of thread entities": "获取话题实体列表",
            "Create thread entity": "创建话题实体",
            "Retrieve list of pending users for space invitation": "获取空间邀请待处理用户列表",
            "Request space user invitation": "请求空间用户邀请",
            "Retrieve list of pending users for project invitation": "获取项目邀请待处理用户列表",
            "Request project user invitation": "请求项目用户邀请",
            "Retrieve list of assignable members to team": "获取可分配至团队的成员列表",
            "Create exported metadata job": "创建元数据导出任务",
            "Retrieve list of exported metadata jobs": "获取元数据导出任务列表",
            "Retrieve exported metadata job details": "获取元数据导出任务详情",
            "Update exported metadata job": "更新元数据导出任务",
            "Delete exported metadata job": "删除元数据导出任务",
            "Retrieve upload Presigned URL for preview resource": "获取预览资源的上传预签名 URL",
            "Request preview resource action": "请求预览资源操作",
            "Retrieve list of audit log search keys": "获取审计日志搜索键列表",
            "Retrieve embed URL for posting": "获取发布用的嵌入 URL",
            "Request role management action": "请求角色管理操作",
            "Retrieve list of report settings": "获取报告设置列表",
            "Retrieve report setting details": "获取报告设置详情",
            "Update report setting": "更新报告设置",
            "Retrieve list of reports": "获取报告列表",
            "Retrieve report details": "获取报告详情",
            "Retrieve list of report subscribers": "获取报告订阅者列表",
            "Capture asset frame": "捕获资产帧",
            "Retrieve list of links": "获取链接列表",
            "Create link": "创建链接",
            "Update link": "更新链接",
            "Delete link": "删除链接",
            "Create drive": "创建驱动器",
            "Delete drive": "删除驱动器",
            "Validate share grantee": "验证共享被授权人",
            "Apply asset owner lock": "应用资产所有者锁定",
            "Release asset owner lock": "解除资产所有者锁定",
            "Create video clip from asset": "从资产创建视频片段",
            "Retrieve list of favorite resources": "获取收藏资源列表",
            "Create favorite resource": "创建收藏资源",
            "Delete favorite resource": "删除收藏资源",
            "Retrieve list of custom menu sets": "获取自定义菜单集列表",
            "Create custom menu set": "创建自定义菜单集",
            "Retrieve custom menu set details": "获取自定义菜单集详情",
            "Update custom menu set": "更新自定义菜单集",
            "Delete custom menu set": "删除自定义菜单集",
            "Request custom menu set action": "请求自定义菜单集操作",
            "Retrieve list of custom menus": "获取自定义菜单列表",
            "Create custom menu": "创建自定义菜单",
            "Retrieve custom menu details": "获取自定义菜单详情",
            "Update custom menu": "更新自定义菜单",
            "Delete custom menu": "删除自定义菜单",
            "Retrieve list of asset histories": "获取资产历史记录列表",
            "Retrieve asset history details": "获取资产历史记录详情",
            "Retrieve integrated search detailed list": "获取综合搜索详细列表",
            "Retrieve list of my requests": "获取我的请求列表",
            "Retrieve my request details": "获取我的请求详情",
            "Update my request": "更新我的请求",
            "Delete my request": "删除我的请求",
            "Create request": "创建请求",
            "Retrieve list of requests": "获取请求列表",
            "Retrieve request details": "获取请求详情",
            "Update request": "更新请求",
            "Delete request": "删除请求",
            "Update request status": "更新请求状态",
            "Create attachment in my request": "在我的请求中创建附件",
            "Delete attachment from my request": "从我的请求中删除附件",
            "Create attachment in request": "在请求中创建附件",
            "Delete attachment from request": "从请求中删除附件",
            "Retrieve list of request categories": "获取请求类别列表",
            "Retrieve list of assets shared with me": "获取与我共享的资产列表",
            "Share asset": "共享资产",
            "Retrieve list of shared assets": "获取已共享资产列表",
            "Unshare asset": "取消共享资产",
            "Assign request assignee": "分配请求负责人",
            "Retrieve custom metadata details of asset": "获取资产的自定义元数据详情",
            "Retrieve list of projects for asset shared with me": "获取与我共享的资产所属项目列表",
            "Retrieve list of user agreements": "获取用户协议列表",
            "Retrieve user agreement details": "获取用户协议详情",
            "Update user agreement consent": "更新用户协议同意状态",
            "Create favorite resources in bulk": "批量创建收藏资源",
            "Delete favorite resources in bulk": "批量删除收藏资源",
            "Retrieve list of supported regions by provider": "获取提供商支持的地区列表",
            "Update asset share": "更新资产共享",
            "Retrieve list of assets I shared": "获取我共享的资产列表",
            "Retrieve list of projects for asset shared by me": "获取我共享的资产所属项目列表",
            "Retrieve list of asset owners": "获取资产所有者列表",
            "Retrieve list of usage metric tenants": "获取使用量指标租户列表",
            "Retrieve list of usage metrics": "获取使用量指标列表",
            "Retrieve list of usage metric data": "获取使用量指标数据列表",
            "Retrieve assignable storages": "获取可分配的存储列表",
            "Retrieve assigned storages": "获取已分配的存储列表",
            "Manage project storages": "管理项目存储",
            "Update owners of assets in bulk": "批量更新资产所有者",
            "Callback for Gen AI service": "Gen AI 服务回调",
            "Create AI job in request": "在请求中创建 AI 任务",
            "AI Source Synchronization": "AI 来源同步",
            "Delete Gen AI Source": "删除 Gen AI 来源",
            "Create prompt preset": "创建提示预设",
            "Update prompt preset": "更新提示预设",
            "Delete prompt preset": "删除提示预设",
            "Update prompt preset status": "更新提示预设状态"
        }
    }
}
